import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Map: { input: any; output: any; }
  Time: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  channel: ChannelTypeNew;
  hasCategory: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  isAvailableApi?: Maybe<Scalars['Boolean']['output']>;
  isImageExists: Scalars['Boolean']['output'];
  isMergeTikTok: Scalars['Boolean']['output'];
  isStore: Scalars['Boolean']['output'];
  isSyncAvailable: Scalars['Boolean']['output'];
  isSyncFileNeeded: Scalars['Boolean']['output'];
  isSyncItem: Scalars['Boolean']['output'];
  isSyncing: Scalars['Boolean']['output'];
  lastSyncedAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AccountInfo = {
  __typename?: 'AccountInfo';
  isImageExists: Scalars['Boolean']['output'];
  isStore: Scalars['Boolean']['output'];
  isSyncAvailable: Scalars['Boolean']['output'];
  isSyncFileNeeded: Scalars['Boolean']['output'];
  isSyncItem: Scalars['Boolean']['output'];
  isSyncing: Scalars['Boolean']['output'];
  lastSyncedAt: Scalars['String']['output'];
};

export type AccountRuby = {
  __typename?: 'AccountRuby';
  accurate?: Maybe<Accurate>;
  address?: Maybe<Address>;
  chanelImage?: Maybe<Scalars['String']['output']>;
  channel: ChannelRuby;
  channelIconUrl?: Maybe<Scalars['String']['output']>;
  companyLogo?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  connectionStatus?: Maybe<Scalars['String']['output']>;
  courierSetting?: Maybe<CourierSetting>;
  createdAt: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['String']['output']>;
  expiredMsg?: Maybe<Scalars['String']['output']>;
  hasCategory: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isAvailableApi?: Maybe<Scalars['Boolean']['output']>;
  isImageExists: Scalars['Boolean']['output'];
  isMergeTikTok: Scalars['Boolean']['output'];
  isStore: Scalars['Boolean']['output'];
  isSyncAvailable: Scalars['Boolean']['output'];
  isSyncFileNeeded: Scalars['Boolean']['output'];
  isSyncItem: Scalars['Boolean']['output'];
  isSyncing: Scalars['Boolean']['output'];
  jurnal?: Maybe<Jurnal>;
  lastSyncedAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reconnectUrl?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  stockSyncEnabled: Scalars['Boolean']['output'];
  storeUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  warehouseMappings?: Maybe<Array<WarehouseMappingRuby>>;
  warehouses?: Maybe<Array<WarehouseRuby>>;
};

export type AccountV2 = {
  __typename?: 'AccountV2';
  alias?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  warehouse?: Maybe<Array<Maybe<Warehouse>>>;
  warehouseCount?: Maybe<Scalars['Int']['output']>;
  warehouseId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Accurate = {
  __typename?: 'Accurate';
  accountPayout?: Maybe<Scalars['JSON']['output']>;
  branches?: Maybe<Scalars['JSON']['output']>;
  customers?: Maybe<Scalars['JSON']['output']>;
  shipping?: Maybe<Scalars['JSON']['output']>;
  taxes?: Maybe<Scalars['JSON']['output']>;
  warehouses?: Maybe<Scalars['JSON']['output']>;
};

export type AccurateAccountInput = {
  no?: InputMaybe<Scalars['String']['input']>;
};

export type AccurateAccountMappingInput = {
  no?: InputMaybe<Scalars['String']['input']>;
};

export type AccurateAccountPayoutMappingInput = {
  fulfillment?: InputMaybe<AccurateAccountMappingInput>;
  platformRebate?: InputMaybe<AccurateAccountMappingInput>;
  service?: InputMaybe<AccurateAccountMappingInput>;
  shippingDifference?: InputMaybe<AccurateAccountMappingInput>;
  voucherSeller?: InputMaybe<AccurateAccountMappingInput>;
};

export type AccurateBranchInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AccurateCustomerMappingInput = {
  customers?: InputMaybe<Array<AccurateCustomerMappingItemInput>>;
};

export type AccurateCustomerMappingItemInput = {
  account?: InputMaybe<AccurateAccountInput>;
  branch?: InputMaybe<AccurateBranchInput>;
  forstokChannel?: InputMaybe<ForstokChannelInput>;
};

export type AccurateMappingInput = {
  accountPayout?: InputMaybe<AccurateAccountPayoutMappingInput>;
  customers?: InputMaybe<AccurateCustomerMappingInput>;
  shipping?: InputMaybe<AccurateShippingInput>;
  tax?: InputMaybe<AccurateTaxInput>;
  warehouses?: InputMaybe<AccurateWarehouseMappingInput>;
};

export type AccurateShippingInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type AccurateTaxInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type AccurateWarehouseInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AccurateWarehouseMappingInput = {
  warehouses?: InputMaybe<Array<AccurateWarehouseMappingItemInput>>;
};

export type AccurateWarehouseMappingItemInput = {
  accurateWarehouse?: InputMaybe<AccurateWarehouseInput>;
  accurateWebhook?: InputMaybe<AccurateWebhookInput>;
  forstokWarehouse?: InputMaybe<ForstokWarehouseInput>;
};

export type AccurateWebhookInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ActionAccountInput = {
  ID?: InputMaybe<Scalars['Int']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isPOS?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  warehouseId: Array<Scalars['String']['input']>;
};

export type ActionAccountPayload = {
  __typename?: 'ActionAccountPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ActionActiveInactiveResponse = {
  __typename?: 'ActionActiveInactiveResponse';
  failedItems?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  successItems?: Maybe<Array<Scalars['String']['output']>>;
  unprocessItems?: Maybe<Array<Scalars['String']['output']>>;
};

export type ActionAvailability = {
  __typename?: 'ActionAvailability';
  channelGroupId?: Maybe<Scalars['Int']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<ActionAvailibilityGroup>;
  invoiced?: Maybe<Scalars['Int']['output']>;
  isDisable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packed?: Maybe<Scalars['Int']['output']>;
  picked?: Maybe<Scalars['Int']['output']>;
  picklist?: Maybe<Scalars['Int']['output']>;
  shipped?: Maybe<Scalars['Int']['output']>;
  statusId?: Maybe<Scalars['Int']['output']>;
  statusInvoice?: Maybe<Scalars['String']['output']>;
};

export type ActionAvailibilityGroup = {
  __typename?: 'ActionAvailibilityGroup';
  action: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ActionBundleProductError = {
  __typename?: 'ActionBundleProductError';
  main?: Maybe<Scalars['Boolean']['output']>;
  masterVariantId?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
};

export type ActionBundleProductResponse = {
  __typename?: 'ActionBundleProductResponse';
  errors?: Maybe<Array<Maybe<ActionBundleProductError>>>;
  message: Scalars['String']['output'];
};

export type ActionCampaignInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  audienceType: Scalars['String']['input'];
  campaignName: Scalars['String']['input'];
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAutoLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isExclude?: InputMaybe<Scalars['Boolean']['input']>;
  isSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  recipients?: InputMaybe<Array<RecipientCampaignContactInput>>;
  replyHandler?: InputMaybe<Scalars['String']['input']>;
  replyHandlerId?: InputMaybe<Scalars['Int']['input']>;
  scheduleDate?: InputMaybe<Scalars['String']['input']>;
  senderPhone: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  terms?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ActionCampaignResponse = {
  __typename?: 'ActionCampaignResponse';
  campaign?: Maybe<Campaign>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ActionCategoryMappingResponse = {
  __typename?: 'ActionCategoryMappingResponse';
  listCategoryMapping?: Maybe<ListCategoryMapping>;
  success: Scalars['Boolean']['output'];
};

export type ActionChatStoreInput = {
  addressInput?: InputMaybe<StoreAddressInput>;
  companyLogo?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  courierSettingInput?: InputMaybe<CourierSettingInput>;
  customCourierInput?: InputMaybe<Array<InputMaybe<CustomCourierInput>>>;
  customPaymentInput?: InputMaybe<Array<InputMaybe<CustomPaymentInput>>>;
  deliverySettingInput?: InputMaybe<DeliverySettingInput>;
  fallbackMessage?: InputMaybe<Scalars['String']['input']>;
  handoff?: InputMaybe<Scalars['String']['input']>;
  handoffMessage?: InputMaybe<Scalars['String']['input']>;
  handoffUserId?: InputMaybe<Scalars['Int']['input']>;
  holidayMessage?: InputMaybe<Scalars['String']['input']>;
  holidays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hours?: InputMaybe<Array<InputMaybe<StoreHoursInput>>>;
  id: Scalars['String']['input'];
  paymentSettingInput?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentType?: InputMaybe<PaymentType>;
  replyMessage?: InputMaybe<Scalars['String']['input']>;
  resolveConfirmation?: InputMaybe<Scalars['String']['input']>;
  resolveConfirmationTimer?: InputMaybe<Scalars['Int']['input']>;
  resolvedReminderMessage?: InputMaybe<Scalars['String']['input']>;
  resolvedReminderTimer?: InputMaybe<Scalars['Int']['input']>;
  roundRobinUsers?: InputMaybe<Array<InputMaybe<RoundRobinUserInput>>>;
  storeId: Scalars['Int']['input'];
  storeName: Scalars['String']['input'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
  welcomeMessageFileType?: InputMaybe<FileType>;
  welcomeMessageFileUrl?: InputMaybe<Scalars['String']['input']>;
  welcomeMessageImageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ActionChatStorePayload = {
  __typename?: 'ActionChatStorePayload';
  chatStore?: Maybe<ChatStoreDetail>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ActionChatWhatsAppTemplateInput = {
  accountId: Scalars['Int']['input'];
  category: Scalars['String']['input'];
  components: ComponentInput;
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parameterFormat?: InputMaybe<Scalars['String']['input']>;
};

export type ActionChatWhatsAppTemplatePayload = {
  __typename?: 'ActionChatWhatsAppTemplatePayload';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  template?: Maybe<Template>;
};

export type ActionConfirmLinkingResponse = {
  __typename?: 'ActionConfirmLinkingResponse';
  failedItems?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  successItems?: Maybe<Array<Scalars['String']['output']>>;
  unprocessItems?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ActionConfirmPriceStatusName {
  Approve = 'approve',
  Delete = 'delete'
}

export type ActionLabelPayload = {
  __typename?: 'ActionLabelPayload';
  content?: Maybe<Label>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ActionListingError = {
  __typename?: 'ActionListingError';
  imageIndex?: Maybe<Scalars['Int']['output']>;
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
  variantIndex?: Maybe<Scalars['Int']['output']>;
};

export type ActionListingInput = {
  listingAccount?: InputMaybe<Scalars['Int']['input']>;
  listingSku?: InputMaybe<Scalars['String']['input']>;
  masterSku?: InputMaybe<Scalars['String']['input']>;
  masterVariantId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActionListingPayload = {
  __typename?: 'ActionListingPayload';
  message: Scalars['String']['output'];
};

export type ActionListingResponse = {
  __typename?: 'ActionListingResponse';
  errors?: Maybe<Array<Maybe<ActionListingError>>>;
  message: Scalars['String']['output'];
};

export type ActionManualLinkingError = {
  __typename?: 'ActionManualLinkingError';
  message: Scalars['String']['output'];
  variantIndex?: Maybe<Scalars['Int']['output']>;
};

export type ActionManualLinkingResponse = {
  __typename?: 'ActionManualLinkingResponse';
  errors?: Maybe<Array<Maybe<ActionManualLinkingError>>>;
  message: Scalars['String']['output'];
};

export type ActionPriceAdjustmentResponse = {
  __typename?: 'ActionPriceAdjustmentResponse';
  errors?: Maybe<Array<Maybe<ActionListingError>>>;
  message: Scalars['String']['output'];
};

export type ActionPriceListingError = {
  __typename?: 'ActionPriceListingError';
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type ActionPriceListingResponse = {
  __typename?: 'ActionPriceListingResponse';
  errors?: Maybe<Array<Maybe<ActionPriceListingError>>>;
  message: Scalars['String']['output'];
};

export type ActionProductsError = {
  __typename?: 'ActionProductsError';
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
  variantIndex: Scalars['Int']['output'];
};

export type ActionProductsInput = {
  draftId?: InputMaybe<Scalars['Int']['input']>;
  products: Array<InputProduct>;
};

export type ActionProductsPayload = {
  __typename?: 'ActionProductsPayload';
  errors?: Maybe<Array<Maybe<ActionProductsError>>>;
  message: Scalars['String']['output'];
  productIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type ActionPromotionResponse = {
  __typename?: 'ActionPromotionResponse';
  message: Scalars['String']['output'];
};

export type ActionSalesOrder = {
  __typename?: 'ActionSalesOrder';
  order: Order;
};

export type ActionSalesOrderDropshipInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
};

export type ActionSalesOrderInput = {
  accountId: Scalars['Int']['input'];
  addressId?: InputMaybe<Scalars['Int']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  contactType?: InputMaybe<CrmContactType>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  dropship?: InputMaybe<ActionSalesOrderDropshipInput>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  isMarkAsPaid: Scalars['Boolean']['input'];
  isPOS: Scalars['Boolean']['input'];
  itemLinesAttributes?: InputMaybe<Array<ItemLinesAttributes>>;
  localName?: InputMaybe<Scalars['String']['input']>;
  methodPayment?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentTerm?: InputMaybe<OrderPaymentTerm>;
  shippingPrice?: InputMaybe<Scalars['Int']['input']>;
  warehouseId: Scalars['Int']['input'];
};

export type ActionUnreadRoomInput = {
  roomId: Scalars['String']['input'];
};

export type ActionUnreadRoomPayload = {
  __typename?: 'ActionUnreadRoomPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ActionVoucherInput = {
  applicableCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  applicableProducts?: InputMaybe<Array<InputMaybe<ActionVoucherProductInput>>>;
  applicableStoreIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  discountValue?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['String']['input'];
  excludedProductIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isStackable?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmount: Scalars['Int']['input'];
  minOrderValue: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  quotaPerUser?: InputMaybe<Scalars['Int']['input']>;
  quotaTotal?: InputMaybe<Scalars['Int']['input']>;
  stackGroup?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  status?: InputMaybe<VoucherActionStatus>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  storeScope?: InputMaybe<Scalars['String']['input']>;
  type: VoucherType;
};

export type ActionVoucherProductInput = {
  id: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivityFilterByInputs = {
  source?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Address = {
  __typename?: 'Address';
  address: Scalars['String']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  subDistrict?: Maybe<SubDistrict>;
  subdistrictId: Scalars['Int']['output'];
};

export type AddressInput = {
  address: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  subdistrictId: Scalars['Int']['input'];
};

export type Agent = {
  __typename?: 'Agent';
  avatar?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: AgentType;
};

export type AgentConversation = {
  __typename?: 'AgentConversation';
  agent: Agent;
  open: Scalars['Int']['output'];
};

/** Filter agent type: Bot, Human. Kosong = all. */
export enum AgentReportType {
  Bot = 'Bot',
  Human = 'Human'
}

export enum AgentType {
  Bot = 'BOT',
  Human = 'HUMAN'
}

export type Analytics = {
  __typename?: 'Analytics';
  sections: Array<Sections>;
};

export type AnalyticsGuestTokenResult = {
  __typename?: 'AnalyticsGuestTokenResult';
  dashboardId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  profileId?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type Announcement = {
  __typename?: 'Announcement';
  message?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ArchivedProductsPayload = {
  __typename?: 'ArchivedProductsPayload';
  failedProducts?: Maybe<Array<Scalars['Int']['output']>>;
  message: Scalars['String']['output'];
  successProducts?: Maybe<Array<Scalars['Int']['output']>>;
};

export type AttributeInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type AudienceCampaignPerformance = {
  __typename?: 'AudienceCampaignPerformance';
  locationPerformance?: Maybe<LocationCampaignPerformance>;
  orderPerformance?: Maybe<Array<Maybe<DataCampaignPerformance>>>;
  performance?: Maybe<DataCampaignPerformance>;
  productPerformance?: Maybe<Array<Maybe<DataCampaignPerformance>>>;
  spendPerformance?: Maybe<Array<Maybe<DataCampaignPerformance>>>;
};

export type AutoReply = {
  __typename?: 'AutoReply';
  body: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  storeId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<FileType>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AutoReplyConnection = {
  __typename?: 'AutoReplyConnection';
  edges?: Maybe<Array<Maybe<AutoReplyEdge>>>;
  nodes?: Maybe<Array<Maybe<AutoReply>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type AutoReplyEdge = {
  __typename?: 'AutoReplyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutoReply>;
};

export enum AutoReplyFileType {
  Image = 'image',
  Pdf = 'pdf',
  Video = 'video'
}

export type AutoReplyFilter = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type AvailableCouriers = {
  __typename?: 'AvailableCouriers';
  data?: Maybe<Array<Maybe<DataCourier>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AvailablePayments = {
  __typename?: 'AvailablePayments';
  data?: Maybe<Array<Maybe<DataPayment>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type BillingAddressInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingPhone?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingSubDistrictId?: InputMaybe<Scalars['Int']['input']>;
};

export type Bin = {
  __typename?: 'Bin';
  binName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  id?: Maybe<Scalars['String']['output']>;
  locType?: Maybe<Scalars['String']['output']>;
  oldWarehouseId: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityPicked?: Maybe<Scalars['Int']['output']>;
  quantityToPick?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Time']['output'];
  warehouseId: Scalars['String']['output'];
};

export type BreadcrumbCategory = {
  __typename?: 'BreadcrumbCategory';
  id: Scalars['String']['output'];
  lowest: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type BundleTypeNew = {
  __typename?: 'BundleTypeNew';
  bundleVariants?: Maybe<Array<BundleVariantTypeNew>>;
};

export type BundleVariantTypeNew = {
  __typename?: 'BundleVariantTypeNew';
  main: Scalars['Boolean']['output'];
  unit?: Maybe<Scalars['Int']['output']>;
  variant?: Maybe<ItemVariant>;
  variantId?: Maybe<Scalars['Int']['output']>;
};

export type ButtonInput = {
  example?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  accountId?: Maybe<Scalars['Int']['output']>;
  amountSpent?: Maybe<Scalars['Float']['output']>;
  attachmentUrl?: Maybe<Scalars['String']['output']>;
  audienceType?: Maybe<Scalars['String']['output']>;
  averageOrderValue?: Maybe<Scalars['Float']['output']>;
  campaignDelivered?: Maybe<Scalars['Int']['output']>;
  campaignDeliveredPercentage?: Maybe<Scalars['Int']['output']>;
  campaignName?: Maybe<Scalars['String']['output']>;
  campaignNotDelivered?: Maybe<Scalars['Int']['output']>;
  campaignRead?: Maybe<Scalars['Int']['output']>;
  campaignReadPercentage?: Maybe<Scalars['Int']['output']>;
  campaignReply?: Maybe<Scalars['Int']['output']>;
  campaignReplyPercentage?: Maybe<Scalars['Int']['output']>;
  campaignSent?: Maybe<Scalars['Int']['output']>;
  campaignSentPercentage?: Maybe<Scalars['Int']['output']>;
  campaignUndelivered?: Maybe<Scalars['Int']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  costPerDelivered?: Maybe<Scalars['Float']['output']>;
  costPerOrder?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<Scalars['Boolean']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  firstSentDate?: Maybe<Scalars['Time']['output']>;
  flowId?: Maybe<Scalars['Int']['output']>;
  flowType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSentDate?: Maybe<Scalars['Time']['output']>;
  recipients?: Maybe<Array<CampaignRecipient>>;
  replyHandler?: Maybe<Scalars['String']['output']>;
  replyHandlerId?: Maybe<Scalars['Int']['output']>;
  returnOnWhatsAppSpent?: Maybe<Scalars['Float']['output']>;
  scheduleDate?: Maybe<Scalars['Time']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  senderPhone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusPercentage?: Maybe<Scalars['Int']['output']>;
  successCount?: Maybe<Scalars['Int']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  totalAttachment?: Maybe<Scalars['Int']['output']>;
  totalOrderAmount?: Maybe<Scalars['Float']['output']>;
  totalOrderPercentage?: Maybe<Scalars['Int']['output']>;
  totalOrders?: Maybe<Scalars['Int']['output']>;
  totalRecipients?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CampaignActivityConnection = {
  __typename?: 'CampaignActivityConnection';
  edges?: Maybe<Array<Maybe<CampaignActivityEdge>>>;
  nodes?: Maybe<Array<Maybe<WhatsappCampaignActivity>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type CampaignActivityEdge = {
  __typename?: 'CampaignActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<WhatsappCampaignActivity>;
};

export type CampaignConnection = {
  __typename?: 'CampaignConnection';
  edges?: Maybe<Array<Maybe<CampaignEdge>>>;
  nodes?: Maybe<Array<Maybe<Campaign>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type CampaignEdge = {
  __typename?: 'CampaignEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Campaign>;
};

export type CampaignFilter = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignRecipient = {
  __typename?: 'CampaignRecipient';
  customerId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type CampaignSortByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type CancelPop = {
  __typename?: 'CancelPop';
  orders?: Maybe<Array<Maybe<Order>>>;
};

export type CancelQuantity = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityId?: InputMaybe<Scalars['String']['input']>;
};

export type CancelReason = {
  __typename?: 'CancelReason';
  channelId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CarouselButtonInput = {
  example?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselCardComponentInput = {
  buttons?: InputMaybe<Array<CarouselButtonInput>>;
  example?: InputMaybe<CarouselExampleInput>;
  format?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CarouselCardInput = {
  components?: InputMaybe<Array<CarouselCardComponentInput>>;
};

export type CarouselExampleInput = {
  headerHandle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CartBillingAddress = {
  __typename?: 'CartBillingAddress';
  address?: Maybe<Scalars['String']['output']>;
  address_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type CartBillingAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type CartCourier = {
  __typename?: 'CartCourier';
  name?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
};

export type CartCourierInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
};

export type CartShippingAddress = {
  __typename?: 'CartShippingAddress';
  address?: Maybe<Scalars['String']['output']>;
  address_id?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type CartShippingAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_id?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type CartVoucher = {
  __typename?: 'CartVoucher';
  calculatedDiscountAmount?: Maybe<Scalars['Int']['output']>;
  disabled: Scalars['Boolean']['output'];
  type?: Maybe<VoucherType>;
  voucher?: Maybe<Voucher>;
};

export type CartVoucherList = {
  __typename?: 'CartVoucherList';
  cartSummary?: Maybe<CartVoucherSummary>;
  data?: Maybe<Array<Maybe<CartVoucher>>>;
};

export type CartVoucherSummary = {
  __typename?: 'CartVoucherSummary';
  amount?: Maybe<Scalars['Int']['output']>;
  cartId?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['Int']['output']>;
  currentDiscount?: Maybe<Scalars['Int']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  shippingRate?: Maybe<Scalars['Int']['output']>;
  storeId?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
};

export type CartWarehouse = {
  __typename?: 'CartWarehouse';
  address: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  oldId: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  subDistrictId: Scalars['String']['output'];
  zip_code: Scalars['String']['output'];
};

export type CartWarehouseInput = {
  address: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  oldId: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  subDistrictId: Scalars['String']['input'];
  zip_code: Scalars['String']['input'];
};

export type CategoryListingContentListing = {
  __typename?: 'CategoryListingContentListing';
  labelArr?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value: Scalars['String']['output'];
  valueArr?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CategoryMapping = {
  __typename?: 'CategoryMapping';
  details?: Maybe<Array<CategoryMappingDetail>>;
  id: Scalars['ID']['output'];
  masterCategoryName: Scalars['String']['output'];
};

/** The connection type for CategoryMapping. */
export type CategoryMappingConnection = {
  __typename?: 'CategoryMappingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CategoryMappingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ListCategoryMapping>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type CategoryMappingDetail = {
  __typename?: 'CategoryMappingDetail';
  accountId?: Maybe<Scalars['Int']['output']>;
  channelCategoryId?: Maybe<Scalars['Int']['output']>;
  channelCategoryNames?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type CategoryMappingEdge = {
  __typename?: 'CategoryMappingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ListCategoryMapping>;
};

export type Channel = {
  __typename?: 'Channel';
  channelGroupId: Scalars['Int']['output'];
  color?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageContentType?: Maybe<Scalars['String']['output']>;
  imageFingerprint?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  initials: Scalars['String']['output'];
  isPos: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ChannelRuby = {
  __typename?: 'ChannelRuby';
  channelGroupId: Scalars['Int']['output'];
  color?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  isPos: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type ChannelTypeNew = {
  __typename?: 'ChannelTypeNew';
  channelGroupId: Scalars['Int']['output'];
  color?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  isPos: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ChannelWarehouse = {
  __typename?: 'ChannelWarehouse';
  code: Scalars['String']['output'];
  localId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ChannelWarehouseListResponse = {
  __typename?: 'ChannelWarehouseListResponse';
  channelWarehouses: Array<ChannelWarehouse>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ChannelWarehouseSyncResponse = {
  __typename?: 'ChannelWarehouseSyncResponse';
  channelWarehouses: Array<ChannelWarehouse>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChannelsFilterByInput = {
  itemV2?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPayoutByApiAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPayoutMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  orderV2?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChannelsPayload = {
  __typename?: 'ChannelsPayload';
  Stores?: Maybe<Array<Maybe<StoresPayload>>>;
  availableAPI?: Maybe<Scalars['Boolean']['output']>;
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  editListing?: Maybe<Scalars['Boolean']['output']>;
  navbarId?: Maybe<Scalars['Int']['output']>;
  totalStores?: Maybe<Scalars['Int']['output']>;
};

export type ChatAiToken = {
  __typename?: 'ChatAIToken';
  balance: Scalars['Int']['output'];
  balanceChange: Scalars['Float']['output'];
  channel: ChatAiTokenChannel;
  conversationCount: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  receivedMessagesCount: Scalars['Int']['output'];
  sentMessagesCount: Scalars['Int']['output'];
  tokenUsageCount: Scalars['Int']['output'];
  type: ChatAiTokenType;
};

export type ChatAiTokenChannel = {
  __typename?: 'ChatAITokenChannel';
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId: Scalars['String']['output'];
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  channelName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  storeId: Scalars['Int']['output'];
  storeName: Scalars['String']['output'];
};

export type ChatAiTokenConnection = {
  __typename?: 'ChatAITokenConnection';
  edges?: Maybe<Array<ChatAiTokenEdge>>;
  nodes: Array<ChatAiToken>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type ChatAiTokenEdge = {
  __typename?: 'ChatAITokenEdge';
  cursor: Scalars['String']['output'];
  node: ChatAiToken;
};

export type ChatAiTokenFilterBy = {
  type?: InputMaybe<ChatAiTokenType>;
};

export type ChatAiTokenMetrics = {
  __typename?: 'ChatAITokenMetrics';
  avgCost: Scalars['Int']['output'];
  avgMonthlySpent: Scalars['Int']['output'];
  currentBalance: Scalars['Int']['output'];
  monthSpent: Scalars['Int']['output'];
  monthSpentPercentage: Scalars['Int']['output'];
  monthlyBudgetLimit: Scalars['Int']['output'];
};

export enum ChatAiTokenType {
  Topup = 'TOPUP',
  Usage = 'USAGE'
}

export type ChatActionAutoReplyInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status: Scalars['String']['input'];
  storeId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<FileType>;
};

export type ChatActionAutoReplyPayload = {
  __typename?: 'ChatActionAutoReplyPayload';
  autoReply?: Maybe<AutoReply>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChatActionLimitInput = {
  amount: Scalars['Int']['input'];
};

export type ChatActionLimitPayload = {
  __typename?: 'ChatActionLimitPayload';
  chatAITokenMetrics: ChatAiTokenMetrics;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChatActionTopupInput = {
  amount: Scalars['Int']['input'];
};

export type ChatActionTopupPayload = {
  __typename?: 'ChatActionTopupPayload';
  chatAITokenMetrics: ChatAiTokenMetrics;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChatAddToCartInput = {
  accountId: Scalars['Int']['input'];
  billing?: InputMaybe<CartBillingAddressInput>;
  contactId: Scalars['Int']['input'];
  courier?: InputMaybe<CartCourierInput>;
  customName?: InputMaybe<Scalars['String']['input']>;
  customValue?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  fulfillmentType?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<ChatItemInput>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentCode?: InputMaybe<Scalars['String']['input']>;
  paymentTerm?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<CartShippingAddressInput>;
  shippingRate?: InputMaybe<Scalars['Int']['input']>;
  voucherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouse?: InputMaybe<CartWarehouseInput>;
};

export type ChatAddToCartResponse = {
  __typename?: 'ChatAddToCartResponse';
  chatCart?: Maybe<ChatCart>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ChatAuthorizePayload = {
  __typename?: 'ChatAuthorizePayload';
  content?: Maybe<ChatStore>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChatCart = {
  __typename?: 'ChatCart';
  accountId: Scalars['Int']['output'];
  billing?: Maybe<CartBillingAddress>;
  contactId: Scalars['Int']['output'];
  courier?: Maybe<CartCourier>;
  customName?: Maybe<Scalars['String']['output']>;
  customValue?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  fulfillmentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<ChatItem>>;
  note?: Maybe<Scalars['String']['output']>;
  paymentCode?: Maybe<Scalars['String']['output']>;
  paymentTerm?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<CartShippingAddress>;
  shippingRate?: Maybe<Scalars['Int']['output']>;
  voucherIds?: Maybe<Array<Scalars['String']['output']>>;
  vouchers?: Maybe<Array<ChatCartVoucher>>;
  warehouse?: Maybe<CartWarehouse>;
};

export type ChatCartVoucher = {
  __typename?: 'ChatCartVoucher';
  calculatedDiscountAmount: Scalars['Int']['output'];
  code?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  maxAmount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  voucherId: Scalars['String']['output'];
};

export type ChatConversation = {
  __typename?: 'ChatConversation';
  data: Array<Scalars['Int']['output']>;
  persentage: Scalars['Float']['output'];
  status: ChatStatus;
  total: Scalars['Int']['output'];
};

export enum ChatConversationType {
  Conversation = 'CONVERSATION',
  Count = 'COUNT',
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export type ChatCustomerSurvey = {
  __typename?: 'ChatCustomerSurvey';
  channel: ChatCustomerSurveyChannel;
  commentMessage?: Maybe<Scalars['String']['output']>;
  contactId: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Int']['output'];
  referral?: Maybe<Scalars['String']['output']>;
  storeId: Scalars['Int']['output'];
};

export type ChatCustomerSurveyChannel = {
  __typename?: 'ChatCustomerSurveyChannel';
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId: Scalars['String']['output'];
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  channelName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  storeId: Scalars['Int']['output'];
  storeName: Scalars['String']['output'];
};

export type ChatCustomerSurveyConnection = {
  __typename?: 'ChatCustomerSurveyConnection';
  edges?: Maybe<Array<ChatCustomerSurveyEdge>>;
  nodes: Array<ChatCustomerSurvey>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type ChatCustomerSurveyEdge = {
  __typename?: 'ChatCustomerSurveyEdge';
  cursor: Scalars['String']['output'];
  node: ChatCustomerSurvey;
};

export type ChatCustomerSurveyMetric = {
  __typename?: 'ChatCustomerSurveyMetric';
  AverageScore: Scalars['Float']['output'];
  CSATScorePercentage: Scalars['Float']['output'];
  totalResponses: Scalars['Int']['output'];
};

export type ChatCustomerSurveyStats = {
  __typename?: 'ChatCustomerSurveyStats';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  responseRatePercentage: Scalars['Float']['output'];
  satisfactionScorePercentage: Scalars['Float']['output'];
  totalResponsesPercentage: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type ChatCustomerSurveyStatsConnection = {
  __typename?: 'ChatCustomerSurveyStatsConnection';
  edges?: Maybe<Array<ChatCustomerSurveyStatsEdge>>;
  nodes: Array<ChatCustomerSurveyStats>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type ChatCustomerSurveyStatsEdge = {
  __typename?: 'ChatCustomerSurveyStatsEdge';
  cursor: Scalars['String']['output'];
  node: ChatCustomerSurveyStats;
};

export type ChatCustomerSurveySummary = {
  __typename?: 'ChatCustomerSurveySummary';
  metric: ChatCustomerSurveyMetric;
  neutralCount: Scalars['Int']['output'];
  neutralPercentage: Scalars['Float']['output'];
  notSatisfiedCount: Scalars['Int']['output'];
  notSatisfiedPercentage: Scalars['Float']['output'];
  question?: Maybe<Scalars['String']['output']>;
  satisfiedCount: Scalars['Int']['output'];
  satisfiedPercentage: Scalars['Float']['output'];
};

export type ChatDeleteAutoReplyPayload = {
  __typename?: 'ChatDeleteAutoReplyPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChatFilterByInputs = {
  condition?: InputMaybe<RoomCondition>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Array<Scalars['Int']['input']>>;
  roomType?: InputMaybe<RoomType>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ChatItem = {
  __typename?: 'ChatItem';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isSold?: Maybe<Scalars['Boolean']['output']>;
  length: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  productId: Scalars['String']['output'];
  productIdInt?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  salePrice?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
  variantIdInt?: Maybe<Scalars['Int']['output']>;
  weight: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type ChatItemInput = {
  description: Scalars['String']['input'];
  height: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isSold?: InputMaybe<Scalars['Boolean']['input']>;
  length: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  productIdInt?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  salePrice?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
  variantIdInt?: InputMaybe<Scalars['Int']['input']>;
  weight: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export enum ChatKnowledgeAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  ImportDocument = 'IMPORT_DOCUMENT',
  None = 'NONE',
  Update = 'UPDATE'
}

export enum ChatKnowledgeCategory {
  Others = 'OTHERS',
  ProductKnowledge = 'PRODUCT_KNOWLEDGE',
  Promotions = 'PROMOTIONS',
  ReturnPolicy = 'RETURN_POLICY',
  StoreInformation = 'STORE_INFORMATION',
  StorePolicy = 'STORE_POLICY'
}

export type ChatKnowledgeChange = {
  __typename?: 'ChatKnowledgeChange';
  action: ChatKnowledgeAction;
  after?: Maybe<ChatKnowledgeSnapshot>;
  before?: Maybe<ChatKnowledgeSnapshot>;
};

export type ChatKnowledgeConfirmation = {
  __typename?: 'ChatKnowledgeConfirmation';
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
};

export enum ChatKnowledgeConfirmationDecision {
  Cancel = 'CANCEL',
  Confirm = 'CONFIRM'
}

export type ChatKnowledgeConversation = {
  __typename?: 'ChatKnowledgeConversation';
  assistantMessage: Scalars['String']['output'];
  changes: Array<ChatKnowledgeChange>;
  confirmation?: Maybe<ChatKnowledgeConfirmation>;
  error?: Maybe<ChatKnowledgeError>;
  job?: Maybe<ChatKnowledgeJob>;
  operationId?: Maybe<Scalars['ID']['output']>;
  sessionId: Scalars['ID']['output'];
  status: ChatKnowledgeConversationStatus;
};

export type ChatKnowledgeConversationPayload = {
  __typename?: 'ChatKnowledgeConversationPayload';
  conversation: ChatKnowledgeConversation;
};

export enum ChatKnowledgeConversationStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NeedsClarification = 'NEEDS_CLARIFICATION',
  NeedsConfirmation = 'NEEDS_CONFIRMATION',
  Processing = 'PROCESSING',
  Unsupported = 'UNSUPPORTED'
}

export type ChatKnowledgeError = {
  __typename?: 'ChatKnowledgeError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type ChatKnowledgeFile = {
  __typename?: 'ChatKnowledgeFile';
  error?: Maybe<ChatKnowledgeError>;
  expiresAt?: Maybe<Scalars['Time']['output']>;
  fileRef?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<ChatKnowledgeFileState>;
  uploadTarget?: Maybe<ChatKnowledgeUploadTarget>;
};

export type ChatKnowledgeFilePayload = {
  __typename?: 'ChatKnowledgeFilePayload';
  file: ChatKnowledgeFile;
};

export enum ChatKnowledgeFileState {
  Consumed = 'CONSUMED',
  Expired = 'EXPIRED',
  Finalized = 'FINALIZED',
  Registered = 'REGISTERED',
  Rejected = 'REJECTED'
}

export type ChatKnowledgeFinalizeDocumentInput = {
  fileRef: Scalars['ID']['input'];
  idempotencyKey: Scalars['ID']['input'];
  storeId: Scalars['Int']['input'];
};

export type ChatKnowledgeJob = {
  __typename?: 'ChatKnowledgeJob';
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type ChatKnowledgeRegisterDocumentInput = {
  idempotencyKey: Scalars['ID']['input'];
  mediaType: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
  storeId: Scalars['Int']['input'];
};

export type ChatKnowledgeResolveConfirmationInput = {
  confirmationId: Scalars['ID']['input'];
  decision: ChatKnowledgeConfirmationDecision;
  idempotencyKey: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  storeId: Scalars['Int']['input'];
};

export type ChatKnowledgeSendMessageInput = {
  idempotencyKey: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  storeId: Scalars['Int']['input'];
};

export type ChatKnowledgeSnapshot = {
  __typename?: 'ChatKnowledgeSnapshot';
  answer?: Maybe<Scalars['String']['output']>;
  category?: Maybe<ChatKnowledgeCategory>;
  knowledgeId?: Maybe<Scalars['ID']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type ChatKnowledgeUploadDocumentInput = {
  category?: InputMaybe<ChatKnowledgeCategory>;
  fileRef: Scalars['ID']['input'];
  idempotencyKey: Scalars['ID']['input'];
  instruction?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  storeId: Scalars['Int']['input'];
};

export type ChatKnowledgeUploadFormField = {
  __typename?: 'ChatKnowledgeUploadFormField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ChatKnowledgeUploadHeader = {
  __typename?: 'ChatKnowledgeUploadHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ChatKnowledgeUploadTarget = {
  __typename?: 'ChatKnowledgeUploadTarget';
  expiresAt?: Maybe<Scalars['Time']['output']>;
  formFields: Array<ChatKnowledgeUploadFormField>;
  method: Scalars['String']['output'];
  /** @deprecated Gunakan method dan formFields untuk presigned POST */
  requiredHeaders: Array<ChatKnowledgeUploadHeader>;
  url: Scalars['String']['output'];
};

export type ChatLabelAssignPayload = {
  __typename?: 'ChatLabelAssignPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChatLocation = {
  __typename?: 'ChatLocation';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  channelId: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isFromBuyer: Scalars['Boolean']['output'];
  llmUsage?: Maybe<ChatMessageLlmUsage>;
  messageAction?: Maybe<Array<Maybe<ChatMessageAction>>>;
  messageFooterText?: Maybe<Scalars['String']['output']>;
  messageProduct?: Maybe<ChatProduct>;
  messageProductId?: Maybe<Scalars['String']['output']>;
  messageQuestion?: Maybe<Scalars['String']['output']>;
  messageText?: Maybe<Scalars['String']['output']>;
  messageTitle?: Maybe<Scalars['String']['output']>;
  messageTitleAction?: Maybe<Scalars['String']['output']>;
  messageType: MessageType;
  messageUrl?: Maybe<Scalars['String']['output']>;
  replyMessage?: Maybe<ChatReplyMessage>;
  roomId: Scalars['String']['output'];
  senderName: Scalars['String']['output'];
  status: MessageStatus;
  storeId: Scalars['Int']['output'];
  update?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatMessageAction = {
  __typename?: 'ChatMessageAction';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** The connection type for ChatMessage. */
export type ChatMessageConnection = {
  __typename?: 'ChatMessageConnection';
  edges?: Maybe<Array<Maybe<ChatMessageEdge>>>;
  nodes?: Maybe<Array<Maybe<ChatMessageGroup>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type ChatMessageEdge = {
  __typename?: 'ChatMessageEdge';
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ChatMessageGroup>;
};

export type ChatMessageGroup = {
  __typename?: 'ChatMessageGroup';
  createdAt: Scalars['String']['output'];
  messages: Array<Maybe<ChatMessage>>;
};

export type ChatMessageLlmUsage = {
  __typename?: 'ChatMessageLLMUsage';
  outputTextTokens: Scalars['Int']['output'];
};

export type ChatProduct = {
  __typename?: 'ChatProduct';
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl: Array<Scalars['String']['output']>;
  masterBrand: Scalars['String']['output'];
  masterCategory: Scalars['String']['output'];
  masterProductId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  productIdInt?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  store?: Maybe<ChatStore>;
  storeId: Scalars['Int']['output'];
  variants?: Maybe<Array<Maybe<ChatProductVariant>>>;
};

/** The connection type for ChatProduct. */
export type ChatProductConnection = {
  __typename?: 'ChatProductConnection';
  edges?: Maybe<Array<Maybe<ChatProductEdge>>>;
  nodes?: Maybe<Array<Maybe<ChatProduct>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type ChatProductEdge = {
  __typename?: 'ChatProductEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ChatProduct>;
};

export type ChatProductVariant = {
  __typename?: 'ChatProductVariant';
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  idInt?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  salePrice?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  warehouses?: Maybe<Array<Maybe<ProductWarehouse>>>;
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ChatReplyMessage = {
  __typename?: 'ChatReplyMessage';
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageFooterText?: Maybe<Scalars['String']['output']>;
  messageText?: Maybe<Scalars['String']['output']>;
  messageTitle?: Maybe<Scalars['String']['output']>;
  messageType: MessageType;
  messageUrl?: Maybe<Scalars['String']['output']>;
};

/** Connection untuk ChatReportByAgents. */
export type ChatReportByAgentsConnection = {
  __typename?: 'ChatReportByAgentsConnection';
  edges?: Maybe<Array<Maybe<ChatReportByAgentsEdge>>>;
  nodes?: Maybe<Array<Maybe<ChatReportByAgentsNode>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

/** Edge untuk connection ChatReportByAgents. */
export type ChatReportByAgentsEdge = {
  __typename?: 'ChatReportByAgentsEdge';
  cursor: Scalars['String']['output'];
  node: ChatReportByAgentsNode;
};

/** Filter untuk chatReportByAgents. */
export type ChatReportByAgentsFilterBy = {
  /** Filter by business hours only (true/false). */
  businessHours?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by channel ID. */
  channelId?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by store ID. */
  storeId?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by agent type (Bot/Human). Kosong = all. */
  type?: InputMaybe<AgentReportType>;
};

/** Satu baris laporan per agent. */
export type ChatReportByAgentsNode = {
  __typename?: 'ChatReportByAgentsNode';
  /** Rata-rata waktu resolusi (detik). */
  avgResolutionTime: Scalars['Int']['output'];
  /** Rata-rata waktu respons (detik). */
  avgResponseTime: Scalars['Int']['output'];
  /** Jumlah percakapan (No of Conversation). */
  conversationCount: Scalars['Int']['output'];
  /** Jumlah yang di-resolve. */
  resolutionCount: Scalars['Int']['output'];
  /** Store (channel) seperti di chat stores. */
  store: ChatStore;
  /** Tipe agent: Bot atau Human. */
  type: AgentReportType;
  /** ID agent/user. */
  userId: Scalars['Int']['output'];
  /** Nama agent/user. */
  userName: Scalars['String']['output'];
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  assignedUserId?: Maybe<Scalars['Int']['output']>;
  assignedUserName?: Maybe<Scalars['String']['output']>;
  contactId: Scalars['Int']['output'];
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isExpired: Scalars['Boolean']['output'];
  isFirstSync: Scalars['Boolean']['output'];
  isLastMsgFromBuyer: Scalars['Boolean']['output'];
  isSyncing: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Maybe<LabelRoom>>>;
  lastMessage: Scalars['String']['output'];
  roomType: RoomType;
  solved?: Maybe<ChatSolvedRoom>;
  store: ChatStore;
  storeId: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
  unreply: Scalars['Boolean']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type ChatRoomByMessage = {
  __typename?: 'ChatRoomByMessage';
  assignedUserId?: Maybe<Scalars['Int']['output']>;
  assignedUserName?: Maybe<Scalars['String']['output']>;
  contactId: Scalars['Int']['output'];
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isExpired: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Maybe<LabelRoom>>>;
  lastMessage: Scalars['String']['output'];
  messageId?: Maybe<Scalars['String']['output']>;
  messageIndex?: Maybe<Scalars['Int']['output']>;
  roomId?: Maybe<Scalars['String']['output']>;
  roomType: RoomType;
  solved?: Maybe<ChatSolvedRoom>;
  store: ChatStore;
  storeId: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** The connection type for ChatRoomByMessageConnection. */
export type ChatRoomByMessageConnection = {
  __typename?: 'ChatRoomByMessageConnection';
  edges?: Maybe<Array<Maybe<ChatRoomByMessageEdge>>>;
  nodes?: Maybe<Array<Maybe<ChatRoomByMessage>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  unreply?: Maybe<Scalars['Boolean']['output']>;
  updateFe: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type ChatRoomByMessageEdge = {
  __typename?: 'ChatRoomByMessageEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ChatRoomByMessage>;
};

/** The connection type for ChatRoom. */
export type ChatRoomConnection = {
  __typename?: 'ChatRoomConnection';
  edges?: Maybe<Array<Maybe<ChatRoomEdge>>>;
  nodes?: Maybe<Array<Maybe<ChatRoom>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  unreply?: Maybe<Scalars['Boolean']['output']>;
  updateFe: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type ChatRoomEdge = {
  __typename?: 'ChatRoomEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ChatRoom>;
};

export type ChatSendMessagePayload = {
  __typename?: 'ChatSendMessagePayload';
  content: Array<Maybe<ChatMessage>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChatShopeeConnectUrlPayload = {
  __typename?: 'ChatShopeeConnectUrlPayload';
  message: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChatSolvedRoom = {
  __typename?: 'ChatSolvedRoom';
  solvedAt: Scalars['Time']['output'];
  solvedBy: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export enum ChatStatus {
  Down = 'DOWN',
  Up = 'UP'
}

export type ChatStore = {
  __typename?: 'ChatStore';
  assignAgentsCount?: Maybe<Scalars['Int']['output']>;
  channelColor: Scalars['String']['output'];
  channelId: Scalars['Int']['output'];
  channelImage: Scalars['String']['output'];
  channelInitials: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  conversationMonthlyCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isSyncing: Scalars['Boolean']['output'];
  journeyId?: Maybe<Scalars['Int']['output']>;
  journeyName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  storeId: Scalars['Int']['output'];
  storeName: Scalars['String']['output'];
  tokenUsageCount?: Maybe<Scalars['Int']['output']>;
  unreadCount: Scalars['Int']['output'];
  unreply: Scalars['Boolean']['output'];
  unreplyAll?: Maybe<Scalars['Boolean']['output']>;
  unreplyAllMine?: Maybe<Scalars['Boolean']['output']>;
  unreplyMine?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ChatStoreDetail = {
  __typename?: 'ChatStoreDetail';
  address?: Maybe<StoreAddress>;
  apiProvider?: Maybe<Scalars['String']['output']>;
  assignAgentsCount?: Maybe<Scalars['Int']['output']>;
  catalogId?: Maybe<Scalars['Int']['output']>;
  channelColor: Scalars['String']['output'];
  channelId: Scalars['Int']['output'];
  channelImage: Scalars['String']['output'];
  channelInitials: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  companyLogo?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  conversationMonthlyCount?: Maybe<Scalars['Int']['output']>;
  courierSetting?: Maybe<CourierSetting>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customCourier?: Maybe<Array<Maybe<CustomCourier>>>;
  customPayment?: Maybe<Array<Maybe<CustomPayment>>>;
  deliverySetting?: Maybe<DeliverySetting>;
  fallbackMessage?: Maybe<Scalars['String']['output']>;
  handoff?: Maybe<Scalars['String']['output']>;
  handoffMessage?: Maybe<Scalars['String']['output']>;
  handoffUserId?: Maybe<Scalars['Int']['output']>;
  holidayMessage?: Maybe<Scalars['String']['output']>;
  holidays?: Maybe<Array<Scalars['String']['output']>>;
  hours?: Maybe<Array<StoreHours>>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isSyncing: Scalars['Boolean']['output'];
  journeyId?: Maybe<Scalars['Int']['output']>;
  journeyName?: Maybe<Scalars['String']['output']>;
  paymentSetting?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  paymentType?: Maybe<PaymentType>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneId?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  replyMessage?: Maybe<Scalars['String']['output']>;
  resolveConfirmation?: Maybe<Scalars['String']['output']>;
  resolveConfirmationTimer?: Maybe<Scalars['Int']['output']>;
  resolvedReminderMessage?: Maybe<Scalars['String']['output']>;
  resolvedReminderTimer?: Maybe<Scalars['Int']['output']>;
  roundRobinUsers?: Maybe<Array<RoundRobinUser>>;
  storeId: Scalars['Int']['output'];
  storeName: Scalars['String']['output'];
  tokenUsageCount?: Maybe<Scalars['Int']['output']>;
  unreadCount: Scalars['Int']['output'];
  unreply: Scalars['Boolean']['output'];
  unreplyAll?: Maybe<Scalars['Boolean']['output']>;
  unreplyAllMine?: Maybe<Scalars['Boolean']['output']>;
  unreplyMine?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userIds?: Maybe<Array<Scalars['Int']['output']>>;
  welcomeMessage?: Maybe<Scalars['String']['output']>;
  welcomeMessageFileType?: Maybe<FileType>;
  welcomeMessageFileUrl?: Maybe<Scalars['String']['output']>;
  welcomeMessageImageUrl?: Maybe<Scalars['String']['output']>;
  xenPlatformId?: Maybe<Scalars['String']['output']>;
  xenPlatformSplitrule?: Maybe<Scalars['String']['output']>;
  xenditCallbackToken?: Maybe<Scalars['String']['output']>;
  xenditEnv?: Maybe<Scalars['String']['output']>;
};

export type ChatSyncPayload = {
  __typename?: 'ChatSyncPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChatUserPayload = {
  __typename?: 'ChatUserPayload';
  message: Scalars['String']['output'];
  roomId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChatWhatsAppForm = {
  __typename?: 'ChatWhatsAppForm';
  category?: Maybe<Array<Scalars['String']['output']>>;
  flowId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ChatWhatsAppFormStatus>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ChatWhatsAppFormConnection = {
  __typename?: 'ChatWhatsAppFormConnection';
  edges?: Maybe<Array<Maybe<ChatWhatsAppFormEdge>>>;
  nodes?: Maybe<Array<Maybe<ChatWhatsAppForm>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type ChatWhatsAppFormEdge = {
  __typename?: 'ChatWhatsAppFormEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ChatWhatsAppForm>;
};

export type ChatWhatsAppFormFilter = {
  status?: InputMaybe<ChatWhatsAppFormStatus>;
};

export enum ChatWhatsAppFormStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type City = {
  __typename?: 'City';
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  lon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Province>;
  provinceId?: Maybe<Scalars['Int']['output']>;
};

export type CityInput = {
  provinceId: Scalars['Int']['input'];
};

export type Company = {
  __typename?: 'Company';
  billingType?: Maybe<Scalars['String']['output']>;
  companyCategory?: Maybe<CompanyCategory>;
  countProfiles?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyCategory = {
  __typename?: 'CompanyCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ComponentBodyInput = {
  example?: InputMaybe<ExampleBodyInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ComponentButtonInput = {
  buttons?: InputMaybe<Array<ButtonInput>>;
  type: Scalars['String']['input'];
};

export type ComponentFooterInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHeaderInput = {
  example?: InputMaybe<ExampleHeaderInput>;
  format: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ComponentInput = {
  body?: InputMaybe<ComponentBodyInput>;
  buttons?: InputMaybe<ComponentButtonInput>;
  carousel?: InputMaybe<Array<InputMaybe<CarouselCardInput>>>;
  footer?: InputMaybe<ComponentFooterInput>;
  header?: InputMaybe<ComponentHeaderInput>;
};

export type ConfirmReceive = {
  __typename?: 'ConfirmReceive';
  message: Scalars['String']['output'];
};

export type ConfirmReceiveInput = {
  id: Scalars['Int']['input'];
  itemlines: Array<ConfirmReceiveInputItemline>;
  type: Scalars['String']['input'];
};

export type ConfirmReceiveInputItemline = {
  actualQuantity: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type Contact = {
  __typename?: 'Contact';
  activities: Array<ContactActivity>;
  attributes: Array<ContactAttribute>;
  billingAddress?: Maybe<Array<Maybe<ContactAddress>>>;
  campaignOverview: ContactCampaignOverview;
  company?: Maybe<ContactCompany>;
  contactId: Scalars['String']['output'];
  conversationOverview: ContactChatOverview;
  createdAt?: Maybe<Scalars['Time']['output']>;
  dateOfBirth: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  email: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  orderOverview: ContactOrderOverview;
  paymentTerm?: Maybe<ContactPaymentTerm>;
  phoneNumber: Scalars['String']['output'];
  point: Scalars['Float']['output'];
  shippingAddress: Scalars['String']['output'];
  shippingAddresses: Array<ContactAddress>;
  stage: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type ContactActionAttributePayload = {
  __typename?: 'ContactActionAttributePayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ContactActionResponse = {
  __typename?: 'ContactActionResponse';
  contact?: Maybe<Contact>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ContactActivity = {
  __typename?: 'ContactActivity';
  eventAt?: Maybe<Scalars['Time']['output']>;
  name: Scalars['String']['output'];
  storeId: Scalars['Int']['output'];
  storeName: Scalars['String']['output'];
};

export type ContactAddress = {
  __typename?: 'ContactAddress';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['Int']['output'];
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  subdistrict: SubDistrict;
  subdistrictId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type ContactAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdistrictId?: InputMaybe<Scalars['Int']['input']>;
  type: ContactAddressType;
};

export enum ContactAddressType {
  Billing = 'billing',
  Shipping = 'shipping'
}

export type ContactAttribute = {
  __typename?: 'ContactAttribute';
  category: Scalars['String']['output'];
  dataType: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type ContactAttributeConnection = {
  __typename?: 'ContactAttributeConnection';
  edges: Array<ContactAttributeEdge>;
  nodes: Array<ContactCustomAttribute>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type ContactAttributeEdge = {
  __typename?: 'ContactAttributeEdge';
  cursor: Scalars['String']['output'];
  node: ContactCustomAttribute;
};

export type ContactAttributeInput = {
  contactType?: InputMaybe<Scalars['String']['input']>;
  demographic?: InputMaybe<Scalars['String']['input']>;
  engagement?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  member?: InputMaybe<Scalars['String']['input']>;
  orders?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  purchaseIntent?: InputMaybe<Scalars['String']['input']>;
  spend?: InputMaybe<Scalars['String']['input']>;
};

export type ContactBasic = {
  __typename?: 'ContactBasic';
  contactId: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  type: ContactBasicType;
};

export enum ContactBasicType {
  Company = 'company',
  Customer = 'customer'
}

export type ContactCampaignOverview = {
  __typename?: 'ContactCampaignOverview';
  emailClick: Scalars['Int']['output'];
  emailOpen: Scalars['Int']['output'];
  emailSent: Scalars['Int']['output'];
  whatsappClick: Scalars['Int']['output'];
  whatsappDelivered: Scalars['Int']['output'];
  whatsappSent: Scalars['Int']['output'];
};

export type ContactChatOverview = {
  __typename?: 'ContactChatOverview';
  chatTags: Array<Scalars['String']['output']>;
  firstInboundChat: Scalars['String']['output'];
  inboundChat: Scalars['Int']['output'];
  lastInboundChat: Scalars['String']['output'];
};

export type ContactCompany = {
  __typename?: 'ContactCompany';
  billingAddress?: Maybe<ContactAddress>;
  companySize: Scalars['String']['output'];
  companyType: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  discountLevel: Scalars['Float']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  industryType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  npwp: Scalars['String']['output'];
  paymentTerms: ContactPaymentTerm;
  phoneNumber: Scalars['String']['output'];
  shippingAddresses: Array<ContactAddress>;
  totalEmployees: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
  website: Scalars['String']['output'];
};

export type ContactCompanyActionResponse = {
  __typename?: 'ContactCompanyActionResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ContactCompanyAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdistrictId?: InputMaybe<Scalars['Int']['input']>;
  type: ContactAddressType;
};

export type ContactCompanyConnection = {
  __typename?: 'ContactCompanyConnection';
  edges: Array<ContactCompanyEdge>;
  nodes: Array<ContactCompany>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type ContactCompanyEdge = {
  __typename?: 'ContactCompanyEdge';
  cursor: Scalars['String']['output'];
  node: ContactCompany;
};

export type ContactCompanyInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingSubdistrictId?: InputMaybe<Scalars['Int']['input']>;
  companySize?: InputMaybe<Scalars['String']['input']>;
  companyType?: InputMaybe<Scalars['String']['input']>;
  discountLevel?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  industryType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  npwp?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<ContactPaymentTerm>;
  phoneNumber: Scalars['String']['input'];
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  shippingSubdistrictId?: InputMaybe<Scalars['Int']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCompanyMemberInput = {
  contactId: Scalars['Int']['input'];
  position: Scalars['String']['input'];
};

export type ContactCompanySortBy = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type ContactConnection = {
  __typename?: 'ContactConnection';
  edges: Array<ContactEdge>;
  nodes: Array<Contact>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type ContactCustomAttribute = {
  __typename?: 'ContactCustomAttribute';
  attributeId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type ContactEdge = {
  __typename?: 'ContactEdge';
  cursor: Scalars['String']['output'];
  node: Contact;
};

export type ContactFilter = {
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  stage?: InputMaybe<Scalars['String']['input']>;
};

export enum ContactGender {
  Female = 'Female',
  Male = 'Male'
}

export type ContactInput = {
  billingAddress?: InputMaybe<Array<InputMaybe<ContactInputAddress>>>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<ContactGender>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentTerm?: InputMaybe<ContactPaymentTerm>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<Array<InputMaybe<ContactInputAddress>>>;
};

export type ContactInputAddress = {
  address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  subdistrictId?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactInputAttribute = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ContactOrder = {
  __typename?: 'ContactOrder';
  addressName: Scalars['String']['output'];
  brand: Scalars['String']['output'];
  campaignId: Scalars['Int']['output'];
  campaignSource: Scalars['String']['output'];
  category: Scalars['String']['output'];
  channelOrderId: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  idCode?: Maybe<Scalars['String']['output']>;
  omniOrderId: Scalars['Int']['output'];
  orderType: OrderType;
  orderedAt?: Maybe<Scalars['Time']['output']>;
  paymentLink?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  paymentType: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
  staffId: Scalars['Int']['output'];
  staffName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  store: ContactStore;
  totalAmount: Scalars['Float']['output'];
  trackingCompany: Scalars['String']['output'];
  trackingNumber: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type ContactOrderConnection = {
  __typename?: 'ContactOrderConnection';
  edges: Array<ContactOrderEdge>;
  nodes: Array<ContactOrder>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type ContactOrderEdge = {
  __typename?: 'ContactOrderEdge';
  cursor: Scalars['String']['output'];
  node: ContactOrder;
};

export type ContactOrderFilter = {
  stage: Scalars['String']['input'];
};

export type ContactOrderOverview = {
  __typename?: 'ContactOrderOverview';
  averageSpent: Scalars['Float']['output'];
  cashbackBalance: Scalars['Float']['output'];
  totalItemSold: Scalars['Float']['output'];
  totalOrder: Scalars['Int']['output'];
  totalSpent: Scalars['Float']['output'];
};

export enum ContactPaymentTerm {
  Net_7 = 'NET_7',
  Net_14 = 'NET_14',
  Net_15 = 'NET_15',
  Net_30 = 'NET_30',
  Net_60 = 'NET_60',
  PaymentAfterDelivery = 'PAYMENT_AFTER_DELIVERY',
  PaymentBeforeDelivery = 'PAYMENT_BEFORE_DELIVERY'
}

export enum ContactSearchFilter {
  Multi = 'multi',
  Single = 'single'
}

export type ContactSearchResult = {
  __typename?: 'ContactSearchResult';
  contactId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  type: ContactSearchType;
};

export enum ContactSearchType {
  Contact = 'CONTACT',
  Manual = 'MANUAL'
}

export type ContactSort = {
  averageValue?: InputMaybe<Sort>;
  cashbackBalance?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  totalOrder?: InputMaybe<Sort>;
  totalSpent?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type ContactStore = {
  __typename?: 'ContactStore';
  channelColor: Scalars['String']['output'];
  channelId: Scalars['Int']['output'];
  channelImage: Scalars['String']['output'];
  channelInitials: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
  storeId: Scalars['String']['output'];
  storeName: Scalars['String']['output'];
};

export type ContentListing = {
  __typename?: 'ContentListing';
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Array<Scalars['String']['output']>>;
  listing: Array<ListingContentListing>;
  listingId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
  variants?: Maybe<Array<Maybe<VariantContentListing>>>;
};

export type ConversationMetrics = {
  __typename?: 'ConversationMetrics';
  botAgent: Scalars['Int']['output'];
  humanAgents: Scalars['Int']['output'];
  mine: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  lon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Courier = {
  __typename?: 'Courier';
  fulfillmentType?: Maybe<Scalars['String']['output']>;
  groupFulfillmentType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CourierSetting = {
  __typename?: 'CourierSetting';
  courier?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rate?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ShippingCourierType>;
};

export type CourierSettingInput = {
  courier?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ShippingCourierType>;
};

/** Autogenerated input type of CreateAccount */
export type CreateAccountInput = {
  channelId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAccount */
export type CreateAccountPayload = {
  __typename?: 'CreateAccountPayload';
  account: AccountRuby;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomerInput = {
  billingAddress?: InputMaybe<BillingAddressInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  shippingAddress?: InputMaybe<ShippingAddressInput>;
};

export type CreateCustomerPayload = {
  __typename?: 'CreateCustomerPayload';
  customer: Customer;
};

/** Autogenerated input type of CreateDashboardUser */
export type CreateDashboardUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateDashboardUser */
export type CreateDashboardUserPayload = {
  __typename?: 'CreateDashboardUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dashboardUser: DashboardUser;
};

export type CreateExcelPaymentReceive = {
  __typename?: 'CreateExcelPaymentReceive';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateExcelPaymentReceiveInput = {
  uploadedFile: Scalars['String']['input'];
};

export type CreateFinanceTransactionInput = {
  date: Scalars['String']['input'];
  description: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['Int']['input'];
  vat: Scalars['Int']['input'];
};

export type CreateFinanceTransactionResult = {
  __typename?: 'CreateFinanceTransactionResult';
  message: Scalars['String']['output'];
  transaction: FinanceTransaction;
};

export type CreateFullPaymentReceive = {
  __typename?: 'CreateFullPaymentReceive';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateFullPaymentReceiveInput = {
  invoicePayment?: InputMaybe<Array<InputMaybe<InvoicePaymentInput>>>;
  paymentReceivedDate?: InputMaybe<Scalars['String']['input']>;
  paymentReceivedType: Scalars['String']['input'];
  paymentReference?: InputMaybe<Scalars['String']['input']>;
  totalAmountReceived: Scalars['Int']['input'];
  totalFulfillmentFee?: InputMaybe<Scalars['Int']['input']>;
  totalPlatformRebate?: InputMaybe<Scalars['Int']['input']>;
  totalPromotion?: InputMaybe<Scalars['Int']['input']>;
  totalServiceFee?: InputMaybe<Scalars['Int']['input']>;
  totalShipping?: InputMaybe<Scalars['Int']['input']>;
  totalShippingFeeDiff?: InputMaybe<Scalars['Int']['input']>;
  totalTax?: InputMaybe<Scalars['Int']['input']>;
  totalVoucherAmount?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateGeneratePaymentReceive = {
  __typename?: 'CreateGeneratePaymentReceive';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateGeneratePaymentReceiveInput = {
  channelId: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  storeId: Scalars['Int']['input'];
};

export type CreateMassPaymentReceive = {
  __typename?: 'CreateMassPaymentReceive';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateMassPaymentReceiveInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  invoiceStatus?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePackageInput = {
  orders?: InputMaybe<Array<CreatePackageOrderInput>>;
};

export type CreatePackageItemLineBundleInput = {
  itemLineBundleId: Scalars['Int']['input'];
  qtyToPack: Scalars['Int']['input'];
};

export type CreatePackageItemLinesInput = {
  itemLineBundles?: InputMaybe<Array<InputMaybe<CreatePackageItemLineBundleInput>>>;
  itemLinesId: Scalars['String']['input'];
  qtyToPack: Scalars['Int']['input'];
};

export type CreatePackageOrderInput = {
  itemLines?: InputMaybe<Array<CreatePackageItemLinesInput>>;
  orderId: Scalars['String']['input'];
};

export type CreatePackagePayload = {
  __typename?: 'CreatePackagePayload';
  message: Scalars['String']['output'];
};

export type CreatePicklistInput = {
  orders?: InputMaybe<Array<CreatePicklistOrderInput>>;
  pickerId?: InputMaybe<Scalars['Int']['input']>;
  refId: Scalars['String']['input'];
  update: Scalars['Boolean']['input'];
  warehouseId: Scalars['Int']['input'];
};

export type CreatePicklistItemLineBundleInput = {
  itemLineBundleId: Scalars['Int']['input'];
  qtyToPick: Scalars['Int']['input'];
};

export type CreatePicklistItemLinesInput = {
  itemLineBundles?: InputMaybe<Array<InputMaybe<CreatePicklistItemLineBundleInput>>>;
  itemLinesId: Scalars['String']['input'];
  qtyToPick: Scalars['Int']['input'];
};

export type CreatePicklistOrderInput = {
  itemLines?: InputMaybe<Array<CreatePicklistItemLinesInput>>;
  orderId: Scalars['String']['input'];
};

export type CreatePicklistPayload = {
  __typename?: 'CreatePicklistPayload';
  message: Scalars['String']['output'];
  picklist?: Maybe<Picklist>;
};

export type CreateQuantity = {
  __typename?: 'CreateQuantity';
  errors: Array<CreateQuantityError>;
  message: Scalars['String']['output'];
};

export type CreateQuantityError = {
  __typename?: 'CreateQuantityError';
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type CreateQuantityInput = {
  adjust?: InputMaybe<Scalars['Boolean']['input']>;
  itemlines: Array<CreateQuantityInputItemline>;
  reference?: InputMaybe<Scalars['String']['input']>;
  returnId?: InputMaybe<Scalars['Int']['input']>;
  stockAt?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  warehouseDestinationId?: InputMaybe<Scalars['Int']['input']>;
  warehouseId: Scalars['Int']['input'];
};

export type CreateQuantityInputItemline = {
  id: Scalars['String']['input'];
  onhandQuantity?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateQuantityReturn = {
  __typename?: 'CreateQuantityReturn';
  errors: Array<CreateQuantityReturnError>;
  message: Scalars['String']['output'];
};

export type CreateQuantityReturnError = {
  __typename?: 'CreateQuantityReturnError';
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type CreateQuantityReturnInput = {
  adjust?: InputMaybe<Scalars['Boolean']['input']>;
  itemlines: Array<CreateQuantityReturnInputItemline>;
  reference?: InputMaybe<Scalars['String']['input']>;
  returnId?: InputMaybe<Scalars['Int']['input']>;
  stockAt?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  warehouseId: Scalars['Int']['input'];
};

export type CreateQuantityReturnInputItemline = {
  id: Scalars['String']['input'];
  onhandQuantity?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateReturnInput = {
  approve: Scalars['Boolean']['input'];
  createInbound?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<ReturnItem>>;
  orderID: Scalars['String']['input'];
  returnedAt: Scalars['String']['input'];
  warehouseID: Scalars['Int']['input'];
};

/** Autogenerated input type of CreateRole */
export type CreateRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  permissionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  permissions?: InputMaybe<Array<PermissionInputs>>;
};

/** Autogenerated return type of CreateRole */
export type CreateRolePayload = {
  __typename?: 'CreateRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  role: Role;
};

/** Autogenerated input type of CreateSalesChannelAccount */
export type CreateSalesChannelAccountInput = {
  apiClientKey?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['String']['input']>;
  applicationSecret?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['Int']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  consumerKey?: InputMaybe<Scalars['String']['input']>;
  consumerSecret?: InputMaybe<Scalars['String']['input']>;
  fsId?: InputMaybe<Scalars['String']['input']>;
  mainAccountId?: InputMaybe<Scalars['Int']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  mtaUsername?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  resetAndImport?: InputMaybe<Scalars['Boolean']['input']>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  shopUrl?: InputMaybe<Scalars['String']['input']>;
  storeUrl?: InputMaybe<Scalars['String']['input']>;
  tiktokAccountId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateSalesChannelAccount */
export type CreateSalesChannelAccountPayload = {
  __typename?: 'CreateSalesChannelAccountPayload';
  account: AccountRuby;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateSalesOrderAccount */
export type CreateSalesOrderAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateSalesOrderAccount */
export type CreateSalesOrderAccountPayload = {
  __typename?: 'CreateSalesOrderAccountPayload';
  account: AccountRuby;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateSalesOrder */
export type CreateSalesOrderInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['Int']['input'];
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  dropshipperAttributes?: InputMaybe<DropshipperInputInput>;
  itemLinesAttributes: Array<ItemLinesInputInput>;
  localName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  shippingPrice?: InputMaybe<Scalars['Int']['input']>;
  warehouseId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateSalesOrder */
export type CreateSalesOrderPayload = {
  __typename?: 'CreateSalesOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  order: Order;
};

export type CreateShipmentInput = {
  ordersAttributes?: InputMaybe<Array<InputMaybe<OrderAttribute>>>;
};

export type CreateShipmentPayload = {
  __typename?: 'CreateShipmentPayload';
  failedOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  successOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type CreateShipmentRtsInput = {
  ordersShipmentRTS?: InputMaybe<Array<InputMaybe<OrderShipmentRts>>>;
};

export type CreateWarehouseInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isPos?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWarehousePayload = {
  __typename?: 'CreateWarehousePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
};

export type CrmActionResponse = {
  __typename?: 'CrmActionResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CrmActivity = {
  __typename?: 'CrmActivity';
  Message: Scalars['String']['output'];
  actionType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type CrmAttribute = {
  __typename?: 'CrmAttribute';
  availableValues: Array<Scalars['String']['output']>;
  cardType: CrmCardType;
  dataType: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCustom: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type CrmAttributeActionAttributePayload = {
  __typename?: 'CrmAttributeActionAttributePayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CrmAttributeConnection = {
  __typename?: 'CrmAttributeConnection';
  edges: Array<CrmAttributeEdge>;
  nodes: Array<CrmAttribute>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type CrmAttributeEdge = {
  __typename?: 'CrmAttributeEdge';
  cursor: Scalars['String']['output'];
  node: CrmAttribute;
};

export type CrmAttributeInput = {
  cardType: CrmCardType;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export enum CrmCardType {
  Deal = 'DEAL',
  Ticket = 'TICKET'
}

export type CrmContact = {
  __typename?: 'CrmContact';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: CrmContactType;
};

export type CrmContactInput = {
  ID: Scalars['Int']['input'];
  Type: CrmContactType;
};

export enum CrmContactType {
  Company = 'COMPANY',
  Customer = 'CUSTOMER'
}

export type CrmDeal = {
  __typename?: 'CrmDeal';
  activities: Array<CrmActivity>;
  assignedTo: Scalars['Int']['output'];
  assignedToName: Scalars['String']['output'];
  attributes: Array<CrmAttribute>;
  contacts: Array<CrmContact>;
  createdAt: Scalars['Time']['output'];
  currentStageId: Scalars['Int']['output'];
  currentStageTitle: Scalars['String']['output'];
  dealType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  estimatedDealAmount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerName: Scalars['String']['output'];
  pipelineId: Scalars['Int']['output'];
  pipelineName: Scalars['String']['output'];
  priority: CrmDealPriority;
  quotationId?: Maybe<Scalars['Int']['output']>;
  targetCloseDate: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type CrmDealAttributeInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CrmDealConnection = {
  __typename?: 'CrmDealConnection';
  edges: Array<CrmDealEdge>;
  nodes: Array<CrmDeal>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type CrmDealEdge = {
  __typename?: 'CrmDealEdge';
  cursor: Scalars['String']['output'];
  node: CrmDeal;
};

export type CrmDealFilter = {
  attributes?: InputMaybe<Array<CrmDealAttributeInput>>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  dealType?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  pipelineId?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<CrmDealPriority>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrmDealInput = {
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  attributes?: InputMaybe<Array<CrmDealAttributeInput>>;
  contacts?: InputMaybe<Array<CrmContactInput>>;
  currentStageId: Scalars['Int']['input'];
  dealType?: InputMaybe<Scalars['String']['input']>;
  estimatedDealAmount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  pipelineId: Scalars['Int']['input'];
  priority: CrmDealPriority;
  targetCloseDate?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export enum CrmDealPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type CrmDealUpdateStageInput = {
  id: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
};

export type CrmPipeline = {
  __typename?: 'CrmPipeline';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  ownerName: Scalars['String']['output'];
  profileId: Scalars['Int']['output'];
  type: CrmCardType;
  updatedAt: Scalars['Time']['output'];
};

export type CrmPipelineInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  type: CrmCardType;
};

export type CrmStage = {
  __typename?: 'CrmStage';
  createdAt: Scalars['Time']['output'];
  id: Scalars['Int']['output'];
  pipelineId: Scalars['Int']['output'];
  pipelineName: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  totalValue: Scalars['Float']['output'];
  type: CrmCardType;
  updatedAt: Scalars['Time']['output'];
};

export type CrmStageActionInput = {
  stages: Array<CrmStageInput>;
};

export type CrmStageInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  pipelineId: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type CrmTicket = {
  __typename?: 'CrmTicket';
  activities: Array<CrmActivity>;
  assignedTo: Scalars['Int']['output'];
  assignedToName: Scalars['String']['output'];
  attributes: Array<CrmAttribute>;
  contacts: Array<CrmContact>;
  createdAt: Scalars['Time']['output'];
  currentStageId: Scalars['Int']['output'];
  currentStageTitle: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerName: Scalars['String']['output'];
  pipelineId: Scalars['Int']['output'];
  pipelineName: Scalars['String']['output'];
  priority: CrmTicketPriority;
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type CrmTicketAttributeInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CrmTicketConnection = {
  __typename?: 'CrmTicketConnection';
  edges: Array<CrmTicketEdge>;
  nodes: Array<CrmTicket>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type CrmTicketEdge = {
  __typename?: 'CrmTicketEdge';
  cursor: Scalars['String']['output'];
  node: CrmTicket;
};

export type CrmTicketFilter = {
  assignedToId?: InputMaybe<Scalars['Int']['input']>;
  attributes?: InputMaybe<Array<CrmTicketAttributeInput>>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  pipelineId?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<CrmTicketPriority>;
  source?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrmTicketInput = {
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  attributes?: InputMaybe<Array<CrmTicketAttributeInput>>;
  contacts?: InputMaybe<Array<CrmContactInput>>;
  currentStageId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  pipelineId: Scalars['Int']['input'];
  priority: CrmTicketPriority;
  source?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export enum CrmTicketPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type CrmTicketUpdateStageInput = {
  id: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
};

export type CustomCourier = {
  __typename?: 'CustomCourier';
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  rate: Scalars['Int']['output'];
};

export type CustomCourierInput = {
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  rate: Scalars['Int']['input'];
};

export type CustomPayment = {
  __typename?: 'CustomPayment';
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
};

export type CustomPaymentInput = {
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  customerAddress?: Maybe<CustomerAddress>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  address?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingDistrict?: Maybe<Scalars['String']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  billingPhone?: Maybe<Scalars['String']['output']>;
  billingPostalCode?: Maybe<Scalars['String']['output']>;
  billingProvince?: Maybe<Scalars['String']['output']>;
  billingSubDistrict?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  subDistrict?: Maybe<Scalars['String']['output']>;
};

export type DashboardUser = {
  __typename?: 'DashboardUser';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  role?: Maybe<Role>;
  roleId?: Maybe<Scalars['Int']['output']>;
  settings: Scalars['String']['output'];
};

export type DashboardUserLogin = {
  __typename?: 'DashboardUserLogin';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  loginAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Permissions>>>;
  profileId?: Maybe<Scalars['Int']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  rolePermissions?: Maybe<Array<Maybe<RolePermissions>>>;
  token?: Maybe<Scalars['String']['output']>;
  tokenExpired?: Maybe<Scalars['String']['output']>;
};

export type DataCampaignPerformance = {
  __typename?: 'DataCampaignPerformance';
  audience?: Maybe<Scalars['Int']['output']>;
  delivered?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  readPercentage?: Maybe<Scalars['Int']['output']>;
};

export type DataCourier = {
  __typename?: 'DataCourier';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DataLoginPayload = {
  __typename?: 'DataLoginPayload';
  base?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dashboardUser?: Maybe<DashboardUserLogin>;
};

export type DataPayment = {
  __typename?: 'DataPayment';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  group: Scalars['String']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DateRange = {
  endDate: Scalars['Time']['input'];
  startDate: Scalars['Time']['input'];
};

export type DefaultUserWarehouse = {
  __typename?: 'DefaultUserWarehouse';
  message: Scalars['String']['output'];
  warehouseID?: Maybe<Scalars['Int']['output']>;
};

export type Delete = {
  __typename?: 'Delete';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteArchivedProductPayload = {
  __typename?: 'DeleteArchivedProductPayload';
  message: Scalars['String']['output'];
};

export type DeleteCampaignPayload = {
  __typename?: 'DeleteCampaignPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteDashboardUser */
export type DeleteDashboardUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDashboardUser */
export type DeleteDashboardUserPayload = {
  __typename?: 'DeleteDashboardUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dashboardUser: DashboardUser;
};

export type DeleteLabelPayload = {
  __typename?: 'DeleteLabelPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteListingsPayload = {
  __typename?: 'DeleteListingsPayload';
  failedItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['Any']['output']>;
  successItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DeletePackageInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeletePackagePayload = {
  __typename?: 'DeletePackagePayload';
  failedPackages?: Maybe<Array<Scalars['Int']['output']>>;
  success: Scalars['Boolean']['output'];
  successPackages?: Maybe<Array<Scalars['Int']['output']>>;
};

export type DeletePicklistPayload = {
  __typename?: 'DeletePicklistPayload';
  failedPicklists?: Maybe<Array<Scalars['Int']['output']>>;
  success: Scalars['Boolean']['output'];
  successPicklists?: Maybe<Array<Scalars['Int']['output']>>;
};

export type DeleteProductsPayload = {
  __typename?: 'DeleteProductsPayload';
  failedProducts?: Maybe<Array<Scalars['Int']['output']>>;
  message: Scalars['String']['output'];
  successProducts?: Maybe<Array<Scalars['Int']['output']>>;
};

/** Autogenerated input type of DeleteRole */
export type DeleteRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRole */
export type DeleteRolePayload = {
  __typename?: 'DeleteRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  role: Role;
};

export type DeleteVoucherResponse = {
  __typename?: 'DeleteVoucherResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteWarehouseInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteWarehousePayload = {
  __typename?: 'DeleteWarehousePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
};

export type DeliverySetting = {
  __typename?: 'DeliverySetting';
  type: DeliveryType;
  warehouseIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DeliverySettingInput = {
  type: DeliveryType;
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum DeliveryType {
  Delivery = 'delivery',
  PickUp = 'pick_up'
}

export type District = {
  __typename?: 'District';
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  lon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type DistrictInput = {
  cityId: Scalars['Int']['input'];
};

export type DownloadExcelDocumentResponse = {
  __typename?: 'DownloadExcelDocumentResponse';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Draft = {
  __typename?: 'Draft';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profileId: Scalars['Int']['output'];
  totalSku: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Autogenerated input type of DraftDelete */
export type DraftDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DraftDelete */
export type DraftDeletePayload = {
  __typename?: 'DraftDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  draftDelete: Delete;
};

export type DraftOptionPayload = {
  __typename?: 'DraftOptionPayload';
  option: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DraftProductPayload = {
  __typename?: 'DraftProductPayload';
  category: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  variants?: Maybe<Array<Maybe<DraftVariantPayload>>>;
};

export type DraftVariantPayload = {
  __typename?: 'DraftVariantPayload';
  barcode?: Maybe<Scalars['String']['output']>;
  costPrice?: Maybe<Scalars['Int']['output']>;
  height: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  length: Scalars['Int']['output'];
  options?: Maybe<Array<Maybe<DraftOptionPayload>>>;
  quantity: Scalars['Int']['output'];
  regularPrice: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type DropshipperInputInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['String']['input']>;
};

export type EditPicklistInput = {
  pickerId?: InputMaybe<Scalars['Int']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
};

export type EditPicklistPayload = {
  __typename?: 'EditPicklistPayload';
  message: Scalars['String']['output'];
  picklist?: Maybe<Picklist>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExampleBodyInput = {
  bodyTextNamedParams?: InputMaybe<Array<InputMaybe<TextNamedParamInput>>>;
};

export type ExampleHeaderInput = {
  headerHandle?: InputMaybe<Scalars['String']['input']>;
  headerTextNamedParams?: InputMaybe<Array<InputMaybe<TextNamedParamInput>>>;
};

export type ExportFinanceTransactionInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExportFinanceTransactionPayload = {
  __typename?: 'ExportFinanceTransactionPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExportInvoiceInput = {
  channelEndDate?: InputMaybe<Scalars['String']['input']>;
  channelStartDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type ExportInvoicePayload = {
  __typename?: 'ExportInvoicePayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExportOrderInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type ExportOrderPayload = {
  __typename?: 'ExportOrderPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExportPaymentReceiveInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ExportPaymentReceivePayload = {
  __typename?: 'ExportPaymentReceivePayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExportPicklistInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type ExportPicklistPayload = {
  __typename?: 'ExportPicklistPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExportStockHistoryInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
  warehouseName?: InputMaybe<Scalars['String']['input']>;
};

export type ExportStockHistoryPayload = {
  __typename?: 'ExportStockHistoryPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FailedEvent = {
  __typename?: 'FailedEvent';
  Message: Scalars['String']['output'];
  Total: Scalars['Int']['output'];
  Url: Scalars['String']['output'];
};

export enum FileType {
  Image = 'image',
  Pdf = 'pdf',
  Video = 'video'
}

export type FinanceTransaction = {
  __typename?: 'FinanceTransaction';
  channelId: Scalars['Int']['output'];
  channelOrderId: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  creditAmount?: Maybe<Scalars['Int']['output']>;
  debitAmount?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceId: Scalars['Int']['output'];
  isCancelled: Scalars['Boolean']['output'];
  profileId: Scalars['Int']['output'];
  salesOrderId: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  store: FinanceTransactionStore;
  transactionId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FinanceTransactionConnection = {
  __typename?: 'FinanceTransactionConnection';
  nodes: Array<FinanceTransaction>;
  pageInfo?: Maybe<PageInfoWithOffset>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPageCount?: Maybe<Scalars['Int']['output']>;
};

export type FinanceTransactionFilterBy = {
  stores?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FinanceTransactionStore = {
  __typename?: 'FinanceTransactionStore';
  channelColor?: Maybe<Scalars['String']['output']>;
  channelInitial?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Forecasting = {
  __typename?: 'Forecasting';
  avgQtySold?: Maybe<Scalars['Int']['output']>;
  dayOutOfStock?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  onHandTotal?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Scalars['String']['output']>;
  outOfStockDate?: Maybe<Scalars['Time']['output']>;
  productImage?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  projectedSaleQty?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
};

export type ForecastingConnectionType = {
  __typename?: 'ForecastingConnectionType';
  edges?: Maybe<Array<Maybe<ForecastingEdge>>>;
  nodes?: Maybe<Array<Maybe<Forecasting>>>;
  pageCursors?: Maybe<Array<Maybe<PageCursor>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPageCount?: Maybe<Scalars['Int']['output']>;
};

export type ForecastingEdge = {
  __typename?: 'ForecastingEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Forecasting>;
};

export type ForecastingFilter = {
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ForgotPasswordInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type ForgotPasswordPayload = {
  __typename?: 'ForgotPasswordPayload';
  message: Scalars['String']['output'];
};

export type ForstokChannelInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ForstokWarehouseInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of GenerateRedirect */
export type GenerateRedirectInput = {
  channelId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  storeUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GenerateRedirect */
export type GenerateRedirectPayload = {
  __typename?: 'GenerateRedirectPayload';
  channelId: Scalars['Int']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  redirectUrl: Scalars['String']['output'];
};

export type GetVariantListingActionAvailability = {
  __typename?: 'GetVariantListingActionAvailability';
  group?: Maybe<GetVariantListingActionAvailabilityGroup>;
  name: Scalars['String']['output'];
};

export type GetVariantListingActionAvailabilityGroup = {
  __typename?: 'GetVariantListingActionAvailabilityGroup';
  action: Scalars['String']['output'];
  name: GetVariantListingActionAvailabilityGroupName;
};

export enum GetVariantListingActionAvailabilityGroupName {
  Other = 'other',
  Primary = 'primary'
}

export type GetVariantListingStatus = {
  __typename?: 'GetVariantListingStatus';
  count: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GlobalActivity = {
  __typename?: 'GlobalActivity';
  actionAt: Scalars['Time']['output'];
  actionName: Scalars['String']['output'];
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inProgress: Scalars['Boolean']['output'];
  ipAddress: Scalars['String']['output'];
  isGlobalAction: Scalars['Boolean']['output'];
  processFinishedAt?: Maybe<Scalars['Time']['output']>;
  profileID: Scalars['Int']['output'];
  resultUrl?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  summaries?: Maybe<Array<Maybe<Summary>>>;
  totalCount: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  uploadedAt?: Maybe<Scalars['Time']['output']>;
  userEmail: Scalars['String']['output'];
  userID: Scalars['Int']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type GoodReceive = {
  __typename?: 'GoodReceive';
  confirmedBy: GoodReceiveUser;
  createdAt: Scalars['String']['output'];
  goodReceiveId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  inboundId: Scalars['String']['output'];
  itemLines: Array<GoodReceiveItemLine>;
  newStatus: Scalars['String']['output'];
  oldStatus: Scalars['String']['output'];
  oldWarehouseId: Scalars['Int']['output'];
  putaway: StockInboundPutaway;
  totalActualInboundQty: Scalars['Int']['output'];
  warehouseId: Scalars['String']['output'];
  warehouseName: Scalars['String']['output'];
};

export type GoodReceiveItemLine = {
  __typename?: 'GoodReceiveItemLine';
  deltaQuantity: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  newQuantity: Scalars['Int']['output'];
  newStatus: Scalars['String']['output'];
  oldQuantity: Scalars['Int']['output'];
  oldStatus: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

export type GoodReceiveUser = {
  __typename?: 'GoodReceiveUser';
  dashboardUserId: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ImportInvoiceInput = {
  invoiceId: Scalars['String']['input'];
};

export type ImportInvoicePayload = {
  __typename?: 'ImportInvoicePayload';
  invoiceId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportListingResponse = {
  __typename?: 'ImportListingResponse';
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ImportOrderInput = {
  orderId: Scalars['String']['input'];
};

export type ImportOrderPayload = {
  __typename?: 'ImportOrderPayload';
  message?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportWhatsAppForm = {
  __typename?: 'ImportWhatsAppForm';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum InboundType {
  ManualInbound = 'MANUAL_INBOUND',
  OrderReturn = 'ORDER_RETURN',
  StockTransfer = 'STOCK_TRANSFER'
}

export type IncompleteIntegrationListResponse = {
  __typename?: 'IncompleteIntegrationListResponse';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  stores: Array<StoreV2>;
  total: Scalars['Int']['output'];
};

export type InputActionActiveInactivePayload = {
  ids: Array<Scalars['String']['input']>;
  type: Scalars['Boolean']['input'];
};

export type InputActionBundleProduct = {
  brand: Scalars['String']['input'];
  bundleId?: InputMaybe<Scalars['Int']['input']>;
  bundleVariants: Array<InputBundleVariantProduct>;
  category: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  masterVariant: InputBundleMasterVariant;
  name: Scalars['String']['input'];
  sellingPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type InputActionBundleProductPayload = {
  __typename?: 'InputActionBundleProductPayload';
  brand: Scalars['String']['output'];
  bundleId?: Maybe<Scalars['Int']['output']>;
  bundleVariants: Array<InputBundleVariantProductPayload>;
  category: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  draftId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  kind?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  profileId?: Maybe<Scalars['Int']['output']>;
  sellingPrice?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type InputActionCategoryMapping = {
  category: InputActionCategoryMappingCategory;
  id: Scalars['String']['input'];
  storeId: Scalars['Int']['input'];
};

export type InputActionCategoryMappingCategory = {
  labelArr?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value: Scalars['String']['input'];
  valueArr?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InputActionConfirmLinkingPayload = {
  ids: Array<Scalars['String']['input']>;
  masterLabelSKU?: InputMaybe<Scalars['String']['input']>;
  storeLabelSku: Scalars['String']['input'];
};

export type InputActionConfirmPricePayload = {
  id: Scalars['Int']['input'];
  status: ActionConfirmPriceStatusName;
};

export type InputActionConfirmPriceResponse = {
  __typename?: 'InputActionConfirmPriceResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type InputActionListing = {
  id?: InputMaybe<Scalars['Int']['input']>;
  listing?: InputMaybe<Array<InputActionProductListing>>;
  variants?: InputMaybe<Array<InputActionListingVariant>>;
};

export type InputActionListingPayload = {
  listings: Array<InputActionListing>;
};

export type InputActionListingVariant = {
  id: Scalars['Int']['input'];
  listing?: InputMaybe<Array<InputActionListingVariantListing>>;
  sku: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputActionListingVariantListing = {
  accountId: Scalars['Int']['input'];
  custom?: InputMaybe<Scalars['Any']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputActionListingVariantOption = {
  option: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type InputActionManualLinkingPayload = {
  id: Scalars['String']['input'];
  variants?: InputMaybe<Array<InputActionManualLinkingVariant>>;
};

export type InputActionManualLinkingVariant = {
  id: Scalars['String']['input'];
  masterVariantId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputActionPriceAdjustmentItem = {
  custom?: InputMaybe<Scalars['Any']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  salePrice?: InputMaybe<Scalars['Int']['input']>;
  variantId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputActionPriceAdjustmentPayload = {
  approve?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<InputActionPriceAdjustmentItem>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InputActionPriceListingPayload = {
  id: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  salePrice?: InputMaybe<Scalars['Int']['input']>;
  salePriceEndAt?: InputMaybe<Scalars['String']['input']>;
  salePriceStartAt?: InputMaybe<Scalars['String']['input']>;
};

export type InputActionProductListing = {
  accountId: Scalars['Int']['input'];
  category?: InputMaybe<Scalars['Any']['input']>;
  custom?: InputMaybe<Scalars['Any']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  localId?: InputMaybe<Scalars['String']['input']>;
};

export type InputActionPromotion = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputActionPromotionProduct>>;
  promotionName?: InputMaybe<Scalars['String']['input']>;
  promotionType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type InputActionPromotionProduct = {
  availableQuantity?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  promotionAllocation?: InputMaybe<Scalars['Int']['input']>;
  variantId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputBreadcrumbCategory = {
  channelName: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type InputBundleMasterVariant = {
  height: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  length: Scalars['Int']['input'];
  masterProductId?: InputMaybe<Scalars['String']['input']>;
  masterVariantId?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  salePrice?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  variantName?: InputMaybe<Scalars['String']['input']>;
  weight: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type InputBundleVariantProduct = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  masterProductId?: InputMaybe<Scalars['String']['input']>;
  masterVariantId?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<InputVariantPriceProduct>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  variantName?: InputMaybe<Scalars['String']['input']>;
};

export type InputBundleVariantProductPayload = {
  __typename?: 'InputBundleVariantProductPayload';
  bundleAttribute?: Maybe<InputVariantBundleAttributePayload>;
  height?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  main?: Maybe<Scalars['Boolean']['output']>;
  masterProductId?: Maybe<Scalars['String']['output']>;
  masterVariantId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  variantName?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type InputCreateListing = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<InputCustomField>>>;
  masterProductId?: InputMaybe<Scalars['Int']['input']>;
  profileId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  variants?: InputMaybe<Array<InputMaybe<InputVariantListing>>>;
};

export type InputCreateListingPayload = {
  __typename?: 'InputCreateListingPayload';
  accountId?: Maybe<Scalars['Int']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  customFields?: Maybe<Array<Maybe<InputCustomFieldPayload>>>;
  id: Scalars['ID']['output'];
  masterProductId?: Maybe<Scalars['Int']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  variants?: Maybe<Array<Maybe<InputVariantListingPayload>>>;
};

export type InputCustomField = {
  id?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InputCustomFieldPayload = {
  __typename?: 'InputCustomFieldPayload';
  id?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InputDownloadExcelDocument = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  agentType?: InputMaybe<Scalars['String']['input']>;
  businessHours?: InputMaybe<Scalars['Boolean']['input']>;
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  projectedDays?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputDraftOption = {
  option: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type InputDraftProduct = {
  category: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  variants?: InputMaybe<Array<InputMaybe<InputDraftVariant>>>;
};

export type InputDraftVariant = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  costPrice?: InputMaybe<Scalars['Int']['input']>;
  height: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  length: Scalars['Int']['input'];
  options?: InputMaybe<Array<InputMaybe<InputDraftOption>>>;
  quantity: Scalars['Int']['input'];
  regularPrice: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type InputGetProductBundlesPayload = {
  __typename?: 'InputGetProductBundlesPayload';
  bundleId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  /**  product property  */
  masterVariantId?: Maybe<Scalars['Int']['output']>;
  masterVariantSKU?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  variants?: Maybe<Array<Maybe<ProductBundleVariants>>>;
};

export type InputGetProductListingsPayload = {
  __typename?: 'InputGetProductListingsPayload';
  /**  product property  */
  masterVariantId?: Maybe<Scalars['Int']['output']>;
  masterVariantSKU?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<ProductOption>>>;
  variants?: Maybe<Array<Maybe<ProductListingVariants>>>;
};

export type InputGetVariantListingOptionPayload = {
  __typename?: 'InputGetVariantListingOptionPayload';
  option?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InputGetVariantListingsPayload = {
  __typename?: 'InputGetVariantListingsPayload';
  actionAvailabilities?: Maybe<Array<Maybe<GetVariantListingActionAvailability>>>;
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  /**  image channel property  */
  channelName?: Maybe<Scalars['String']['output']>;
  /**  listing property  */
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isPromotion?: Maybe<Scalars['Boolean']['output']>;
  listingAccount?: Maybe<Scalars['Int']['output']>;
  listingId?: Maybe<Scalars['Int']['output']>;
  listingObjectId?: Maybe<Scalars['String']['output']>;
  liveLink?: Maybe<Scalars['String']['output']>;
  liveLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  localId?: Maybe<Scalars['String']['output']>;
  masterProductId?: Maybe<Scalars['Int']['output']>;
  masterVariantId?: Maybe<Scalars['Int']['output']>;
  navbarId?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<Maybe<InputGetVariantListingOptionPayload>>>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<VariantSalePrice>;
  status?: Maybe<GetVariantListingStatus>;
  storeName?: Maybe<Scalars['String']['output']>;
  storeSku?: Maybe<Scalars['String']['output']>;
  variantListingId?: Maybe<Scalars['Int']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
};

export type InputGetVariantOptionPayload = {
  __typename?: 'InputGetVariantOptionPayload';
  option?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InputGetVariantWarehousePayload = {
  __typename?: 'InputGetVariantWarehousePayload';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  quantityOnHand?: Maybe<Scalars['Int']['output']>;
  reservedQuantity?: Maybe<Scalars['Int']['output']>;
};

export type InputGetVariantsListingPayload = {
  __typename?: 'InputGetVariantsListingPayload';
  accountId?: Maybe<Scalars['Int']['output']>;
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  listingId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<InputGetVariantsListingSalePricePayload>;
};

export type InputGetVariantsListingSalePricePayload = {
  __typename?: 'InputGetVariantsListingSalePricePayload';
  endAt?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['String']['output']>;
};

export type InputGetVariantsPayload = {
  __typename?: 'InputGetVariantsPayload';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  bundleAmountPrice?: Maybe<Scalars['Int']['output']>;
  bundleDiscountType?: Maybe<Scalars['String']['output']>;
  bundleQuantity?: Maybe<Scalars['Int']['output']>;
  bundleRegularPrice?: Maybe<Scalars['Int']['output']>;
  bundleTotalPrice?: Maybe<Scalars['Int']['output']>;
  costPrice?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  listings?: Maybe<Array<Maybe<InputGetVariantsListingPayload>>>;
  masterProductId?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<InputGetVariantOptionPayload>>>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityOnHand?: Maybe<Scalars['Int']['output']>;
  regularPrice?: Maybe<Scalars['Int']['output']>;
  reservedQuantity?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
  warehouse?: Maybe<Array<Maybe<InputGetVariantWarehousePayload>>>;
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type InputImportListing = {
  accountId: Scalars['Int']['input'];
  channelId: Scalars['Int']['input'];
};

export type InputOption = {
  option: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type InputProduct = {
  brand: Scalars['String']['input'];
  category: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variants?: InputMaybe<Array<InputMaybe<InputVariant>>>;
};

export type InputProductListingBrand = {
  accountId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type InputProductListingCustomField = {
  accountId: Scalars['Int']['input'];
  categoryId: Scalars['String']['input'];
};

export type InputUpdateCustomField = {
  id?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InputUpdateCustomFieldPayload = {
  __typename?: 'InputUpdateCustomFieldPayload';
  id?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InputUpdateListing = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<InputUpdateCustomField>>>;
  id: Scalars['ID']['input'];
  masterProductId?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  variants?: InputMaybe<Array<InputMaybe<InputUpdateVariantListing>>>;
};

export type InputUpdateListingPayload = {
  __typename?: 'InputUpdateListingPayload';
  accountId?: Maybe<Scalars['Int']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  customFields?: Maybe<Array<Maybe<InputUpdateCustomFieldPayload>>>;
  id: Scalars['ID']['output'];
  masterProductId?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  variants?: Maybe<Array<Maybe<InputUpdateVariantListingPayload>>>;
};

export type InputUpdateVariantCustomField = {
  id?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InputUpdateVariantCustomFieldPayload = {
  __typename?: 'InputUpdateVariantCustomFieldPayload';
  id?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InputUpdateVariantListing = {
  confirmedLinking?: InputMaybe<Scalars['Boolean']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<InputUpdateVariantCustomField>>>;
  imageUrl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masterSku?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateVariantListingPayload = {
  __typename?: 'InputUpdateVariantListingPayload';
  confirmedLinking?: Maybe<Scalars['Boolean']['output']>;
  customFields?: Maybe<Array<Maybe<InputUpdateVariantCustomFieldPayload>>>;
  imageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  masterSku?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type InputUploadExcelDocument = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputVariant = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  bundle_id?: InputMaybe<Scalars['Int']['input']>;
  costPrice?: InputMaybe<Scalars['Int']['input']>;
  height: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Any']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  length: Scalars['Int']['input'];
  options?: InputMaybe<Array<InputOption>>;
  quantity: Scalars['Int']['input'];
  regularPrice: Scalars['Int']['input'];
  salePrice?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  tax?: InputMaybe<Scalars['Boolean']['input']>;
  total_bundle?: InputMaybe<Scalars['Int']['input']>;
  total_listing?: InputMaybe<Scalars['Int']['input']>;
  variantListingId?: InputMaybe<Scalars['String']['input']>;
  weight: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type InputVariantBundleAttributePayload = {
  __typename?: 'InputVariantBundleAttributePayload';
  price?: Maybe<InputVariantPriceProductPayload>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type InputVariantListing = {
  confirmedLinking?: InputMaybe<Scalars['Boolean']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<InputVariantListingCustomField>>>;
  imageUrl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masterSku?: InputMaybe<Scalars['String']['input']>;
  masterVariantId?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type InputVariantListingCustomField = {
  id?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InputVariantListingCustomFieldPayload = {
  __typename?: 'InputVariantListingCustomFieldPayload';
  id?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InputVariantListingPayload = {
  __typename?: 'InputVariantListingPayload';
  confirmedLinking?: Maybe<Scalars['Boolean']['output']>;
  customFields?: Maybe<Array<Maybe<InputVariantListingCustomFieldPayload>>>;
  imageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  masterSku?: Maybe<Scalars['String']['output']>;
  masterVariantId?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type InputVariantPriceProduct = {
  amount: Scalars['Int']['input'];
  discountType: Scalars['String']['input'];
  regular: Scalars['Int']['input'];
  sale?: InputMaybe<Scalars['Int']['input']>;
  total: Scalars['Int']['input'];
};

export type InputVariantPriceProductPayload = {
  __typename?: 'InputVariantPriceProductPayload';
  amount?: Maybe<Scalars['Int']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  regular?: Maybe<Scalars['Int']['output']>;
  sale?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type InvalidCredential = {
  __typename?: 'InvalidCredential';
  buttonName?: Maybe<Scalars['String']['output']>;
  channelLink: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  popupBodyMessage?: Maybe<Scalars['String']['output']>;
  popupHeaderMessage?: Maybe<Scalars['String']['output']>;
  storeName: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type InventoryConnectionType = {
  __typename?: 'InventoryConnectionType';
  edges: Array<QtyInventoryEdge>;
  nodes: Array<QtyInventory>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type InventoryFilter = {
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InventoryOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type InventorySettingLevel = {
  __typename?: 'InventorySettingLevel';
  batchId: Scalars['Boolean']['output'];
  bin: Scalars['Boolean']['output'];
  expiredDate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serialNumber: Scalars['Boolean']['output'];
};

export type InventorySettings = {
  __typename?: 'InventorySettings';
  level: InventorySettingLevel;
  lowStockAlert: LowStockAlert;
  priorityStore: PriorityStore;
  reservedStockRules: ReservedStockRules;
};

export type Invoice = {
  __typename?: 'Invoice';
  accountID: Scalars['Int']['output'];
  actionAvailabilities?: Maybe<Array<Maybe<ActionAvailability>>>;
  amountReceived: Scalars['Int']['output'];
  balanceDue: Scalars['Int']['output'];
  channelID: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  customerNote?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  dueDate?: Maybe<Scalars['Time']['output']>;
  fee: Scalars['Int']['output'];
  fulfillmentFee: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invoiceDate?: Maybe<Scalars['Time']['output']>;
  invoicePayout?: Maybe<Array<Maybe<InvoicePayout>>>;
  invoiceReference?: Maybe<Scalars['String']['output']>;
  itemLines?: Maybe<Array<InvoiceItemLine>>;
  messageText: Scalars['String']['output'];
  orderInvoice?: Maybe<OrderInvoice>;
  paidAt?: Maybe<Scalars['Time']['output']>;
  payment?: Maybe<Array<Maybe<InvoicePayment>>>;
  payoutByAPI: Scalars['Boolean']['output'];
  profileID: Scalars['Int']['output'];
  promotion: Scalars['Int']['output'];
  rebate: Scalars['Int']['output'];
  receiptCode?: Maybe<Scalars['String']['output']>;
  return?: Maybe<Array<Maybe<Return>>>;
  returnAmount: Scalars['Int']['output'];
  salesperson?: Maybe<Scalars['String']['output']>;
  shipping: Scalars['Int']['output'];
  shippingCustomerID: Scalars['Int']['output'];
  shippingFeeDiff: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
  term?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  vatIn: Scalars['Float']['output'];
  vatOut: Scalars['Float']['output'];
  voucherSeller: Scalars['Int']['output'];
};

/** The connection type for Invoice. */
export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Invoice>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Invoice>;
};

export type InvoiceFilterByInputs = {
  contactId?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentReady?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  stores?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InvoiceItemLine = {
  __typename?: 'InvoiceItemLine';
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  invoiceID: Scalars['Int']['output'];
  itemImageUrl?: Maybe<Scalars['String']['output']>;
  itemLineBundle?: Maybe<Array<Maybe<OrderItemLineBundle>>>;
  itemLineID: Scalars['Int']['output'];
  itemPrice: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  qtyInvoiced: Scalars['Int']['output'];
  qtyOrdered: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Array<Maybe<Status>>>;
  tax?: Maybe<Scalars['Boolean']['output']>;
  taxPrice: Scalars['Int']['output'];
  taxRate?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type InvoicePayment = {
  __typename?: 'InvoicePayment';
  amountReceived: Scalars['Int']['output'];
  balanceDue: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  invoiceID: Scalars['Int']['output'];
  payment?: Maybe<Payment>;
  paymentID: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type InvoicePaymentInput = {
  amountReceived: Scalars['Int']['input'];
  balanceDue: Scalars['Int']['input'];
  channelPaymentDate?: InputMaybe<Scalars['String']['input']>;
  fulfillmentFee: Scalars['Int']['input'];
  invoiceID: Scalars['Int']['input'];
  platformRebate: Scalars['Int']['input'];
  promotion: Scalars['Int']['input'];
  returnAmount?: InputMaybe<Scalars['Int']['input']>;
  serviceFee: Scalars['Int']['input'];
  shipping: Scalars['Int']['input'];
  shippingFeeDiff: Scalars['Int']['input'];
  tax: Scalars['Int']['input'];
  voucherAmount: Scalars['Int']['input'];
};

export type InvoicePayout = {
  __typename?: 'InvoicePayout';
  accountName?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type InvoiceSetting = {
  __typename?: 'InvoiceSetting';
  isAutoCreate?: Maybe<Scalars['Boolean']['output']>;
  isAutoPaid?: Maybe<Scalars['Boolean']['output']>;
  paymentDateOption?: Maybe<Scalars['String']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  statusAutoCreate?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
};

export type ItemLineBundles = {
  itemLineBundleId: Scalars['Int']['input'];
  qtyToReturn: Scalars['Int']['input'];
};

export type ItemLinesAttributes = {
  itemVariantId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  regularPrice: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type ItemLinesInputInput = {
  itemVariantId?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemPriceAdjustment = {
  __typename?: 'ItemPriceAdjustment';
  newPrice?: Maybe<Scalars['Int']['output']>;
  newSalePrice?: Maybe<Scalars['Int']['output']>;
  oldPrice?: Maybe<Scalars['Int']['output']>;
  oldSalePrice?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  saleEndAt?: Maybe<Scalars['String']['output']>;
  saleStartAt?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  store?: Maybe<ProductListingStore>;
};

export type ItemPromotion = {
  __typename?: 'ItemPromotion';
  bundle?: Maybe<Array<Maybe<ItemPromotionBundle>>>;
  discount?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  maxOrder?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type ItemPromotionBundle = {
  __typename?: 'ItemPromotionBundle';
  name?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  totalBundle?: Maybe<Scalars['Int']['output']>;
};

export type ItemTypeNew = {
  __typename?: 'ItemTypeNew';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  masterBrandName?: Maybe<Scalars['String']['output']>;
  masterCategoryName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  optionTypes?: Maybe<Array<OptionType>>;
  profileId: Scalars['ID']['output'];
  variants?: Maybe<Array<ItemVariant>>;
};

export type ItemVariant = {
  __typename?: 'ItemVariant';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  bundle?: Maybe<BundleTypeNew>;
  config?: Maybe<Scalars['String']['output']>;
  costPrice?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  itemId: Scalars['ID']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  listings?: Maybe<Array<Listing>>;
  mainImageUrl?: Maybe<Scalars['String']['output']>;
  masterCatalog?: Maybe<MasterCatalog>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  profileId: Scalars['ID']['output'];
  reservedQuantity?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  variantType?: Maybe<Scalars['String']['output']>;
  warehouseSpaces?: Maybe<Array<WarehouseSpace>>;
};

export type Jurnal = {
  __typename?: 'Jurnal';
  accounts?: Maybe<Scalars['JSON']['output']>;
  taxes?: Maybe<Scalars['JSON']['output']>;
  warehouses?: Maybe<Scalars['JSON']['output']>;
};

export type JurnalAccountInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type JurnalAccountMappingInput = {
  accounts?: InputMaybe<Array<JurnalAccountMappingItemInput>>;
  fullfilmentFee?: InputMaybe<JurnalAccountInput>;
  serviceFee?: InputMaybe<JurnalAccountInput>;
  shippingDifferent?: InputMaybe<JurnalAccountInput>;
  voucherSeller?: InputMaybe<JurnalAccountInput>;
};

export type JurnalAccountMappingItemInput = {
  account?: InputMaybe<JurnalAccountInput>;
  forstokChannel?: InputMaybe<ForstokChannelInput>;
};

export type JurnalMappingInput = {
  accounts?: InputMaybe<JurnalAccountMappingInput>;
  taxes?: InputMaybe<JurnalTaxInput>;
  warehouses?: InputMaybe<JurnalWarehouseMappingInput>;
};

export type JurnalTaxInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type JurnalWarehouseInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type JurnalWarehouseMappingInput = {
  warehouses?: InputMaybe<Array<JurnalWarehouseMappingItemInput>>;
};

export type JurnalWarehouseMappingItemInput = {
  forstokWarehouse?: InputMaybe<ForstokWarehouseInput>;
  jurnalWarehouse?: InputMaybe<JurnalWarehouseInput>;
};

export type Label = {
  __typename?: 'Label';
  createdAt?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  labelDescription?: Maybe<Scalars['String']['output']>;
  labelId?: Maybe<Scalars['Int']['output']>;
  labelName?: Maybe<Scalars['String']['output']>;
  unreply?: Maybe<Scalars['Boolean']['output']>;
  unreplyAll?: Maybe<Scalars['Boolean']['output']>;
  unreplyAllMine?: Maybe<Scalars['Boolean']['output']>;
  unreplyMine?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type LabelConnection = {
  __typename?: 'LabelConnection';
  edges?: Maybe<Array<Maybe<LabelEdge>>>;
  nodes?: Maybe<Array<Maybe<Label>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

export type LabelConversation = {
  __typename?: 'LabelConversation';
  label: Scalars['String']['output'];
  labelID: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
};

export type LabelEdge = {
  __typename?: 'LabelEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Label>;
};

export type LabelInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  labelDescription: Scalars['String']['input'];
  labelId?: InputMaybe<Scalars['Int']['input']>;
  labelName: Scalars['String']['input'];
};

export type LabelRoom = {
  __typename?: 'LabelRoom';
  labelId?: Maybe<Scalars['Int']['output']>;
  labelName?: Maybe<Scalars['String']['output']>;
};

export type LinkChatMessageByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkChatProductByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkChatRoomByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkInvoiceByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkOrderFulfillmentByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkOrderItemLineByInput = {
  name?: InputMaybe<Sort>;
  sku?: InputMaybe<Sort>;
};

export type LinkOrderPromotionByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkPackageByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkPaymentReceivedByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkPicklistByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkPicklistItemLineByInput = {
  name?: InputMaybe<Sort>;
  orderID?: InputMaybe<Sort>;
  qtyOrdered?: InputMaybe<Sort>;
  qtyPicked?: InputMaybe<Sort>;
  sku?: InputMaybe<Sort>;
};

export type LinkProductArchivedByInput = {
  archivedAt?: InputMaybe<Sort>;
};

export type LinkProductByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkProductListingByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type LinkReturnOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type ListAvailabilityGroup = {
  __typename?: 'ListAvailabilityGroup';
  action: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ListCategoryMapping = {
  __typename?: 'ListCategoryMapping';
  details?: Maybe<Array<Maybe<ListCategoryMappingDetail>>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  totalSku: Scalars['Int']['output'];
};

export type ListCategoryMappingDetail = {
  __typename?: 'ListCategoryMappingDetail';
  category?: Maybe<ListCategoryMappingDetailCategory>;
  channelColor?: Maybe<Scalars['String']['output']>;
  channelIcon?: Maybe<Scalars['String']['output']>;
  channelId: Scalars['Int']['output'];
  channelInitial?: Maybe<Scalars['String']['output']>;
  channelName: Scalars['String']['output'];
  hasCategory: Scalars['Boolean']['output'];
  storeId: Scalars['Int']['output'];
  storeName?: Maybe<Scalars['String']['output']>;
};

export type ListCategoryMappingDetailCategory = {
  __typename?: 'ListCategoryMappingDetailCategory';
  labelArr?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value: Scalars['String']['output'];
  valueArr?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ListPriceAvailability = {
  __typename?: 'ListPriceAvailability';
  group?: Maybe<ListAvailabilityGroup>;
  name: Scalars['String']['output'];
};

export type Listing = {
  __typename?: 'Listing';
  account: Account;
  accountId: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  channel: ChannelTypeNew;
  channelCategory?: Maybe<ListingCategory>;
  channelId: Scalars['Int']['output'];
  confirmed: Scalars['Boolean']['output'];
  consignmentQuantity?: Maybe<Scalars['Int']['output']>;
  currentSalePrice?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastLog?: Maybe<Scalars['String']['output']>;
  liveLink?: Maybe<Scalars['String']['output']>;
  localItemId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  promotion?: Maybe<Scalars['Boolean']['output']>;
  qcStatus?: Maybe<ListingQc>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stockAllocations: Array<ListingStockAllocation>;
  syncing: Scalars['Boolean']['output'];
  unconfirmedStatus?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ListingActionAvailability = {
  __typename?: 'ListingActionAvailability';
  group?: Maybe<ListingActionAvailabilityGroup>;
  name: Scalars['String']['output'];
};

export type ListingActionAvailabilityGroup = {
  __typename?: 'ListingActionAvailabilityGroup';
  action: Scalars['String']['output'];
  name: ListingActionAvailabilityGroupName;
};

export enum ListingActionAvailabilityGroupName {
  Other = 'other',
  PendingActions = 'pendingActions',
  Primary = 'primary'
}

export type ListingBrand = {
  __typename?: 'ListingBrand';
  label: Scalars['String']['output'];
  localId?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** The connection type for ListingBrand. */
export type ListingBrandConnection = {
  __typename?: 'ListingBrandConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ListingBrandEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ListingBrand>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ListingBrandEdge = {
  __typename?: 'ListingBrandEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ListingBrand>;
};

export type ListingCategories = {
  __typename?: 'ListingCategories';
  child_categories?: Maybe<Scalars['Any']['output']>;
  id: Scalars['String']['output'];
  lowest: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ListingCategory = {
  __typename?: 'ListingCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tree?: Maybe<Array<Scalars['String']['output']>>;
};

export type ListingContentListing = {
  __typename?: 'ListingContentListing';
  accountId: Scalars['Int']['output'];
  category?: Maybe<CategoryListingContentListing>;
  channelId?: Maybe<Scalars['Int']['output']>;
  custom?: Maybe<Scalars['Any']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  localId?: Maybe<Scalars['String']['output']>;
};

export type ListingCustomHeader = {
  __typename?: 'ListingCustomHeader';
  condition?: Maybe<Scalars['String']['output']>;
  containOfType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fieldType: Scalars['String']['output'];
  groupBy?: Maybe<Scalars['String']['output']>;
  isCreateAble?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<ListingCustomHeaderOption>>;
  schema?: Maybe<Scalars['String']['output']>;
  tips?: Maybe<Scalars['String']['output']>;
  typeData: Scalars['String']['output'];
  validations?: Maybe<ListingCustomHeaderValidation>;
};

export type ListingCustomHeaderOption = {
  __typename?: 'ListingCustomHeaderOption';
  label: Scalars['String']['output'];
  localId?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Array<ListingCustomHeaderOptionData>>;
  value: Scalars['String']['output'];
};

export type ListingCustomHeaderOptionData = {
  __typename?: 'ListingCustomHeaderOptionData';
  label: Scalars['String']['output'];
  localId?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ListingCustomHeaderValidation = {
  __typename?: 'ListingCustomHeaderValidation';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  required: Scalars['Boolean']['output'];
};

export type ListingHeader = {
  __typename?: 'ListingHeader';
  color?: Maybe<Scalars['String']['output']>;
  condition: Scalars['String']['output'];
  fieldType: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  initial?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  mappingCategory?: Maybe<ListingHeaderMappingCategory>;
  name: Scalars['String']['output'];
  typeData: Scalars['String']['output'];
  validations?: Maybe<ListingHeaderValidation>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type ListingHeaderMappingCategory = {
  __typename?: 'ListingHeaderMappingCategory';
  labelArr?: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['String']['output'];
  valueArr?: Maybe<Array<Scalars['Int']['output']>>;
};

export type ListingHeaderValidation = {
  __typename?: 'ListingHeaderValidation';
  required: Scalars['Boolean']['output'];
};

export type ListingPendingAction = {
  __typename?: 'ListingPendingAction';
  TotalEmptySKU?: Maybe<Scalars['Int']['output']>;
  TotalSKUNotMatched?: Maybe<Scalars['Int']['output']>;
  TotalSkuMatched?: Maybe<Scalars['Int']['output']>;
  TotalSkus?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<ListingPendingActionData>>>;
};

export type ListingPendingActionData = {
  __typename?: 'ListingPendingActionData';
  EmptySKU?: Maybe<Scalars['Int']['output']>;
  SKUMatched?: Maybe<Scalars['Int']['output']>;
  SKUNotMatched?: Maybe<Scalars['Int']['output']>;
  channel?: Maybe<ListingPendingActionDataChannel>;
};

export type ListingPendingActionDataChannel = {
  __typename?: 'ListingPendingActionDataChannel';
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
};

export type ListingQc = {
  __typename?: 'ListingQc';
  hasPassed?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<ListingQcMessage>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ListingQcMessage = {
  __typename?: 'ListingQcMessage';
  bodies?: Maybe<Array<ListingQcMessageBody>>;
  headers?: Maybe<Array<Scalars['String']['output']>>;
};

export type ListingQcMessageBody = {
  __typename?: 'ListingQcMessageBody';
  hasPassed?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ListingStockAllocation = {
  __typename?: 'ListingStockAllocation';
  endAt: Scalars['ISO8601DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  reservedQuantity: Scalars['Int']['output'];
  startAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ListingSummary = {
  __typename?: 'ListingSummary';
  data: Array<ListingSummaryData>;
  total: Scalars['Int']['output'];
  totalInStock: Scalars['Int']['output'];
  totalOutOfStock: Scalars['Int']['output'];
};

export type ListingSummaryData = {
  __typename?: 'ListingSummaryData';
  all: Scalars['Int']['output'];
  color?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactive: Scalars['Int']['output'];
  initials: Scalars['String']['output'];
  live: Scalars['Int']['output'];
  missingImage: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  outOfStock: Scalars['String']['output'];
  pendingAction: Scalars['Int']['output'];
  qcPending: Scalars['Int']['output'];
  qcRejected: Scalars['Int']['output'];
};

export type ListingTotalSkus = {
  __typename?: 'ListingTotalSkus';
  TotalBundle?: Maybe<Scalars['Int']['output']>;
  TotalFailed?: Maybe<Scalars['Int']['output']>;
  TotalInactive?: Maybe<Scalars['Int']['output']>;
  TotalLive?: Maybe<Scalars['Int']['output']>;
  TotalMasterProduct?: Maybe<Scalars['Int']['output']>;
  TotalSkus?: Maybe<Scalars['Int']['output']>;
  TotalSold?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<ListingTotalSkusData>>>;
};

export type ListingTotalSkusData = {
  __typename?: 'ListingTotalSkusData';
  All?: Maybe<Scalars['Int']['output']>;
  Failed?: Maybe<Scalars['Int']['output']>;
  Inactive?: Maybe<Scalars['Int']['output']>;
  Live?: Maybe<Scalars['Int']['output']>;
  Sold?: Maybe<Scalars['Int']['output']>;
  channel?: Maybe<ListingTotalSkusDataChannel>;
};

export type ListingTotalSkusDataChannel = {
  __typename?: 'ListingTotalSkusDataChannel';
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  navbarId?: Maybe<Scalars['Int']['output']>;
};

export type ListingVariantContentListing = {
  __typename?: 'ListingVariantContentListing';
  accountId: Scalars['Int']['output'];
  channelId?: Maybe<Scalars['Int']['output']>;
  custom?: Maybe<Scalars['Any']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type LiveView = {
  __typename?: 'LiveView';
  conversationMetrics: ConversationMetrics;
  conversationsByAgents: Array<AgentConversation>;
  conversationsByLabels: Array<LabelConversation>;
  conversationsByStores: Array<StoreConversation>;
};

export type LiveViewChannel = {
  __typename?: 'LiveViewChannel';
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId: Scalars['String']['output'];
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  channelName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  storeId: Scalars['Int']['output'];
  storeName: Scalars['String']['output'];
};

export type LiveViewFilters = {
  agentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  dateRange?: InputMaybe<DateRange>;
  labelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationCampaignPerformance = {
  __typename?: 'LocationCampaignPerformance';
  city?: Maybe<Array<Maybe<DataCampaignPerformance>>>;
  profince?: Maybe<Array<Maybe<DataCampaignPerformance>>>;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  data?: Maybe<DataLoginPayload>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LowStockAlert = {
  __typename?: 'LowStockAlert';
  emailAt: Scalars['Int']['output'];
  emailRecipients: Array<Maybe<Scalars['String']['output']>>;
  isActive: Scalars['Boolean']['output'];
  quantity: Scalars['Int']['output'];
};

export type LowStockAlertInput = {
  emailAt?: InputMaybe<Scalars['Int']['input']>;
  emailRecipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isActive: Scalars['Boolean']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkAsCompleted = {
  __typename?: 'MarkAsCompleted';
  failedOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type MarkAsCompletedInput = {
  ordersAttributes?: InputMaybe<Array<InputMaybe<OrderAttributeComplete>>>;
};

export type MarkAsDelivered = {
  __typename?: 'MarkAsDelivered';
  failedOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  limitSummary?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type MarkAsDeliveredInput = {
  ordersAttributes?: InputMaybe<Array<InputMaybe<OrderAttributeDelivery>>>;
};

export type MarkAsIncomplete = {
  __typename?: 'MarkAsIncomplete';
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MarkAsIncompleteInput = {
  id: Scalars['Int']['input'];
};

export type MarkAsPaidInput = {
  ordersAttributes?: InputMaybe<Array<InputMaybe<OrderAttribute>>>;
};

export type MarkAsPaidPayload = {
  __typename?: 'MarkAsPaidPayload';
  errors: Scalars['String']['output'];
  success: Scalars['String']['output'];
};

export type MarkAsReadyToShipInput = {
  ordersReadyToShip?: InputMaybe<Array<InputMaybe<OrderAttributeReadyToShip>>>;
};

export type MarkAsReadyToShipPayload = {
  __typename?: 'MarkAsReadyToShipPayload';
  failedOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  limitSummary?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type MassPaymentPop = {
  __typename?: 'MassPaymentPop';
  countAvail: Scalars['Int']['output'];
  countNotAvail: Scalars['Int']['output'];
  countTotal: Scalars['Int']['output'];
};

export type MasterCatalog = {
  __typename?: 'MasterCatalog';
  barcode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
};

export type MasterCategory = {
  __typename?: 'MasterCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<OptionCategory>>>;
  profileID?: Maybe<Scalars['Int']['output']>;
};

export type MasterDataDummy = {
  __typename?: 'MasterDataDummy';
  id: Scalars['ID']['output'];
};

export type MasterTag = {
  __typename?: 'MasterTag';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type MessagePerformance = {
  __typename?: 'MessagePerformance';
  amountSpent?: Maybe<Scalars['Float']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  clicksPercentage?: Maybe<Scalars['Int']['output']>;
  costPerClick?: Maybe<Scalars['Float']['output']>;
  costPerDelivered?: Maybe<Scalars['Float']['output']>;
  messageDelivered?: Maybe<Scalars['Int']['output']>;
  messageDeliveredPercentage?: Maybe<Scalars['Int']['output']>;
  messageRead?: Maybe<Scalars['Int']['output']>;
  messageReadPercentage?: Maybe<Scalars['Int']['output']>;
  messageSent?: Maybe<Scalars['Int']['output']>;
};

export enum MessageStatus {
  Completed = 'completed',
  Delivered = 'delivered',
  Error = 'error',
  Failed = 'failed',
  Pending = 'pending',
  Read = 'read',
  Sent = 'sent'
}

export type MessageTotalClick = {
  __typename?: 'MessageTotalClick';
  clicks?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum MessageType {
  Audio = 'audio',
  Document = 'document',
  Flow = 'flow',
  FlowResponse = 'flowResponse',
  Image = 'image',
  ImageWithCaption = 'imageWithCaption',
  Location = 'location',
  Menu = 'menu',
  Order = 'order',
  Product = 'product',
  Sticker = 'sticker',
  Text = 'text',
  Video = 'video'
}

export type MessageUniqueClick = {
  __typename?: 'MessageUniqueClick';
  clicks?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  ActionLinkListing: ActionListingPayload;
  actionAccount?: Maybe<ActionAccountPayload>;
  actionActiveInactive: ActionActiveInactiveResponse;
  actionBundleProduct: ActionBundleProductResponse;
  actionCategoryMapping: ActionCategoryMappingResponse;
  actionChatStore: ActionChatStorePayload;
  actionChatWhatsAppTemplate: ActionChatWhatsAppTemplatePayload;
  actionConfirmLinking: ActionConfirmLinkingResponse;
  actionConfirmPriceAdjustment: InputActionConfirmPriceResponse;
  actionConfirmReceived?: Maybe<ConfirmReceive>;
  actionCreateQuantity?: Maybe<CreateQuantity>;
  actionListing: ActionListingResponse;
  actionManualLinking: ActionManualLinkingResponse;
  actionPriceAdjustment: ActionPriceAdjustmentResponse;
  actionPriceListing: ActionPriceListingResponse;
  actionProducts: ActionProductsPayload;
  actionPromotion: ActionPromotionResponse;
  actionSalesOrder?: Maybe<ActionSalesOrder>;
  actionUnreadRoom?: Maybe<ActionUnreadRoomPayload>;
  actionVoucher: Voucher;
  archivedProducts: ArchivedProductsPayload;
  cancelOrder?: Maybe<OrderCancelPayload>;
  chatActionAutoReply?: Maybe<ChatActionAutoReplyPayload>;
  chatActionCampaign?: Maybe<ActionCampaignResponse>;
  chatActionLabel?: Maybe<ActionLabelPayload>;
  chatActionLimit: ChatActionLimitPayload;
  chatActionTopup: ChatActionTopupPayload;
  chatAddToCart?: Maybe<ChatAddToCartResponse>;
  chatAuthorize?: Maybe<ChatAuthorizePayload>;
  chatDeleteAutoReply?: Maybe<ChatDeleteAutoReplyPayload>;
  chatDeleteCampaign?: Maybe<DeleteCampaignPayload>;
  chatDeleteLabel?: Maybe<DeleteLabelPayload>;
  chatKnowledgeFinalizeDocument: ChatKnowledgeFilePayload;
  chatKnowledgeRegisterDocument: ChatKnowledgeFilePayload;
  chatKnowledgeResolveConfirmation: ChatKnowledgeConversationPayload;
  chatKnowledgeSendMessage: ChatKnowledgeConversationPayload;
  chatKnowledgeUploadDocument: ChatKnowledgeConversationPayload;
  chatLabelAssign?: Maybe<ChatLabelAssignPayload>;
  chatSendMessage?: Maybe<ChatSendMessagePayload>;
  chatShopeeConnectUrl: ChatShopeeConnectUrlPayload;
  chatSync?: Maybe<ChatSyncPayload>;
  chatUser: ChatUserPayload;
  contactAction?: Maybe<ContactActionResponse>;
  contactActionAttribute?: Maybe<ContactActionAttributePayload>;
  contactAddressAction?: Maybe<ContactActionResponse>;
  contactAddressDelete?: Maybe<ContactActionResponse>;
  contactCompanyAction: ContactCompanyActionResponse;
  contactCompanyAddressAction?: Maybe<ContactCompanyActionResponse>;
  contactCompanyAddressDelete?: Maybe<ContactCompanyActionResponse>;
  contactDeleteAttribute?: Maybe<ContactActionAttributePayload>;
  createAccount?: Maybe<CreateAccountPayload>;
  createCustomer?: Maybe<CreateCustomerPayload>;
  createDashboardUser?: Maybe<CreateDashboardUserPayload>;
  createExcelPaymentReceive?: Maybe<CreateExcelPaymentReceive>;
  createFinanceTransaction?: Maybe<CreateFinanceTransactionResult>;
  createFullPaymentReceive?: Maybe<CreateFullPaymentReceive>;
  createGeneratePaymentReceive?: Maybe<CreateGeneratePaymentReceive>;
  createListingProducts?: Maybe<Array<InputCreateListingPayload>>;
  createMassPaymentReceive?: Maybe<CreateMassPaymentReceive>;
  createPackage?: Maybe<CreatePackagePayload>;
  createPicklist?: Maybe<CreatePicklistPayload>;
  createPrintPicklist?: Maybe<CreatePicklistPayload>;
  createReturn: ReturnResponse;
  createRole?: Maybe<CreateRolePayload>;
  createSalesChannelAccount?: Maybe<CreateSalesChannelAccountPayload>;
  createSalesOrder?: Maybe<CreateSalesOrderPayload>;
  createSalesOrderAccount?: Maybe<CreateSalesOrderAccountPayload>;
  createShipment?: Maybe<CreateShipmentPayload>;
  createShipmentRTS?: Maybe<CreateShipmentPayload>;
  createTodo: Todo;
  createWarehouse?: Maybe<CreateWarehousePayload>;
  crmAttributeAction?: Maybe<CrmAttributeActionAttributePayload>;
  crmAttributeDelete?: Maybe<CrmAttributeActionAttributePayload>;
  crmDealAction?: Maybe<CrmActionResponse>;
  crmDealDelete?: Maybe<CrmActionResponse>;
  crmDealUpdateStage?: Maybe<CrmActionResponse>;
  crmPipelineAction?: Maybe<CrmActionResponse>;
  crmPipelineDelete?: Maybe<CrmActionResponse>;
  crmStageAction?: Maybe<CrmActionResponse>;
  crmStageDelete?: Maybe<CrmActionResponse>;
  crmTicketAction?: Maybe<CrmActionResponse>;
  crmTicketDelete?: Maybe<CrmActionResponse>;
  crmTicketUpdateStage?: Maybe<CrmActionResponse>;
  deleteArchivedProduct: DeleteArchivedProductPayload;
  deleteDashboardUser?: Maybe<DeleteDashboardUserPayload>;
  deleteListings: DeleteListingsPayload;
  deletePackage?: Maybe<DeletePackagePayload>;
  deletePicklist?: Maybe<DeletePicklistPayload>;
  deleteProducts: DeleteProductsPayload;
  deleteRole?: Maybe<DeleteRolePayload>;
  deleteVoucher: DeleteVoucherResponse;
  deleteWarehouse?: Maybe<DeleteWarehousePayload>;
  /** Delete draft */
  draftDelete?: Maybe<DraftDeletePayload>;
  editPicklist?: Maybe<EditPicklistPayload>;
  exportFinanceTransaction?: Maybe<ExportFinanceTransactionPayload>;
  exportInvoice?: Maybe<ExportInvoicePayload>;
  exportOrder?: Maybe<ExportOrderPayload>;
  exportPaymentReceive?: Maybe<ExportPaymentReceivePayload>;
  exportPicklist?: Maybe<ExportPicklistPayload>;
  exportStockHistory?: Maybe<ExportStockHistoryPayload>;
  forgotPassword?: Maybe<ForgotPasswordPayload>;
  generateRedirect?: Maybe<GenerateRedirectPayload>;
  importListing: ImportListingResponse;
  importUpdateInvoice?: Maybe<ImportInvoicePayload>;
  importUpdateOrder?: Maybe<ImportOrderPayload>;
  login?: Maybe<LoginPayload>;
  markAsCompleted?: Maybe<MarkAsCompleted>;
  markAsDelivered?: Maybe<MarkAsDelivered>;
  markAsIncomplete?: Maybe<MarkAsIncomplete>;
  markAsPaid?: Maybe<MarkAsPaidPayload>;
  markAsReadyToShip?: Maybe<MarkAsReadyToShipPayload>;
  orderPrintDelivery?: Maybe<OrderPrintPayload>;
  orderPrintInvoice?: Maybe<OrderPrintPayload>;
  orderPrintSales?: Maybe<OrderPrintPayload>;
  orderQuotationAction?: Maybe<CrmActionResponse>;
  orderQuotationDelete?: Maybe<CrmActionResponse>;
  orderQuotationPrint?: Maybe<CrmActionResponse>;
  orderQuotationUpdateStatus?: Maybe<CrmActionResponse>;
  printOrder?: Maybe<PrintOrderPayload>;
  printPacklist?: Maybe<PrintPacklistPayload>;
  printPicklist?: Maybe<PrintPicklistPayload>;
  registerNotificationDevice: RegisterNotificationDevicePayload;
  reportingMutationCustomHeader?: Maybe<ReportingMutationCustomHeaderResponse>;
  roomAssign?: Maybe<RoomAssignPayload>;
  roomAssignBulk?: Maybe<RoomAssignBulkPayload>;
  roomResolve?: Maybe<RoomResolvePayload>;
  salesAgentPayoutSetStatus?: Maybe<SalesAgentPayoutActionResponse>;
  salesAgentRegister?: Maybe<SalesAgentActionResponse>;
  salesAgentSetStatus?: Maybe<SalesAgentActionResponse>;
  saveDraftProduct: SaveDraftProductPayload;
  setDefaultWarehouse?: Maybe<SetDefaultWarehousePayload>;
  setStatusWarehouse?: Maybe<SetStatusWarehousePayload>;
  settingPicklist?: Maybe<SettingPicklistPayload>;
  settingUserWarehouse?: Maybe<SettingUserWarehousePayload>;
  stockSync: StockSyncPayload;
  syncChannelWarehouses?: Maybe<ChannelWarehouseSyncResponse>;
  syncOrder?: Maybe<SyncOrderPayload>;
  unarchivedProducts: UnarchivedProductsPayload;
  updateAccount?: Maybe<UpdateAccountPayload>;
  updateDashboardUser?: Maybe<UpdateDashboardUserPayload>;
  updateInventorySettings?: Maybe<UpdateInventorySettings>;
  updateInvoice?: Maybe<UpdateInvoicePayload>;
  updateInvoiceStatus?: Maybe<UpdateInvoiceStatus>;
  updateListingProducts?: Maybe<Array<InputUpdateListingPayload>>;
  updateOrderNote?: Maybe<UpdateOrderNote>;
  updatePicklist?: Maybe<UpdatePicklistPayload>;
  updatePicklistSN?: Maybe<UpdatePicklistPayload>;
  updatePrintDocumentSettings?: Maybe<UpdatePrintDocumentSettings>;
  updateRole?: Maybe<UpdateRolePayload>;
  updateShipper?: Maybe<UpdateShipperUserPayload>;
  updateStatusReturn: ReturnResponse;
  updateTax?: Maybe<UpdateTaxPayload>;
  updateWarehouse?: Maybe<UpdateWarehousePayload>;
  uploadExcelDocument: UploadExcelDocumentResponse;
};


export type MutationActionLinkListingArgs = {
  input: ActionListingInput;
};


export type MutationActionAccountArgs = {
  input: ActionAccountInput;
};


export type MutationActionActiveInactiveArgs = {
  input: InputActionActiveInactivePayload;
};


export type MutationActionBundleProductArgs = {
  input: InputActionBundleProduct;
};


export type MutationActionCategoryMappingArgs = {
  input: InputActionCategoryMapping;
};


export type MutationActionChatStoreArgs = {
  input: ActionChatStoreInput;
};


export type MutationActionChatWhatsAppTemplateArgs = {
  input: ActionChatWhatsAppTemplateInput;
};


export type MutationActionConfirmLinkingArgs = {
  input: InputActionConfirmLinkingPayload;
};


export type MutationActionConfirmPriceAdjustmentArgs = {
  input: InputActionConfirmPricePayload;
};


export type MutationActionConfirmReceivedArgs = {
  input?: InputMaybe<ConfirmReceiveInput>;
};


export type MutationActionCreateQuantityArgs = {
  input?: InputMaybe<CreateQuantityInput>;
};


export type MutationActionListingArgs = {
  input: InputActionListingPayload;
};


export type MutationActionManualLinkingArgs = {
  input: InputActionManualLinkingPayload;
};


export type MutationActionPriceAdjustmentArgs = {
  input: InputActionPriceAdjustmentPayload;
};


export type MutationActionPriceListingArgs = {
  input?: InputMaybe<Array<InputActionPriceListingPayload>>;
};


export type MutationActionProductsArgs = {
  input: ActionProductsInput;
};


export type MutationActionPromotionArgs = {
  input: InputActionPromotion;
};


export type MutationActionSalesOrderArgs = {
  input: ActionSalesOrderInput;
};


export type MutationActionUnreadRoomArgs = {
  input: ActionUnreadRoomInput;
};


export type MutationActionVoucherArgs = {
  input: ActionVoucherInput;
};


export type MutationArchivedProductsArgs = {
  input: ArchivedProductsInput;
};


export type MutationCancelOrderArgs = {
  input: OrderCancelInput;
};


export type MutationChatActionAutoReplyArgs = {
  input: ChatActionAutoReplyInput;
};


export type MutationChatActionCampaignArgs = {
  input: ActionCampaignInput;
};


export type MutationChatActionLabelArgs = {
  input: LabelInput;
};


export type MutationChatActionLimitArgs = {
  input: ChatActionLimitInput;
};


export type MutationChatActionTopupArgs = {
  input: ChatActionTopupInput;
};


export type MutationChatAddToCartArgs = {
  input: ChatAddToCartInput;
};


export type MutationChatAuthorizeArgs = {
  input: ChatAuthorizeInput;
};


export type MutationChatDeleteAutoReplyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationChatDeleteCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};


export type MutationChatDeleteLabelArgs = {
  labelId: Scalars['Int']['input'];
};


export type MutationChatKnowledgeFinalizeDocumentArgs = {
  input: ChatKnowledgeFinalizeDocumentInput;
};


export type MutationChatKnowledgeRegisterDocumentArgs = {
  input: ChatKnowledgeRegisterDocumentInput;
};


export type MutationChatKnowledgeResolveConfirmationArgs = {
  input: ChatKnowledgeResolveConfirmationInput;
};


export type MutationChatKnowledgeSendMessageArgs = {
  input: ChatKnowledgeSendMessageInput;
};


export type MutationChatKnowledgeUploadDocumentArgs = {
  input: ChatKnowledgeUploadDocumentInput;
};


export type MutationChatLabelAssignArgs = {
  input: ChatLabelAssignInput;
};


export type MutationChatSendMessageArgs = {
  input: Array<ChatSendMessageInput>;
};


export type MutationChatShopeeConnectUrlArgs = {
  storeId: Scalars['Int']['input'];
};


export type MutationChatSyncArgs = {
  input: ChatSyncInput;
};


export type MutationChatUserArgs = {
  orderId: Scalars['Int']['input'];
  storeId: Scalars['Int']['input'];
};


export type MutationContactActionArgs = {
  input?: InputMaybe<ContactInput>;
};


export type MutationContactActionAttributeArgs = {
  input?: InputMaybe<AttributeInput>;
};


export type MutationContactAddressActionArgs = {
  input?: InputMaybe<ContactAddressInput>;
};


export type MutationContactAddressDeleteArgs = {
  addressId: Scalars['Int']['input'];
};


export type MutationContactCompanyActionArgs = {
  input: ContactCompanyInput;
};


export type MutationContactCompanyAddressActionArgs = {
  input?: InputMaybe<ContactCompanyAddressInput>;
};


export type MutationContactCompanyAddressDeleteArgs = {
  addressId: Scalars['Int']['input'];
};


export type MutationContactDeleteAttributeArgs = {
  attributeId: Scalars['Int']['input'];
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateDashboardUserArgs = {
  input: CreateDashboardUserInput;
};


export type MutationCreateExcelPaymentReceiveArgs = {
  input?: InputMaybe<CreateExcelPaymentReceiveInput>;
};


export type MutationCreateFinanceTransactionArgs = {
  input: CreateFinanceTransactionInput;
};


export type MutationCreateFullPaymentReceiveArgs = {
  input?: InputMaybe<CreateFullPaymentReceiveInput>;
};


export type MutationCreateGeneratePaymentReceiveArgs = {
  input?: InputMaybe<CreateGeneratePaymentReceiveInput>;
};


export type MutationCreateListingProductsArgs = {
  input: Array<InputCreateListing>;
};


export type MutationCreateMassPaymentReceiveArgs = {
  input?: InputMaybe<CreateMassPaymentReceiveInput>;
};


export type MutationCreatePackageArgs = {
  input: CreatePackageInput;
};


export type MutationCreatePicklistArgs = {
  input: CreatePicklistInput;
};


export type MutationCreatePrintPicklistArgs = {
  input: CreatePicklistInput;
};


export type MutationCreateReturnArgs = {
  input: CreateReturnInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateSalesChannelAccountArgs = {
  input: CreateSalesChannelAccountInput;
};


export type MutationCreateSalesOrderArgs = {
  input: CreateSalesOrderInput;
};


export type MutationCreateSalesOrderAccountArgs = {
  input: CreateSalesOrderAccountInput;
};


export type MutationCreateShipmentArgs = {
  input: CreateShipmentInput;
};


export type MutationCreateShipmentRtsArgs = {
  input: CreateShipmentRtsInput;
};


export type MutationCreateTodoArgs = {
  input: NewTodo;
};


export type MutationCreateWarehouseArgs = {
  input: CreateWarehouseInput;
};


export type MutationCrmAttributeActionArgs = {
  input?: InputMaybe<CrmAttributeInput>;
};


export type MutationCrmAttributeDeleteArgs = {
  attributeId: Scalars['Int']['input'];
};


export type MutationCrmDealActionArgs = {
  input?: InputMaybe<CrmDealInput>;
};


export type MutationCrmDealDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCrmDealUpdateStageArgs = {
  input?: InputMaybe<CrmDealUpdateStageInput>;
};


export type MutationCrmPipelineActionArgs = {
  input?: InputMaybe<CrmPipelineInput>;
};


export type MutationCrmPipelineDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCrmStageActionArgs = {
  input?: InputMaybe<CrmStageActionInput>;
};


export type MutationCrmStageDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCrmTicketActionArgs = {
  input?: InputMaybe<CrmTicketInput>;
};


export type MutationCrmTicketDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCrmTicketUpdateStageArgs = {
  input?: InputMaybe<CrmTicketUpdateStageInput>;
};


export type MutationDeleteArchivedProductArgs = {
  input: DeleteArchivedProductInput;
};


export type MutationDeleteDashboardUserArgs = {
  input: DeleteDashboardUserInput;
};


export type MutationDeleteListingsArgs = {
  input: DeleteListingsInput;
};


export type MutationDeletePackageArgs = {
  input: DeletePackageInput;
};


export type MutationDeletePicklistArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationDeleteProductsArgs = {
  input: DeleteProductsInput;
};


export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};


export type MutationDeleteVoucherArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWarehouseArgs = {
  input: DeleteWarehouseInput;
};


export type MutationDraftDeleteArgs = {
  input: DraftDeleteInput;
};


export type MutationEditPicklistArgs = {
  id: Scalars['Int']['input'];
  input: EditPicklistInput;
};


export type MutationExportFinanceTransactionArgs = {
  input?: InputMaybe<ExportFinanceTransactionInput>;
};


export type MutationExportInvoiceArgs = {
  input?: InputMaybe<ExportInvoiceInput>;
};


export type MutationExportOrderArgs = {
  input?: InputMaybe<ExportOrderInput>;
};


export type MutationExportPaymentReceiveArgs = {
  input?: InputMaybe<ExportPaymentReceiveInput>;
};


export type MutationExportPicklistArgs = {
  input?: InputMaybe<ExportPicklistInput>;
};


export type MutationExportStockHistoryArgs = {
  input?: InputMaybe<ExportStockHistoryInput>;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationGenerateRedirectArgs = {
  input: GenerateRedirectInput;
};


export type MutationImportListingArgs = {
  input: InputImportListing;
};


export type MutationImportUpdateInvoiceArgs = {
  input: ImportInvoiceInput;
};


export type MutationImportUpdateOrderArgs = {
  input: ImportOrderInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMarkAsCompletedArgs = {
  input: MarkAsCompletedInput;
};


export type MutationMarkAsDeliveredArgs = {
  input: MarkAsDeliveredInput;
};


export type MutationMarkAsIncompleteArgs = {
  input?: InputMaybe<MarkAsIncompleteInput>;
};


export type MutationMarkAsPaidArgs = {
  input: MarkAsPaidInput;
};


export type MutationMarkAsReadyToShipArgs = {
  input: MarkAsReadyToShipInput;
};


export type MutationOrderPrintDeliveryArgs = {
  input: OrderPrintInput;
};


export type MutationOrderPrintInvoiceArgs = {
  input: OrderPrintInput;
};


export type MutationOrderPrintSalesArgs = {
  input: OrderPrintInput;
};


export type MutationOrderQuotationActionArgs = {
  input?: InputMaybe<OrderQuotationInput>;
};


export type MutationOrderQuotationDeleteArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationOrderQuotationPrintArgs = {
  input?: InputMaybe<OrderQuotationPrint>;
};


export type MutationOrderQuotationUpdateStatusArgs = {
  input?: InputMaybe<OrderQuotationUpdateStatusInput>;
};


export type MutationPrintOrderArgs = {
  input: PrintOrderInput;
};


export type MutationPrintPacklistArgs = {
  input: PrintPacklistInput;
};


export type MutationPrintPicklistArgs = {
  input: PrintPicklistInput;
};


export type MutationRegisterNotificationDeviceArgs = {
  input: RegisterNotificationDeviceInput;
};


export type MutationReportingMutationCustomHeaderArgs = {
  input: Array<ReportingMutationCustomHeaderInput>;
};


export type MutationRoomAssignArgs = {
  input: RoomAssignInput;
};


export type MutationRoomAssignBulkArgs = {
  input: RoomAssignBulkInput;
};


export type MutationRoomResolveArgs = {
  input: RoomResolveInput;
};


export type MutationSalesAgentPayoutSetStatusArgs = {
  id: Scalars['Int']['input'];
  status: SalesAgentPayoutActionStatus;
};


export type MutationSalesAgentRegisterArgs = {
  input: SalesAgentRegisterInput;
};


export type MutationSalesAgentSetStatusArgs = {
  id: Scalars['Int']['input'];
  status: SalesAgentActionStatus;
};


export type MutationSaveDraftProductArgs = {
  input: SaveDraftInput;
};


export type MutationSetDefaultWarehouseArgs = {
  input: SetDefaultWarehouseInput;
};


export type MutationSetStatusWarehouseArgs = {
  input: SetStatusWarehouseInput;
};


export type MutationSettingPicklistArgs = {
  input: SettingPicklistInput;
};


export type MutationSettingUserWarehouseArgs = {
  input: SettingUserWarehouseInput;
};


export type MutationStockSyncArgs = {
  input: StockSyncInput;
};


export type MutationSyncChannelWarehousesArgs = {
  storeId: Scalars['Int']['input'];
};


export type MutationSyncOrderArgs = {
  input: SyncOrderInput;
};


export type MutationUnarchivedProductsArgs = {
  input: UnarchivedProductsInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateDashboardUserArgs = {
  input: UpdateDashboardUserInput;
};


export type MutationUpdateInventorySettingsArgs = {
  input?: InputMaybe<UpdateInventorySettingsInput>;
};


export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};


export type MutationUpdateInvoiceStatusArgs = {
  input: UpdateInvoiceStatusInput;
};


export type MutationUpdateListingProductsArgs = {
  input: Array<InputUpdateListing>;
};


export type MutationUpdateOrderNoteArgs = {
  input: UpdateOrderNoteInput;
};


export type MutationUpdatePicklistArgs = {
  input: UpdatePicklistInput;
};


export type MutationUpdatePicklistSnArgs = {
  input: UpdatePicklistInput;
};


export type MutationUpdatePrintDocumentSettingsArgs = {
  input: UpdatePrintDocumentSettingsInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateShipperArgs = {
  input: UpdateShipperUserInput;
};


export type MutationUpdateStatusReturnArgs = {
  input: UpdateStatusReturnInput;
};


export type MutationUpdateTaxArgs = {
  input: UpdateTaxInput;
};


export type MutationUpdateWarehouseArgs = {
  input: UpdateWarehouseInput;
};


export type MutationUploadExcelDocumentArgs = {
  input: InputUploadExcelDocument;
};

export type NewTodo = {
  text: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type NotificationDevice = {
  __typename?: 'NotificationDevice';
  appName: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  deviceId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fcmToken: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastSeenAt: Scalars['Time']['output'];
  platform: Scalars['String']['output'];
  profileId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Time']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type Option = {
  __typename?: 'Option';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OptionCategory = {
  __typename?: 'OptionCategory';
  optionType?: Maybe<Scalars['String']['output']>;
  optionValue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OptionType = {
  __typename?: 'OptionType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Option>>;
};

export type OptionVariantContentListing = {
  __typename?: 'OptionVariantContentListing';
  option?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  account?: Maybe<ProfileChannelAssociation>;
  accountId: Scalars['Int']['output'];
  accountName: Scalars['String']['output'];
  address?: Maybe<OrderAddress>;
  advancePackage?: Maybe<Scalars['Boolean']['output']>;
  cancelReasons?: Maybe<Array<Maybe<CancelReason>>>;
  cashless: Scalars['Boolean']['output'];
  channelColor: Scalars['String']['output'];
  channelGroupId?: Maybe<Scalars['Int']['output']>;
  channelId: Scalars['Int']['output'];
  channelImage: Scalars['String']['output'];
  channelInitials: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  cod: Scalars['Boolean']['output'];
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  customer?: Maybe<Customer>;
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  deliveryType: Scalars['String']['output'];
  discShippingPlatform: Scalars['Int']['output'];
  discShippingSeller: Scalars['Int']['output'];
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountReason: Scalars['String']['output'];
  documentPackageSlip: Scalars['String']['output'];
  documentShippingLabel: Scalars['String']['output'];
  dropship: Scalars['Boolean']['output'];
  dropshipper?: Maybe<OrderDropshipper>;
  fulfillmentType?: Maybe<Scalars['String']['output']>;
  fulfillments?: Maybe<Array<Maybe<OrderFulfillment>>>;
  grandTotal?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  idCode?: Maybe<Scalars['String']['output']>;
  insuranceAmount?: Maybe<Scalars['Int']['output']>;
  invoiceNumber: Scalars['String']['output'];
  invoiced?: Maybe<Scalars['Boolean']['output']>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  isMarkAsPaid?: Maybe<Scalars['Boolean']['output']>;
  isPOS?: Maybe<Scalars['Boolean']['output']>;
  itemLines?: Maybe<Array<OrderItemLine>>;
  localId: Scalars['String']['output'];
  localName: Scalars['String']['output'];
  logisticService: Scalars['String']['output'];
  messageText?: Maybe<Scalars['String']['output']>;
  methodPayment?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderPayout?: Maybe<Array<Maybe<OrderPayout>>>;
  orderedAt?: Maybe<Scalars['Time']['output']>;
  packDetail?: Maybe<PackDetail>;
  packages?: Maybe<Array<Maybe<Package>>>;
  packed: Scalars['Int']['output'];
  paid?: Maybe<Scalars['Boolean']['output']>;
  paidAmount?: Maybe<Scalars['Int']['output']>;
  paidShippingPrice: Scalars['Int']['output'];
  payment?: Maybe<Array<Maybe<OrderPayment>>>;
  paymentLink?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  paymentTerm?: Maybe<Scalars['String']['output']>;
  payout?: Maybe<Scalars['Boolean']['output']>;
  picked: Scalars['Int']['output'];
  picklists?: Maybe<Array<Maybe<Picklist>>>;
  posStatus?: Maybe<Scalars['String']['output']>;
  printTrackingBookingNumber: Scalars['String']['output'];
  printTrackingCompany: Scalars['String']['output'];
  printTrackingNumber?: Maybe<Scalars['String']['output']>;
  printed: Scalars['Int']['output'];
  profile: Profile;
  profileId?: Maybe<Scalars['Int']['output']>;
  readyToPrint?: Maybe<Scalars['Boolean']['output']>;
  rebateToSeller?: Maybe<Scalars['Int']['output']>;
  returns?: Maybe<Array<Maybe<Return>>>;
  serviceType: Scalars['String']['output'];
  shipped?: Maybe<Scalars['Boolean']['output']>;
  shippingLabelImages?: Maybe<ShippingLabelImages>;
  shippingPrice?: Maybe<Scalars['Int']['output']>;
  source: Scalars['String']['output'];
  staffName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderStatus>;
  statusId: Scalars['ID']['output'];
  store?: Maybe<OrderStore>;
  subtotal: Scalars['Int']['output'];
  sumQty: Scalars['Int']['output'];
  taxPrice?: Maybe<Scalars['Int']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  totalPrice: Scalars['Int']['output'];
  totalVoucher?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  voucherCode: Scalars['String']['output'];
  voucherPlatform: Scalars['Int']['output'];
  voucherSeller: Scalars['Int']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
};

export type OrderActivity = {
  __typename?: 'OrderActivity';
  actionAt: Scalars['Time']['output'];
  actionName: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inProgress: Scalars['Boolean']['output'];
  ipAddress: Scalars['String']['output'];
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  orderID: Scalars['Int']['output'];
  profileID: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userEmail: Scalars['String']['output'];
  userID: Scalars['Int']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coordinate?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  subDistrict?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type OrderAttribute = {
  orderID: Scalars['Int']['input'];
};

export type OrderAttributeCancel = {
  cancelledQuantity?: InputMaybe<Array<InputMaybe<CancelQuantity>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  reasonCode: Scalars['String']['input'];
  shopCloseEndDate?: InputMaybe<Scalars['String']['input']>;
  shopCloseNote?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAttributeComplete = {
  channelID?: InputMaybe<Scalars['Int']['input']>;
  orderID: Scalars['Int']['input'];
};

export type OrderAttributeDelivery = {
  channelID?: InputMaybe<Scalars['Int']['input']>;
  orderID: Scalars['Int']['input'];
};

export type OrderAttributeReadyToShip = {
  orderId: Scalars['Int']['input'];
  pickupAddressId?: InputMaybe<Scalars['String']['input']>;
  pickupTimeslotId?: InputMaybe<Scalars['String']['input']>;
  trackingCompany?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCancelInput = {
  ordersCancel?: InputMaybe<Array<InputMaybe<OrderAttributeCancel>>>;
};

export type OrderCancelPayload = {
  __typename?: 'OrderCancelPayload';
  failedOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type OrderChartSupport = {
  __typename?: 'OrderChartSupport';
  orders: Array<OrderChartSupportData>;
  timeFormat: Scalars['String']['output'];
};

export type OrderChartSupportData = {
  __typename?: 'OrderChartSupportData';
  label: Scalars['String']['output'];
  totalPrice?: Maybe<Scalars['BigInt']['output']>;
};

export type OrderChartSupportDataV2 = {
  __typename?: 'OrderChartSupportDataV2';
  label: Scalars['String']['output'];
  totalPrice?: Maybe<Scalars['Int']['output']>;
};

export type OrderChartSupportFilterByV2 = {
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OrderChartSupportV2 = {
  __typename?: 'OrderChartSupportV2';
  orders: Array<OrderChartSupportDataV2>;
  timeFormat: Scalars['String']['output'];
};

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

export type OrderDropshipper = {
  __typename?: 'OrderDropshipper';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderID: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['Int']['output']>;
  proviceCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  subDistrict?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

export type OrderFilterByInputs = {
  advancePackage?: InputMaybe<Scalars['Boolean']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  cod?: InputMaybe<Scalars['Boolean']['input']>;
  consignment?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Array<Scalars['String']['input']>>;
  couriers?: InputMaybe<Array<Scalars['String']['input']>>;
  packed?: InputMaybe<Scalars['Int']['input']>;
  picked?: InputMaybe<Scalars['Int']['input']>;
  printed?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  stores?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderFulfillment = {
  __typename?: 'OrderFulfillment';
  bookingCode?: Maybe<Scalars['String']['output']>;
  consignment?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  deliveryTrackingCompany?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemLines?: Maybe<Array<Maybe<OrderItemLineFulfillment>>>;
  localId?: Maybe<Scalars['String']['output']>;
  logisticDestinationCode?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<Package>;
  printed?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Status>;
  statusId?: Maybe<Scalars['Int']['output']>;
  totalPrint?: Maybe<Scalars['Int']['output']>;
  trackingCompany?: Maybe<Scalars['String']['output']>;
  trackingLogo?: Maybe<Scalars['String']['output']>;
  trackingLogoColor?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type OrderFulfillmentConnection = {
  __typename?: 'OrderFulfillmentConnection';
  edges?: Maybe<Array<Maybe<OrderFulfillmentEdge>>>;
  nodes?: Maybe<Array<Maybe<OrderFulfillment>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

export type OrderFulfillmentEdge = {
  __typename?: 'OrderFulfillmentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<OrderFulfillment>;
};

export type OrderFulfillmentFilterByInputs = {
  couriers?: InputMaybe<Array<Scalars['String']['input']>>;
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderInvoice = {
  __typename?: 'OrderInvoice';
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  feeName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoice?: Maybe<Invoice>;
  invoiceID: Scalars['Int']['output'];
  order?: Maybe<Order>;
  orderID: Scalars['Int']['output'];
  rebate?: Maybe<Scalars['Int']['output']>;
  subtotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPrint?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type OrderItemLine = {
  __typename?: 'OrderItemLine';
  addressName?: Maybe<Scalars['String']['output']>;
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  bins?: Maybe<Array<Maybe<Bin>>>;
  consignment?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  deliveryShippingProvider?: Maybe<Scalars['String']['output']>;
  deliveryShippingProviderType?: Maybe<Scalars['String']['output']>;
  fulfillmentItemLine?: Maybe<OrderItemLineFulfillment>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  itemImageUrl?: Maybe<Scalars['String']['output']>;
  itemNote?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  itemVariantId?: Maybe<Scalars['Int']['output']>;
  localId?: Maybe<Scalars['String']['output']>;
  localVariantId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  orderItemLineBundles?: Maybe<Array<Maybe<OrderItemLineBundle>>>;
  orderedAt?: Maybe<Scalars['Time']['output']>;
  packageItemLine?: Maybe<PackageItemLine>;
  packedQuantity?: Maybe<Scalars['Int']['output']>;
  picklistItemLine?: Maybe<PicklistItemLine>;
  price?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityPacked?: Maybe<Scalars['Int']['output']>;
  quantityPicked?: Maybe<Scalars['Int']['output']>;
  quantityReturned?: Maybe<Scalars['Int']['output']>;
  quantityShipped?: Maybe<Scalars['Int']['output']>;
  quantityToPick?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shippingProvider?: Maybe<Scalars['String']['output']>;
  shippingProviderType?: Maybe<Scalars['String']['output']>;
  shippingType?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  slaConfirm?: Maybe<Scalars['Time']['output']>;
  slaShipping?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<Array<Maybe<Status>>>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  taxPrice?: Maybe<Scalars['Int']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  tooltipStatus?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  totalVoucher?: Maybe<Scalars['Int']['output']>;
  trackingLogo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
  voucherCode?: Maybe<Scalars['String']['output']>;
  voucherPlatform?: Maybe<Scalars['Int']['output']>;
  voucherSeller?: Maybe<Scalars['Int']['output']>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
  warehouseSpace?: Maybe<WarehouseSpace>;
  warehouseSpaceId?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type OrderItemLineBundle = {
  __typename?: 'OrderItemLineBundle';
  barcode?: Maybe<Scalars['String']['output']>;
  bins?: Maybe<Array<Maybe<Bin>>>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  itemNote?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  itemVariantId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  orderItemLine?: Maybe<OrderItemLine>;
  orderItemLineId?: Maybe<Scalars['Int']['output']>;
  orderedAt?: Maybe<Scalars['Time']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  quantityInvoiced?: Maybe<Scalars['Int']['output']>;
  quantityPacked?: Maybe<Scalars['Int']['output']>;
  quantityPicked?: Maybe<Scalars['Int']['output']>;
  quantityReturned?: Maybe<Scalars['Int']['output']>;
  quantityShipped?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sku?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
  warehouseSpace?: Maybe<WarehouseSpace>;
  warehouseSpaceId?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for OrderItemLine. */
export type OrderItemLineConnection = {
  __typename?: 'OrderItemLineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderItemLineEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrderItemLine>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type OrderItemLineEdge = {
  __typename?: 'OrderItemLineEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<OrderItemLine>;
};

export type OrderItemLineFilterByInputs = {
  orderID?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderItemLineFulfillment = {
  __typename?: 'OrderItemLineFulfillment';
  consignment?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  fulfillment?: Maybe<OrderFulfillment>;
  fulfillmentId: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  itemNote?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  localIds?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderItemLine?: Maybe<OrderItemLine>;
  orderItemLineId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  serialNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Status>;
  statusId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type OrderItemLineStatus = {
  __typename?: 'OrderItemLineStatus';
  createdAt?: Maybe<Scalars['Time']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  orderItemLine?: Maybe<OrderItemLine>;
  orderItemLineId: Scalars['Int']['output'];
  orderedAt?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<OrderStatus>;
  statusId: Scalars['Int']['output'];
};

export type OrderPayment = {
  __typename?: 'OrderPayment';
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  orderedAt?: Maybe<Scalars['Time']['output']>;
  paidAt?: Maybe<Scalars['Time']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  payoutAmount?: Maybe<Scalars['Int']['output']>;
  payoutAt?: Maybe<Scalars['Time']['output']>;
  serviceFee?: Maybe<Scalars['Float']['output']>;
  statusId: Scalars['Int']['output'];
  verifiedAt?: Maybe<Scalars['Time']['output']>;
};

export enum OrderPaymentTerm {
  Net_7 = 'NET_7',
  Net_14 = 'NET_14',
  Net_15 = 'NET_15',
  Net_30 = 'NET_30',
  Net_60 = 'NET_60',
  PaymentAfterDelivery = 'PAYMENT_AFTER_DELIVERY',
  PaymentBeforeDelivery = 'PAYMENT_BEFORE_DELIVERY'
}

export type OrderPayout = {
  __typename?: 'OrderPayout';
  accountName?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type OrderPicklist = {
  __typename?: 'OrderPicklist';
  createdAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  picklist?: Maybe<Picklist>;
  picklistId?: Maybe<Scalars['Int']['output']>;
  totalPrint?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type OrderPrintInput = {
  orderIds: Array<Scalars['Int']['input']>;
};

export type OrderPrintPayload = {
  __typename?: 'OrderPrintPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type OrderQuotation = {
  __typename?: 'OrderQuotation';
  contactId: Scalars['Int']['output'];
  contactName: Scalars['String']['output'];
  contactType: CrmContactType;
  createdAt: Scalars['Time']['output'];
  customDiscount: Scalars['Float']['output'];
  customShippingAmount: Scalars['Float']['output'];
  customerAddress: OrderQuotationAddress;
  grandTotal: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  idCode?: Maybe<Scalars['String']['output']>;
  itemlines: Array<OrderQuotationItemline>;
  notes: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  paymentTerm: OrderQuotationPaymentTerm;
  reference?: Maybe<Scalars['String']['output']>;
  status: OrderQuotationStatus;
  store: OrderQuotationStore;
  subtotal: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type OrderQuotationAddress = {
  __typename?: 'OrderQuotationAddress';
  address: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  long: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  subdistrict?: Maybe<SubDistrict>;
  subdistrict_id: Scalars['Int']['output'];
};

export type OrderQuotationAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  subdistrictId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderQuotationConnection = {
  __typename?: 'OrderQuotationConnection';
  edges: Array<OrderQuotationEdge>;
  nodes: Array<OrderQuotation>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type OrderQuotationEdge = {
  __typename?: 'OrderQuotationEdge';
  cursor: Scalars['String']['output'];
  node: OrderQuotation;
};

export type OrderQuotationFilter = {
  contactId?: InputMaybe<Scalars['Int']['input']>;
  contactType?: InputMaybe<CrmContactType>;
  status?: InputMaybe<OrderQuotationStatusFilter>;
};

export type OrderQuotationInput = {
  contactId: Scalars['Int']['input'];
  contactType: CrmContactType;
  customDiscount?: InputMaybe<Scalars['Float']['input']>;
  customShippingAmount?: InputMaybe<Scalars['Float']['input']>;
  dealId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemlines: Array<OrderQuotationItemlineInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentTerm?: InputMaybe<OrderQuotationPaymentTerm>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status: OrderQuotationStatus;
  storeId: Scalars['Int']['input'];
};

export type OrderQuotationItemline = {
  __typename?: 'OrderQuotationItemline';
  description?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isCustomItem?: Maybe<Scalars['Boolean']['output']>;
  itemVariantId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  regularPrice: Scalars['Float']['output'];
  sellingPrice: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
};

export type OrderQuotationItemlineInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  itemVariantId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  regularPrice?: InputMaybe<Scalars['Float']['input']>;
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
};

export enum OrderQuotationPaymentTerm {
  Net_7 = 'NET_7',
  Net_14 = 'NET_14',
  Net_15 = 'NET_15',
  Net_30 = 'NET_30',
  Net_60 = 'NET_60',
  PaymentAfterDelivery = 'PAYMENT_AFTER_DELIVERY',
  PaymentBeforeDelivery = 'PAYMENT_BEFORE_DELIVERY'
}

export type OrderQuotationPrint = {
  ids: Array<Scalars['Int']['input']>;
};

export enum OrderQuotationSearchBy {
  QuotationId = 'quotation_id'
}

export enum OrderQuotationStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Open = 'OPEN',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export enum OrderQuotationStatusFilter {
  Accepted = 'ACCEPTED',
  All = 'ALL',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Open = 'OPEN',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export type OrderQuotationStore = {
  __typename?: 'OrderQuotationStore';
  address?: Maybe<OrderQuotationAddress>;
  channelColor: Scalars['String']['output'];
  channelId: Scalars['Int']['output'];
  channelImage: Scalars['String']['output'];
  channelInitials: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  companyLogo: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  phone: Scalars['String']['output'];
  profileId: Scalars['Int']['output'];
  storeIcon: Scalars['String']['output'];
  storeId: Scalars['String']['output'];
  storeName: Scalars['String']['output'];
};

export enum OrderQuotationUpdateStatus {
  Accept = 'accept',
  Cancel = 'cancel',
  Confirm = 'confirm',
  Reject = 'reject',
  Sent = 'sent'
}

export type OrderQuotationUpdateStatusInput = {
  ids: Array<Scalars['Int']['input']>;
  status: OrderQuotationUpdateStatus;
};

export type OrderShipmentRts = {
  channelID?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  pickupAddressId?: InputMaybe<Scalars['String']['input']>;
  pickupTimeslotId?: InputMaybe<Scalars['String']['input']>;
  trackingCompany?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrderStatus = {
  __typename?: 'OrderStatus';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderStore = {
  __typename?: 'OrderStore';
  address?: Maybe<OrderStoreAddress>;
  channelColor: Scalars['String']['output'];
  channelId: Scalars['Int']['output'];
  channelImage: Scalars['String']['output'];
  channelInitials: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  companyLogo: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  phone: Scalars['String']['output'];
  profileId: Scalars['Int']['output'];
  storeIcon: Scalars['String']['output'];
  storeId: Scalars['String']['output'];
  storeName: Scalars['String']['output'];
};

export type OrderStoreAddress = {
  __typename?: 'OrderStoreAddress';
  address: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  long: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  subdistrict?: Maybe<SubDistrict>;
  subdistrict_id: Scalars['Int']['output'];
};

export type OrderToFulfill = {
  __typename?: 'OrderToFulfill';
  data: Array<OrderToFulfillData>;
  total: OrderToFulfillTotal;
};

export type OrderToFulfillData = {
  __typename?: 'OrderToFulfillData';
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId: Scalars['Int']['output'];
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  notShippedOrders: Scalars['Int']['output'];
  openOrders: Scalars['Int']['output'];
  pendingOrders: Scalars['Int']['output'];
  readyToShipOrders: Scalars['Int']['output'];
  storeId: Scalars['ID']['output'];
  storeName: Scalars['String']['output'];
};

export type OrderToFulfillTotal = {
  __typename?: 'OrderToFulfillTotal';
  totalNotShipped: Scalars['Int']['output'];
  totalOpen: Scalars['Int']['output'];
  totalOrders: Scalars['Int']['output'];
  totalPending: Scalars['Int']['output'];
  totalReadyToShip: Scalars['Int']['output'];
};

export enum OrderType {
  Custom = 'custom',
  Omni = 'omni'
}

export type PackDetail = {
  __typename?: 'PackDetail';
  couriers?: Maybe<Array<Maybe<PackDetailCourier>>>;
  isCourierChangeable?: Maybe<Scalars['Boolean']['output']>;
  shipping?: Maybe<PackDetailShipping>;
  shippingType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PackDetailAddress = {
  __typename?: 'PackDetailAddress';
  address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  timeSlots?: Maybe<Array<Maybe<PackDetailTimeslot>>>;
};

export type PackDetailCourier = {
  __typename?: 'PackDetailCourier';
  addresses?: Maybe<Array<Maybe<PackDetailAddress>>>;
  awbFulfillStatus?: Maybe<Scalars['String']['output']>;
  awbPrintStatus?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PackDetailShipping = {
  __typename?: 'PackDetailShipping';
  awb?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Array<Scalars['String']['output']>>;
};

export type PackDetailTimeslot = {
  __typename?: 'PackDetailTimeslot';
  date: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PackPop = {
  __typename?: 'PackPop';
  orders?: Maybe<Array<Maybe<Order>>>;
};

export type Package = {
  __typename?: 'Package';
  createdAt?: Maybe<Scalars['Time']['output']>;
  creator?: Maybe<DashboardUser>;
  creatorId?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Time']['output']>;
  fulfillment?: Maybe<OrderFulfillment>;
  fulfillmentId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  packageItemLines?: Maybe<Array<Maybe<PackageItemLine>>>;
  pickPack?: Maybe<Array<Maybe<PicklistPackage>>>;
  printed?: Maybe<Scalars['Int']['output']>;
  profileId: Scalars['Int']['output'];
  refId?: Maybe<Scalars['String']['output']>;
  totalPrint?: Maybe<Scalars['Int']['output']>;
  totalQty?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  warehouse?: Maybe<Warehouse>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
};

export type PackageActivity = {
  __typename?: 'PackageActivity';
  actionAt: Scalars['Time']['output'];
  actionName: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inProgress: Scalars['Boolean']['output'];
  ipAddress: Scalars['String']['output'];
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  packageID: Scalars['Int']['output'];
  profileID: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userEmail: Scalars['String']['output'];
  userID: Scalars['Int']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type PackageConnection = {
  __typename?: 'PackageConnection';
  edges?: Maybe<Array<Maybe<PackageEdge>>>;
  nodes?: Maybe<Array<Maybe<Package>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

export type PackageEdge = {
  __typename?: 'PackageEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Package>;
};

export type PackageFilterByInputs = {
  couriers?: InputMaybe<Array<Scalars['String']['input']>>;
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  stores?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PackageItemLine = {
  __typename?: 'PackageItemLine';
  barcode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  itemImageUrl?: Maybe<Scalars['String']['output']>;
  itemNote?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  itemVariantId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderItemLine?: Maybe<OrderItemLine>;
  orderItemLineId?: Maybe<Scalars['Int']['output']>;
  package?: Maybe<Package>;
  packageId?: Maybe<Scalars['Int']['output']>;
  packageItemLineBundles?: Maybe<Array<Maybe<PackageItemLineBundle>>>;
  picklistItemLineId?: Maybe<Scalars['Int']['output']>;
  qtyOrdered?: Maybe<Scalars['Int']['output']>;
  qtyPacked?: Maybe<Scalars['Int']['output']>;
  qtyToPacked?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sku?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type PackageItemLineBundle = {
  __typename?: 'PackageItemLineBundle';
  barcode?: Maybe<Scalars['String']['output']>;
  bundleId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  itemImageUrl?: Maybe<Scalars['String']['output']>;
  itemNote?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  itemVariantId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderItemLine?: Maybe<OrderItemLine>;
  orderItemLineId?: Maybe<Scalars['Int']['output']>;
  packageItemLineId?: Maybe<Scalars['Int']['output']>;
  picklistItemLineId?: Maybe<Scalars['Int']['output']>;
  qtyOrdered?: Maybe<Scalars['Int']['output']>;
  qtyPacked?: Maybe<Scalars['Int']['output']>;
  qtyToPacked?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sku?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type PageCursor = {
  __typename?: 'PageCursor';
  endCursor: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  startCursor: Scalars['String']['output'];
};

export type PageCursors = {
  __typename?: 'PageCursors';
  endCursor: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  startCursor: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageInfoWithOffset = {
  __typename?: 'PageInfoWithOffset';
  currentPage?: Maybe<Scalars['Int']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type Pages = {
  __typename?: 'Pages';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  amountReceived?: Maybe<Scalars['Int']['output']>;
  balanceDue?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  paidAt?: Maybe<Scalars['Time']['output']>;
  paymentMethod: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type PaymentReceived = {
  __typename?: 'PaymentReceived';
  accountId: Scalars['Int']['output'];
  accountName: Scalars['String']['output'];
  amountReceived: Scalars['Int']['output'];
  channelColor: Scalars['String']['output'];
  channelId: Scalars['Int']['output'];
  channelImage: Scalars['String']['output'];
  channelInitials: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
  totalInvoices: Scalars['Int']['output'];
};

/** The connection type for PaymentReceived. */
export type PaymentReceivedConnection = {
  __typename?: 'PaymentReceivedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentReceivedEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PaymentReceived>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type PaymentReceivedEdge = {
  __typename?: 'PaymentReceivedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PaymentReceived>;
};

export type PaymentReceivedFilterByInputs = {
  stores?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum PaymentType {
  Manual = 'manual',
  Xendit = 'xendit'
}

export type PayoutChannel = {
  __typename?: 'PayoutChannel';
  channelPaymentDate?: Maybe<Scalars['Time']['output']>;
  fulfillmentFee: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  invoiceId: Scalars['Int']['output'];
  order?: Maybe<Order>;
  orderId: Scalars['Int']['output'];
  platformRebate: Scalars['Int']['output'];
  promotion: Scalars['Int']['output'];
  returnAmount: Scalars['Int']['output'];
  serviceFee: Scalars['Int']['output'];
  shipping: Scalars['Int']['output'];
  shippingFeeDiff: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  tax: Scalars['Int']['output'];
  triable: Scalars['Boolean']['output'];
  voucherAmount: Scalars['Int']['output'];
};

export type PendingOrder = {
  __typename?: 'PendingOrder';
  data: Array<PendingOrderData>;
  totalPendingOrders?: Maybe<Scalars['String']['output']>;
};

export type PendingOrderData = {
  __typename?: 'PendingOrderData';
  color?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pendingOrders: Scalars['Int']['output'];
  pendingOrders024: Scalars['Int']['output'];
  pendingOrders48More: Scalars['Int']['output'];
  pendingOrders2448: Scalars['Int']['output'];
  storeId: Scalars['Int']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  enableWarehouse: Scalars['Boolean']['output'];
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PermissionInputs = {
  id: Scalars['Int']['input'];
  warehouseIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Permissions = {
  __typename?: 'Permissions';
  code?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PickPop = {
  __typename?: 'PickPop';
  orders?: Maybe<Array<Maybe<Order>>>;
  refId: Scalars['String']['output'];
  unpickId?: Maybe<Array<Maybe<Order>>>;
};

export type Picklist = {
  __typename?: 'Picklist';
  actionAvailabilities?: Maybe<Array<Maybe<ActionAvailability>>>;
  actionButton?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  creator?: Maybe<DashboardUser>;
  creatorId?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderPicklist?: Maybe<Array<Maybe<OrderPicklist>>>;
  picker?: Maybe<DashboardUser>;
  pickerId?: Maybe<Scalars['Int']['output']>;
  picklistItemLines?: Maybe<Array<Maybe<PicklistItemLine>>>;
  profileId: Scalars['Int']['output'];
  refId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PicklistStatus>;
  statusId: Scalars['Int']['output'];
  totalQty?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  warehouse?: Maybe<Warehouse>;
  warehouseId: Scalars['Int']['output'];
};

export type PicklistActivity = {
  __typename?: 'PicklistActivity';
  actionAt: Scalars['Time']['output'];
  actionName: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inProgress: Scalars['Boolean']['output'];
  ipAddress: Scalars['String']['output'];
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  picklistID: Scalars['Int']['output'];
  profileID: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userEmail: Scalars['String']['output'];
  userID: Scalars['Int']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type PicklistConnection = {
  __typename?: 'PicklistConnection';
  edges?: Maybe<Array<Maybe<PicklistEdge>>>;
  nodes?: Maybe<Array<Maybe<Picklist>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

export type PicklistEdge = {
  __typename?: 'PicklistEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Picklist>;
};

export type PicklistFilterByInputs = {
  statusId?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PicklistItemLine = {
  __typename?: 'PicklistItemLine';
  barcode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  itemImageUrl?: Maybe<Scalars['String']['output']>;
  itemNote?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  itemVariantId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  orderItemLine?: Maybe<OrderItemLine>;
  orderItemLineId?: Maybe<Scalars['Int']['output']>;
  picklist?: Maybe<Picklist>;
  picklistId?: Maybe<Scalars['Int']['output']>;
  picklistItemLineBundles?: Maybe<Array<Maybe<PicklistItemLineBundle>>>;
  qtyOrdered?: Maybe<Scalars['Int']['output']>;
  qtyPicked?: Maybe<Scalars['Int']['output']>;
  qtyRemaining?: Maybe<Scalars['Int']['output']>;
  qtyToPick?: Maybe<Scalars['Int']['output']>;
  qtyToPickSN?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  serialNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PicklistStatus>;
  statusId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type PicklistItemLineBundle = {
  __typename?: 'PicklistItemLineBundle';
  barcode?: Maybe<Scalars['String']['output']>;
  bins?: Maybe<Array<Maybe<Bin>>>;
  bundleId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  itemImageUrl?: Maybe<Scalars['String']['output']>;
  itemNote?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  itemVariantId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  orderItemLine?: Maybe<OrderItemLine>;
  orderItemLineBundle?: Maybe<OrderItemLineBundle>;
  orderItemLineId?: Maybe<Scalars['Int']['output']>;
  picklistItemLine?: Maybe<PicklistItemLine>;
  picklistItemLineId?: Maybe<Scalars['Int']['output']>;
  qtyOrdered?: Maybe<Scalars['Int']['output']>;
  qtyPicked?: Maybe<Scalars['Int']['output']>;
  qtyRemaining?: Maybe<Scalars['Int']['output']>;
  qtyToPick?: Maybe<Scalars['Int']['output']>;
  qtyToPickSN?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  serialNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PicklistStatus>;
  statusId: Scalars['Int']['output'];
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

/** The connection type for PicklistItemLine. */
export type PicklistItemLineConnection = {
  __typename?: 'PicklistItemLineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PicklistItemLineEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PicklistItemLine>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type PicklistItemLineEdge = {
  __typename?: 'PicklistItemLineEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PicklistItemLine>;
};

export type PicklistItemLineFilterByInputs = {
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  picklistID?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PicklistPackage = {
  __typename?: 'PicklistPackage';
  id: Scalars['Int']['output'];
  packageId?: Maybe<Scalars['Int']['output']>;
  picklistId?: Maybe<Scalars['Int']['output']>;
};

export type PicklistStatus = {
  __typename?: 'PicklistStatus';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PriceAdjustment = {
  __typename?: 'PriceAdjustment';
  actionAvailabilities?: Maybe<Array<Maybe<ListPriceAvailability>>>;
  activityId?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  failedCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  itemLines?: Maybe<Array<Maybe<ItemPriceAdjustment>>>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalSku?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PriceAdjustmentConnection = {
  __typename?: 'PriceAdjustmentConnection';
  edges?: Maybe<Array<Maybe<PriceAdjustmentEdge>>>;
  nodes?: Maybe<Array<Maybe<PriceAdjustment>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type PriceAdjustmentEdge = {
  __typename?: 'PriceAdjustmentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PriceAdjustment>;
};

export type PriceAdjustmentFilterByInputs = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PriceHistory = {
  __typename?: 'PriceHistory';
  adjustmentId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  newPrice?: Maybe<Scalars['Int']['output']>;
  newSalePrice?: Maybe<Scalars['Int']['output']>;
  oldPrice?: Maybe<Scalars['Int']['output']>;
  oldSalePrice?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  store?: Maybe<ProductListingStore>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type PriceHistoryConnection = {
  __typename?: 'PriceHistoryConnection';
  edges?: Maybe<Array<Maybe<PriceHistoryEdge>>>;
  nodes?: Maybe<Array<Maybe<PriceHistory>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type PriceHistoryEdge = {
  __typename?: 'PriceHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PriceHistory>;
};

export type PriceHistoryFilterByInputs = {
  stores?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Principal = {
  __typename?: 'Principal';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  profileId: Scalars['Int']['output'];
};

export type PrintDocumentAddress = {
  __typename?: 'PrintDocumentAddress';
  address: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  long: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  subdistrict: SubDistrict;
  subdistrict_id: Scalars['Int']['output'];
};

export type PrintDocumentSettings = {
  __typename?: 'PrintDocumentSettings';
  address: PrintDocumentAddress;
  brandLogo: Scalars['Boolean']['output'];
  brandLogoUrl: Scalars['String']['output'];
  buyerNote: Scalars['Boolean']['output'];
  channelLogo: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  forstokOrderID: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  logisticLogo: Scalars['Boolean']['output'];
  packagingInfo: Scalars['Boolean']['output'];
  productName: Scalars['Boolean']['output'];
  profileID: Scalars['Int']['output'];
  quantityOrdered: Scalars['Boolean']['output'];
  sellerName: Scalars['Boolean']['output'];
  sellerNote: Scalars['Boolean']['output'];
  sellerNotes: Scalars['String']['output'];
  sellerPhone: Scalars['Boolean']['output'];
  settingType: Scalars['String']['output'];
  skuCode: Scalars['Boolean']['output'];
  storeName: Scalars['String']['output'];
  storePhoneNumber: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  variantName: Scalars['Boolean']['output'];
  withMargin: Scalars['Boolean']['output'];
};

export type PrintOrderInput = {
  documentType: Scalars['String']['input'];
  orderId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PrintOrderPayload = {
  __typename?: 'PrintOrderPayload';
  documentPath: Scalars['String']['output'];
  failedOrders?: Maybe<Array<Scalars['Int']['output']>>;
  failedSummary: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successOrders?: Maybe<Array<Scalars['Int']['output']>>;
  successSummary: Scalars['String']['output'];
  summary: Scalars['String']['output'];
};

export type PrintPacklistInput = {
  orderIds: Array<Scalars['String']['input']>;
};

export type PrintPacklistPayload = {
  __typename?: 'PrintPacklistPayload';
  activityId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  orderId: Array<Scalars['String']['output']>;
};

export type PrintPicklistInput = {
  picklistIds: Array<Scalars['String']['input']>;
};

export type PrintPicklistPayload = {
  __typename?: 'PrintPicklistPayload';
  activityId: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  picklistId: Array<Scalars['String']['output']>;
};

export type PriorityStore = {
  __typename?: 'PriorityStore';
  isActive: Scalars['Boolean']['output'];
  quantity: Scalars['Int']['output'];
  storeAccount: StoreAccount;
};

export type PriorityStoreInput = {
  isActive: Scalars['Boolean']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  storeID?: InputMaybe<Scalars['Int']['input']>;
};

export type Product = {
  __typename?: 'Product';
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  draftId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  kind?: Maybe<Scalars['String']['output']>;
  listingId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalBundle?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  variants?: Maybe<Array<Maybe<ProductVariant>>>;
};

export type ProductArchived = {
  __typename?: 'ProductArchived';
  archivedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
  variants?: Maybe<Array<Maybe<ProductArchivedVariant>>>;
};

/** The connection type for ProductArchived. */
export type ProductArchivedConnection = {
  __typename?: 'ProductArchivedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductArchivedEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductArchived>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductArchivedEdge = {
  __typename?: 'ProductArchivedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductArchived>;
};

export type ProductArchivedVariant = {
  __typename?: 'ProductArchivedVariant';
  id?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
};

export type ProductBundle = {
  __typename?: 'ProductBundle';
  brand?: Maybe<Scalars['String']['output']>;
  bundleId?: Maybe<Scalars['Int']['output']>;
  bundleVariants?: Maybe<Array<Maybe<ProductVariantBundle>>>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  draftId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  kind?: Maybe<Scalars['String']['output']>;
  masterVariant?: Maybe<ProductMasterBundle>;
  name?: Maybe<Scalars['String']['output']>;
  sellingPrice?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type ProductBundleVariants = {
  __typename?: 'ProductBundleVariants';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  bundleQuantity?: Maybe<Scalars['Int']['output']>;
  childSku?: Maybe<Scalars['String']['output']>;
  /**  bundle property  */
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  masterProductId?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<Maybe<ProductOption>>>;
  productName?: Maybe<Scalars['String']['output']>;
  quantityOnHand?: Maybe<Scalars['Int']['output']>;
  reservedQuantity?: Maybe<Scalars['Int']['output']>;
  warehouse?: Maybe<Array<Maybe<InputGetVariantWarehousePayload>>>;
};

/** The connection type for Product. */
export type ProductConnection = {
  __typename?: 'ProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Product>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Product>;
};

export type ProductFilterByInputs = {
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  draftId?: InputMaybe<Scalars['Int']['input']>;
  linkStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProductListing = {
  __typename?: 'ProductListing';
  actionAvailabilities?: Maybe<Array<Maybe<ListingActionAvailability>>>;
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  listingId?: Maybe<Scalars['Int']['output']>;
  liveLink?: Maybe<Scalars['String']['output']>;
  liveLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  masterProductID?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<ProductListingStatus>;
  store?: Maybe<ProductListingStore>;
  variants: Array<VariantProductListing>;
};

export type ProductListingBrand = {
  __typename?: 'ProductListingBrand';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** The connection type for ProductListing. */
export type ProductListingConnection = {
  __typename?: 'ProductListingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductListingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductListing>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type ProductListingCustomField = {
  __typename?: 'ProductListingCustomField';
  id: Scalars['String']['output'];
  inputType?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<ProductListingCustomFieldOption>>>;
  required: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ProductListingCustomFieldOption = {
  __typename?: 'ProductListingCustomFieldOption';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductListingCustomFields = {
  __typename?: 'ProductListingCustomFields';
  item?: Maybe<Array<ProductListingCustomField>>;
  variant?: Maybe<Array<ProductListingCustomField>>;
};

/** An edge in a connection. */
export type ProductListingEdge = {
  __typename?: 'ProductListingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductListing>;
};

export type ProductListingFilterByInputs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['Int']['input'];
  linkStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductListingStatus = {
  __typename?: 'ProductListingStatus';
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductListingStore = {
  __typename?: 'ProductListingStore';
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  storeId: Scalars['Int']['output'];
  storeName?: Maybe<Scalars['String']['output']>;
};

export type ProductListingVariants = {
  __typename?: 'ProductListingVariants';
  actionAvailabilities?: Maybe<Array<Maybe<GetVariantListingActionAvailability>>>;
  /**  image channel property  */
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  /**  listing property  */
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isPromotion?: Maybe<Scalars['Boolean']['output']>;
  listingAccount?: Maybe<Scalars['Int']['output']>;
  listingId?: Maybe<Scalars['Int']['output']>;
  liveLink?: Maybe<Scalars['String']['output']>;
  liveLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  masterProductId?: Maybe<Scalars['Int']['output']>;
  mongoId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<VariantSalePrice>;
  status?: Maybe<GetVariantListingStatus>;
  storeName?: Maybe<Scalars['String']['output']>;
  storeSku?: Maybe<Scalars['String']['output']>;
};

export type ProductMasterBundle = {
  __typename?: 'ProductMasterBundle';
  height?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  masterProductId?: Maybe<Scalars['String']['output']>;
  masterVariantId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ProductOption = {
  __typename?: 'ProductOption';
  option?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProductPromotionStore = {
  __typename?: 'ProductPromotionStore';
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  navbarId?: Maybe<Scalars['Int']['output']>;
  storeId: Scalars['Int']['output'];
  storeName?: Maybe<Scalars['String']['output']>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  bundleId?: Maybe<Scalars['Int']['output']>;
  costPrice?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<Maybe<ProductOption>>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityOnHand?: Maybe<Scalars['Int']['output']>;
  regularPrice?: Maybe<Scalars['Int']['output']>;
  reservedQuantity?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Array<Maybe<GetVariantListingStatus>>>;
  tax?: Maybe<Scalars['Boolean']['output']>;
  totalListing?: Maybe<Scalars['Int']['output']>;
  variantListingId?: Maybe<Scalars['String']['output']>;
  warehouses?: Maybe<Array<Maybe<ProductWarehouse>>>;
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ProductVariantBundle = {
  __typename?: 'ProductVariantBundle';
  imageUrl?: Maybe<Scalars['String']['output']>;
  masterProductId?: Maybe<Scalars['String']['output']>;
  masterVariantId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<ProductVariantBundleAttributePrice>;
  productId?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
};

export type ProductVariantBundleAttributePrice = {
  __typename?: 'ProductVariantBundleAttributePrice';
  amount?: Maybe<Scalars['Int']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  regular?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ProductWarehouse = {
  __typename?: 'ProductWarehouse';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  quantityOnHand?: Maybe<Scalars['Int']['output']>;
  reservedQuantity?: Maybe<Scalars['Int']['output']>;
};

export type Profile = {
  __typename?: 'Profile';
  accounts: Array<AccountRuby>;
  company?: Maybe<Company>;
  dashboardUser?: Maybe<DashboardUser>;
  dashboardUsers: Array<DashboardUser>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoice?: Maybe<InvoiceSetting>;
  isShipper: Scalars['Boolean']['output'];
  level: ProfileLevel;
  mwhActivated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  settings: Scalars['String']['output'];
  status?: Maybe<ProfileStatus>;
  tax?: Maybe<TaxSetting>;
  totalAccounts?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ProfileType>;
  username?: Maybe<Scalars['String']['output']>;
};


export type ProfileDashboardUserArgs = {
  id: Scalars['Int']['input'];
};

export type ProfileActivity = {
  __typename?: 'ProfileActivity';
  action: Scalars['String']['output'];
  actionType: Scalars['String']['output'];
  attempts?: Maybe<Scalars['Int']['output']>;
  countPercentage?: Maybe<Scalars['Int']['output']>;
  currentCount?: Maybe<Scalars['Int']['output']>;
  failed: Scalars['Boolean']['output'];
  failedCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  inProgress: Scalars['Boolean']['output'];
  links: Array<ProfileActivityLink>;
  processFinishedAt?: Maybe<Scalars['String']['output']>;
  processStartedAt: Scalars['String']['output'];
  processTime?: Maybe<Scalars['Int']['output']>;
  resultUrl?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  uploadedUrl?: Maybe<Scalars['String']['output']>;
  userEmail: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

/** The connection type for ProfileActivity. */
export type ProfileActivityConnection = {
  __typename?: 'ProfileActivityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProfileActivityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProfileActivity>>>;
  pageCursors: Array<PageCursors>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProfileActivityEdge = {
  __typename?: 'ProfileActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProfileActivity>;
};

export type ProfileActivityLink = {
  __typename?: 'ProfileActivityLink';
  label: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ProfileBalance = {
  __typename?: 'ProfileBalance';
  balance: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  monthlyBudget: Scalars['Float']['output'];
  profileId: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ProfileChannelAssociation = {
  __typename?: 'ProfileChannelAssociation';
  channel: Channel;
  channelId: Scalars['Int']['output'];
  channelSync: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageContentType?: Maybe<Scalars['String']['output']>;
  imageFingerprint?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  info: AccountInfo;
  lastSyncedItemAt?: Maybe<Scalars['String']['output']>;
  lastSyncedItemQcAt?: Maybe<Scalars['String']['output']>;
  lastSyncedOrderAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ProfileLevel = {
  __typename?: 'ProfileLevel';
  batchId: Scalars['Boolean']['output'];
  bin: Scalars['Boolean']['output'];
  expiredDate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serialNumber: Scalars['Boolean']['output'];
};

export type ProfileStatus = {
  __typename?: 'ProfileStatus';
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type ProfileType = {
  __typename?: 'ProfileType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Promotion = {
  __typename?: 'Promotion';
  channelPromotionId?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  itemLines?: Maybe<Array<Maybe<ItemPromotion>>>;
  name?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  store?: Maybe<ProductPromotionStore>;
  totalSku?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PromotionFilterByInputs = {
  stores?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PromotionList = {
  __typename?: 'PromotionList';
  edges?: Maybe<Array<Maybe<PromotionListEdge>>>;
  nodes?: Maybe<Array<Maybe<Promotion>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type PromotionListEdge = {
  __typename?: 'PromotionListEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Promotion>;
};

export type PromotionStore = {
  __typename?: 'PromotionStore';
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  navbarId?: Maybe<Scalars['Int']['output']>;
  storeId: Scalars['Int']['output'];
  storeName?: Maybe<Scalars['String']['output']>;
};

export type PromotionVariantList = {
  __typename?: 'PromotionVariantList';
  discountPrice?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  regularPrice?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  store?: Maybe<ProductPromotionStore>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Province = {
  __typename?: 'Province';
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  lon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProvinceInput = {
  countryId: Scalars['Int']['input'];
};

export type QtyInventory = {
  __typename?: 'QtyInventory';
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  profileId: Scalars['ID']['output'];
  variantId: Scalars['Int']['output'];
  variantName?: Maybe<Scalars['String']['output']>;
  variantSku: Scalars['String']['output'];
  warehouses: Array<WarehouseInventory>;
};

export type QtyInventoryEdge = {
  __typename?: 'QtyInventoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QtyInventory>;
};

export type Query = {
  __typename?: 'Query';
  Channels: Array<Maybe<ChannelsPayload>>;
  GetProductBundles?: Maybe<Array<Maybe<InputGetProductBundlesPayload>>>;
  GetProductListings?: Maybe<Array<Maybe<InputGetProductListingsPayload>>>;
  GetVariantProductListings: Array<Maybe<InputGetVariantListingsPayload>>;
  GetVariantProducts: Array<Maybe<InputGetVariantsPayload>>;
  MasterTags: Array<MasterTag>;
  account?: Maybe<AccountRuby>;
  accounts?: Maybe<Array<AccountRuby>>;
  accountsV2?: Maybe<Array<Maybe<AccountV2>>>;
  activities?: Maybe<Array<Maybe<GlobalActivity>>>;
  analytics?: Maybe<Analytics>;
  analyticsGuestToken?: Maybe<AnalyticsGuestTokenResult>;
  announcement: Announcement;
  availableCouriers?: Maybe<AvailableCouriers>;
  availablePayments?: Maybe<AvailablePayments>;
  bin?: Maybe<Bin>;
  breadcrumbCategories: Array<BreadcrumbCategory>;
  bundle: ProductBundle;
  cartVouchers: CartVoucherList;
  categoryMappings?: Maybe<CategoryMappingConnection>;
  channelList: Array<ChannelRuby>;
  chatAIToken: ChatAiTokenConnection;
  chatAITokenMetrics: ChatAiTokenMetrics;
  chatAutoReplies?: Maybe<AutoReplyConnection>;
  chatAutoReply?: Maybe<AutoReply>;
  chatCart?: Maybe<ChatCart>;
  chatContactSearch: Array<ContactSearchResult>;
  chatConversation: ChatConversation;
  chatCustomerSurveyStats: ChatCustomerSurveyStatsConnection;
  chatCustomerSurveySummary: ChatCustomerSurveySummary;
  chatCustomerSurveys: ChatCustomerSurveyConnection;
  chatImportWhatsAppForm?: Maybe<ImportWhatsAppForm>;
  chatImportWhatsappTemplate?: Maybe<SuccessResponse>;
  chatKnowledgeConversation: ChatKnowledgeConversation;
  chatLabel?: Maybe<Label>;
  chatLabels?: Maybe<LabelConnection>;
  chatLiveViewConversationMetrics: ConversationMetrics;
  chatLiveViewConversationsByAgents: Array<AgentConversation>;
  chatLiveViewConversationsByLabels: Array<LabelConversation>;
  chatLiveViewConversationsByStores: Array<StoreConversation>;
  chatLocations: Array<ChatLocation>;
  chatMessages?: Maybe<ChatMessageConnection>;
  chatMessagesReceived: ChatConversation;
  chatMessagesSent: ChatConversation;
  chatProducts?: Maybe<ChatProductConnection>;
  /** Laporan chat per agent (Bot/Human) dengan filter dan pagination. */
  chatReportByAgents?: Maybe<ChatReportByAgentsConnection>;
  chatResolvedCount: ChatConversation;
  chatRoom?: Maybe<ChatRoom>;
  chatRoomMessages?: Maybe<ChatRoomByMessageConnection>;
  chatRooms?: Maybe<ChatRoomConnection>;
  chatStore?: Maybe<ChatStoreDetail>;
  chatStores: Array<ChatStore>;
  chatWhatsAppCampaign?: Maybe<Campaign>;
  chatWhatsAppCampaignActivity?: Maybe<CampaignActivityConnection>;
  chatWhatsAppCampaignPerfomance?: Maybe<AudienceCampaignPerformance>;
  chatWhatsAppForm?: Maybe<ChatWhatsAppForm>;
  chatWhatsAppForms?: Maybe<ChatWhatsAppFormConnection>;
  chatWhatsAppTemplate?: Maybe<Template>;
  chatWhatsappCampaigns?: Maybe<CampaignConnection>;
  chatWhatsappTemplateActivity?: Maybe<TemplateActivityConnection>;
  chatWhatsappTemplates?: Maybe<TemplateConnection>;
  cities: Array<City>;
  contact?: Maybe<Contact>;
  contactAddresses: Array<ContactAddress>;
  contactAttributes?: Maybe<ContactAttributeConnection>;
  contactCompanies?: Maybe<ContactCompanyConnection>;
  contactCompany?: Maybe<ContactCompany>;
  contactOrders?: Maybe<ContactOrderConnection>;
  contactSearch: Array<ContactBasic>;
  contacts?: Maybe<ContactConnection>;
  contentListing: Array<ContentListing>;
  countries: Array<Country>;
  crmAttributes?: Maybe<CrmAttributeConnection>;
  crmDeal?: Maybe<CrmDeal>;
  crmDeals?: Maybe<CrmDealConnection>;
  crmPipeline?: Maybe<CrmPipeline>;
  crmPipelines: Array<CrmPipeline>;
  crmStage?: Maybe<CrmStage>;
  crmStages: Array<CrmStage>;
  crmTicket?: Maybe<CrmTicket>;
  crmTickets?: Maybe<CrmTicketConnection>;
  currentDashboardUser?: Maybe<DashboardUser>;
  customer: Customer;
  customers: Array<Customer>;
  dashboardUser?: Maybe<DashboardUser>;
  dashboardUsers: Array<DashboardUser>;
  defaultUserWarehouse?: Maybe<DefaultUserWarehouse>;
  districts: Array<District>;
  downloadExcelDocument: DownloadExcelDocumentResponse;
  /** Find drafts */
  drafts?: Maybe<Array<Draft>>;
  failedEvent?: Maybe<FailedEvent>;
  financeTransactions?: Maybe<FinanceTransactionConnection>;
  fulfillment?: Maybe<OrderFulfillment>;
  fulfillmentSN?: Maybe<OrderFulfillment>;
  fulfillments?: Maybe<OrderFulfillmentConnection>;
  getChannelWarehouses?: Maybe<ChannelWarehouseListResponse>;
  getIncompleteIntegrations?: Maybe<IncompleteIntegrationListResponse>;
  invalidCredentials: Array<InvalidCredential>;
  inventoryForecasting: ForecastingConnectionType;
  inventorySettings?: Maybe<InventorySettings>;
  invoice?: Maybe<Invoice>;
  invoices?: Maybe<InvoiceConnection>;
  invoicesByOrderId?: Maybe<Array<Maybe<Invoice>>>;
  item?: Maybe<ItemTypeNew>;
  itemCategoryMapping?: Maybe<CategoryMapping>;
  itemMasterCategories?: Maybe<Array<Scalars['String']['output']>>;
  listing: ProductListing;
  listingBrands?: Maybe<ListingBrandConnection>;
  listingCategories: Array<ListingCategories>;
  listingCustomHeader: Array<ListingCustomHeader>;
  listingHeader: Array<ListingHeader>;
  listingPendingAction: ListingPendingAction;
  /** Show listing summary */
  listingSummary: ListingSummary;
  listingTotalSkus: ListingTotalSkus;
  listings?: Maybe<ProductListingConnection>;
  listingsByAccountId?: Maybe<Array<Listing>>;
  liveView: LiveView;
  masterCategories: Array<MasterCategory>;
  masterDataDummys: Array<MasterDataDummy>;
  openOrders?: Maybe<OrderConnection>;
  openPrintDocumentSettings?: Maybe<PrintDocumentSettings>;
  order?: Maybe<Order>;
  orderActivities?: Maybe<Array<Maybe<OrderActivity>>>;
  orderChartSupport: OrderChartSupport;
  orderChartSupportV2: OrderChartSupportV2;
  orderCouriers?: Maybe<Array<Maybe<Courier>>>;
  orderInvoice?: Maybe<OrderInvoice>;
  orderItemLines?: Maybe<OrderItemLineConnection>;
  orderQuotation: Array<OrderQuotation>;
  orderQuotations?: Maybe<OrderQuotationConnection>;
  orderSN?: Maybe<Order>;
  orderToFulfill?: Maybe<OrderToFulfill>;
  orders?: Maybe<OrderConnection>;
  ordersSN?: Maybe<OrderConnection>;
  package?: Maybe<Package>;
  packageActivities?: Maybe<Array<Maybe<PackageActivity>>>;
  packageSN?: Maybe<Package>;
  packages?: Maybe<PackageConnection>;
  paymentReceived?: Maybe<PaymentReceived>;
  paymentReceiveds?: Maybe<PaymentReceivedConnection>;
  payoutChannel?: Maybe<Array<PayoutChannel>>;
  pendingOrders: PendingOrder;
  permissions: Array<Permission>;
  picklist?: Maybe<Picklist>;
  picklistActivities?: Maybe<Array<Maybe<PicklistActivity>>>;
  picklistItemLines?: Maybe<PicklistItemLineConnection>;
  picklistSN?: Maybe<Picklist>;
  picklists?: Maybe<PicklistConnection>;
  popUpCancel?: Maybe<CancelPop>;
  popUpFinanceTransaction?: Maybe<TransactionDescriptionPayload>;
  popUpMassPayment?: Maybe<MassPaymentPop>;
  popUpPackage?: Maybe<PackPop>;
  popUpPicklist?: Maybe<PickPop>;
  popUpReadyToShip?: Maybe<RtsPop>;
  popUpShipment?: Maybe<ShipmentPop>;
  priceAdjustment?: Maybe<PriceAdjustment>;
  priceAdjustments?: Maybe<PriceAdjustmentConnection>;
  priceHistories?: Maybe<PriceHistoryConnection>;
  principals: Array<Maybe<Principal>>;
  printDocumentSettings?: Maybe<PrintDocumentSettings>;
  printOrders?: Maybe<OrderConnection>;
  product: Product;
  productListingBrands?: Maybe<Array<ProductListingBrand>>;
  productListingCustomFields?: Maybe<ProductListingCustomFields>;
  productarchiveds?: Maybe<ProductArchivedConnection>;
  products?: Maybe<ProductConnection>;
  productsAccount?: Maybe<Array<Maybe<ResponseProductsAccount>>>;
  profile?: Maybe<Profile>;
  profileActivities?: Maybe<ProfileActivityConnection>;
  promotion?: Maybe<Promotion>;
  promotions?: Maybe<PromotionList>;
  promotionsByVariantsId?: Maybe<Array<Maybe<PromotionVariantList>>>;
  provinces: Array<Province>;
  qtyInventories: InventoryConnectionType;
  regionMetropolitans: Array<RegionMetropolitan>;
  reportingCustomHeader?: Maybe<Array<ReportingCustomHeaderContent>>;
  reportingDashboard?: Maybe<ReportingDashboardConnection>;
  reportingGuestToken?: Maybe<ReportingGuestTokenResult>;
  reportings: Array<Reporting>;
  return?: Maybe<Return>;
  returnOrders?: Maybe<ReturnConnection>;
  returnSN?: Maybe<Return>;
  role: Role;
  roles: Array<Role>;
  saleSummaries: SaleSummary;
  saleSummariesV2: SaleSummaryV2;
  salesAgent?: Maybe<SalesAgent>;
  salesAgentPayout?: Maybe<SalesAgentPayout>;
  salesAgentPayouts?: Maybe<SalesAgentPayoutConnection>;
  salesAgentTransaction?: Maybe<SalesAgentTransaction>;
  salesAgentTransactionMetrics?: Maybe<SalesAgentTransactionMetrics>;
  salesAgentTransactions?: Maybe<SalesAgentTransactionConnection>;
  salesAgents?: Maybe<SalesAgentConnection>;
  shipmentActivities?: Maybe<Array<Maybe<ShipmentActivity>>>;
  shipper?: Maybe<ShipperUser>;
  shippingPrices?: Maybe<Array<ShippingPrices>>;
  stockAdjustment?: Maybe<StockAdjustment>;
  stockAdjustments?: Maybe<StockAdjustmentConnection>;
  stockHistories: Array<StockHistories>;
  stockHistoryList?: Maybe<StockHistoryConnection>;
  stockInbound?: Maybe<StockInbound>;
  stockInbounds?: Maybe<StockInboundConnection>;
  stockOutbound?: Maybe<StockOutbound>;
  stockOutbounds?: Maybe<StockOutboundConnection>;
  stockTransfer?: Maybe<StockTransfer>;
  stockTransfers?: Maybe<StockTransferConnection>;
  subDistricts: Array<SubDistrict>;
  todos: Array<Todo>;
  variant: ItemVariant;
  variantActivityActionTypes?: Maybe<Array<Scalars['String']['output']>>;
  variants?: Maybe<VariantConnectionTypeNew>;
  /** Find variants filter by type */
  variantsFilter?: Maybe<Array<VariantFilter>>;
  voucher?: Maybe<Voucher>;
  voucherAnalytics: VoucherAnalytics;
  vouchers: VoucherList;
  warehouse?: Maybe<Warehouse>;
  warehouseStore?: Maybe<Array<Maybe<Warehouse>>>;
  warehouses?: Maybe<Array<Maybe<Warehouse>>>;
  warehousesV2?: Maybe<Array<Maybe<WarehouseV2>>>;
};


export type QueryChannelsArgs = {
  filterBy?: InputMaybe<ChannelsFilterByInput>;
  search?: InputMaybe<Scalars['Int']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProductBundlesArgs = {
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetProductListingsArgs = {
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetVariantProductListingsArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['Any']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetVariantProductsArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['Any']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryMasterTagsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccountsArgs = {
  onlyPayoutMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  onlySalesOrder?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountsV2Args = {
  onlyPos?: InputMaybe<Scalars['Boolean']['input']>;
  onlySalesOrder?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAvailablePaymentsArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBinArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  oldWarehouseId: Scalars['Int']['input'];
};


export type QueryBreadcrumbCategoriesArgs = {
  input: InputBreadcrumbCategory;
};


export type QueryBundleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCartVouchersArgs = {
  cartId: Scalars['String']['input'];
  type?: InputMaybe<VoucherType>;
};


export type QueryCategoryMappingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChannelListArgs = {
  type: Scalars['String']['input'];
};


export type QueryChatAiTokenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ChatAiTokenFilterBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatAutoRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<AutoReplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatAutoReplyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatCartArgs = {
  accountId: Scalars['Int']['input'];
  contactId: Scalars['Int']['input'];
};


export type QueryChatContactSearchArgs = {
  limitPerType: Scalars['Int']['input'];
  search: Scalars['String']['input'];
};


export type QueryChatConversationArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ChatConversationType>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatCustomerSurveyStatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatCustomerSurveySummaryArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  csatId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatCustomerSurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  csatId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatImportWhatsAppFormArgs = {
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatKnowledgeConversationArgs = {
  sessionId: Scalars['ID']['input'];
  storeId: Scalars['Int']['input'];
};


export type QueryChatLabelArgs = {
  labelId: Scalars['Int']['input'];
};


export type QueryChatLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatLiveViewConversationMetricsArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatLiveViewConversationsByAgentsArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatLiveViewConversationsByLabelsArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatLiveViewConversationsByStoresArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  roomId: Scalars['String']['input'];
  sortBy?: InputMaybe<LinkChatMessageByInput>;
};


export type QueryChatMessagesReceivedArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatMessagesSentArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkChatProductByInput>;
  storeId: Scalars['Int']['input'];
};


export type QueryChatReportByAgentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ChatReportByAgentsFilterBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatResolvedCountArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatRoomArgs = {
  id: Scalars['String']['input'];
};


export type QueryChatRoomMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<ChatFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkChatRoomByInput>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatRoomsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<ChatFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<SearchBy>;
  sortBy?: InputMaybe<LinkChatRoomByInput>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatStoreArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};


export type QueryChatWhatsAppCampaignArgs = {
  campaignId: Scalars['Int']['input'];
};


export type QueryChatWhatsAppCampaignActivityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['Int']['input'];
  filterBy?: InputMaybe<CampaignFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatWhatsAppCampaignPerfomanceArgs = {
  campaignId: Scalars['Int']['input'];
};


export type QueryChatWhatsAppFormArgs = {
  id: Scalars['String']['input'];
};


export type QueryChatWhatsAppFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ChatWhatsAppFormFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatWhatsAppTemplateArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};


export type QueryChatWhatsappCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CampaignFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CampaignSortByInput>;
};


export type QueryChatWhatsappTemplateActivityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<TemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  templateId: Scalars['String']['input'];
};


export type QueryChatWhatsappTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<TemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<TemplateSortByInput>;
};


export type QueryCitiesArgs = {
  provinceId: Scalars['Int']['input'];
};


export type QueryContactArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContactAddressesArgs = {
  addressType?: InputMaybe<ContactAddressType>;
  contactId: Scalars['Int']['input'];
  contactType: ContactBasicType;
};


export type QueryContactAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ContactCompanySortBy>;
};


export type QueryContactCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContactOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactSearchArgs = {
  filterBy?: InputMaybe<ContactSearchFilter>;
  limitPerType: Scalars['Int']['input'];
  search: Scalars['String']['input'];
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ContactSort>;
};


export type QueryContentListingArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  listingIds?: InputMaybe<Array<InputMaybe<InputContentListings>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortBy?: InputMaybe<ContentListingSortBy>;
};


export type QueryCrmAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCrmDealArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCrmDealsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CrmDealFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrmPipelineArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCrmPipelinesArgs = {
  cardType: CrmCardType;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrmStageArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCrmStagesArgs = {
  pipelineId: Scalars['Int']['input'];
};


export type QueryCrmTicketArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCrmTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CrmTicketFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


export type QueryDashboardUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDistrictsArgs = {
  cityId: Scalars['Int']['input'];
};


export type QueryDownloadExcelDocumentArgs = {
  input: InputDownloadExcelDocument;
};


export type QueryFailedEventArgs = {
  group: Scalars['String']['input'];
  profileId: Scalars['Int']['input'];
};


export type QueryFinanceTransactionsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<FinanceTransactionFilterBy>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFulfillmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFulfillmentSnArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFulfillmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OrderFulfillmentFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkOrderFulfillmentByInput>;
};


export type QueryGetChannelWarehousesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  storeId: Scalars['Int']['input'];
};


export type QueryGetIncompleteIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInventoryForecastingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ForecastingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoiceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<InvoiceFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentReceivedId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkInvoiceByInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoicesByOrderIdArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryItemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryItemCategoryMappingArgs = {
  masterCategoryName: Scalars['String']['input'];
};


export type QueryListingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListingBrandsArgs = {
  accountId: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryLocalId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListingCategoriesArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryListingCustomHeaderArgs = {
  accountId: Scalars['Int']['input'];
  categoryLocalId: Scalars['String']['input'];
  listingId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListingHeaderArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryListingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ProductListingFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkProductListingByInput>;
};


export type QueryListingsByAccountIdArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryLiveViewArgs = {
  filters?: InputMaybe<LiveViewFilters>;
};


export type QueryMasterCategoriesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMasterDataDummysArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpenOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OrderFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkOrderByInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  updatedAfter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrderActivitiesArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryOrderChartSupportArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderChartSupportV2Args = {
  channelId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OrderChartSupportFilterByV2>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderCouriersArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  isProfileFiltered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrderInvoiceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrderItemLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OrderItemLineFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkOrderItemLineByInput>;
};


export type QueryOrderQuotationArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryOrderQuotationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OrderQuotationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<OrderQuotationSearchBy>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderSnArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrderToFulfillArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  groupFulfillmentType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OrderFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkOrderByInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  updatedAfter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersSnArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<OrderFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkOrderByInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  updatedAfter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPackageArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPackageActivitiesArgs = {
  packageId: Scalars['Int']['input'];
};


export type QueryPackageSnArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<PackageFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkPackageByInput>;
};


export type QueryPaymentReceivedArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPaymentReceivedsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<PaymentReceivedFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkPaymentReceivedByInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPayoutChannelArgs = {
  payoutChannelInput?: InputMaybe<Array<PayoutChannelInputs>>;
};


export type QueryPicklistArgs = {
  id: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPicklistActivitiesArgs = {
  picklistId: Scalars['Int']['input'];
};


export type QueryPicklistItemLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<PicklistItemLineFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkPicklistItemLineByInput>;
};


export type QueryPicklistSnArgs = {
  id: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPicklistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<PicklistFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkPicklistByInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPopUpCancelArgs = {
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPopUpFinanceTransactionArgs = {
  type: Scalars['String']['input'];
};


export type QueryPopUpMassPaymentArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  invoiceStatus?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPopUpPackageArgs = {
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPopUpPicklistArgs = {
  orderId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  whId: Scalars['Int']['input'];
};


export type QueryPopUpReadyToShipArgs = {
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPopUpShipmentArgs = {
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPriceAdjustmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPriceAdjustmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<PriceAdjustmentFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPriceHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<PriceHistoryFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPrintOrdersArgs = {
  activityId: Scalars['Int']['input'];
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductListingBrandsArgs = {
  input: InputProductListingBrand;
};


export type QueryProductListingCustomFieldsArgs = {
  input: InputProductListingCustomField;
};


export type QueryProductarchivedsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkProductArchivedByInput>;
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ProductFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  listingIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkProductByInput>;
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryProfileActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ActivityFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  showSuperUser?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPromotionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPromotionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<PromotionFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkOrderPromotionByInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPromotionsByVariantsIdArgs = {
  accountId: Scalars['Int']['input'];
  id: Scalars['String']['input'];
};


export type QueryProvincesArgs = {
  countryId: Scalars['Int']['input'];
};


export type QueryQtyInventoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<InventoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<InventoryOrderByInput>;
};


export type QueryReportingCustomHeaderArgs = {
  type: Scalars['String']['input'];
};


export type QueryReportingDashboardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ReportingDashboardFilterBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortReportingDashboardByInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type QueryReportingGuestTokenArgs = {
  dashboardId: Scalars['String']['input'];
};


export type QueryReturnArgs = {
  id: Scalars['Int']['input'];
};


export type QueryReturnOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ReturnOrderFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<LinkReturnOrderByInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  updatedAfter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReturnSnArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRoleArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySaleSummariesArgs = {
  channelId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['Int']['input'];
};


export type QuerySaleSummariesV2Args = {
  channelId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<SaleSummaryFilterByV2>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['Int']['input'];
};


export type QuerySalesAgentArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySalesAgentPayoutArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySalesAgentPayoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<SalesAgentPayoutFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SalesAgentPayoutSort>;
};


export type QuerySalesAgentTransactionArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySalesAgentTransactionMetricsArgs = {
  filterBy?: InputMaybe<SalesAgentTransactionFilter>;
};


export type QuerySalesAgentTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<SalesAgentTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SalesAgentTransactionSort>;
};


export type QuerySalesAgentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<SalesAgentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SalesAgentSort>;
};


export type QueryShipmentActivitiesArgs = {
  shipmentId: Scalars['Int']['input'];
};


export type QueryShippingPricesArgs = {
  input: ShippingPriceRequest;
};


export type QueryStockAdjustmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStockAdjustmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<StockAdjustmentFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<StockAdjustmentSort>;
};


export type QueryStockHistoriesArgs = {
  variantId: Scalars['Int']['input'];
};


export type QueryStockHistoryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<StockHistoryFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStockInboundArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStockInboundsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<StockInboundFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<StockInboundSort>;
};


export type QueryStockOutboundArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStockOutboundsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<StockOutboundFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<StockOutboundSort>;
};


export type QueryStockTransferArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStockTransfersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<StockTransferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<StockTransferSort>;
};


export type QuerySubDistrictsArgs = {
  districtId: Scalars['Int']['input'];
};


export type QueryVariantArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<VariantFilterByInputs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  noIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  updatedAfter?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVariantsFilterArgs = {
  type: Scalars['String']['input'];
};


export type QueryVoucherArgs = {
  id: Scalars['String']['input'];
};


export type QueryVoucherAnalyticsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  voucherId: Scalars['String']['input'];
};


export type QueryVouchersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<VoucherOrderByInput>;
  status?: InputMaybe<VoucherStatus>;
  type?: InputMaybe<VoucherType>;
};


export type QueryWarehouseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWarehouseStoreArgs = {
  StoreId: Scalars['Int']['input'];
};


export type QueryWarehousesArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  onlyPos?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWarehousesV2Args = {
  onlyPos?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RtsPop = {
  __typename?: 'RTSPop';
  orders?: Maybe<Array<Maybe<Order>>>;
};

export type RecipientCampaignContactInput = {
  contactId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type RegionMetropolitan = {
  __typename?: 'RegionMetropolitan';
  cities: Array<City>;
  city_ids: Array<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RegisterNotificationDeviceInput = {
  appName: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fcmToken: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  platform: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['Int']['input']>;
};

export type RegisterNotificationDevicePayload = {
  __typename?: 'RegisterNotificationDevicePayload';
  data: NotificationDevice;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Reporting = {
  __typename?: 'Reporting';
  groups: ReportingGroup;
  id: Scalars['ID']['output'];
};

export type ReportingCustomHeaderContent = {
  __typename?: 'ReportingCustomHeaderContent';
  condition?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  maxWidth: Scalars['Int']['output'];
  minWidth: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  typeData: Scalars['String']['output'];
};

export type ReportingDashboard = {
  __typename?: 'ReportingDashboard';
  dashboardId?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['Any']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  search?: Maybe<ReportingSearch>;
};

export type ReportingDashboardConnection = {
  __typename?: 'ReportingDashboardConnection';
  edges?: Maybe<Array<Maybe<ReportingDashboardEdge>>>;
  nodes?: Maybe<Array<Maybe<ReportingDashboardContent>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type ReportingDashboardContent = {
  __typename?: 'ReportingDashboardContent';
  data?: Maybe<Scalars['Any']['output']>;
};

export type ReportingDashboardEdge = {
  __typename?: 'ReportingDashboardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportingDashboardContent;
};

export type ReportingDashboardFilterBy = {
  isIncludeDeletedWarehouses?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReportingGroup = {
  __typename?: 'ReportingGroup';
  name: Scalars['String']['output'];
  reporting: Array<ReportingDashboard>;
};

export type ReportingGuestTokenResult = {
  __typename?: 'ReportingGuestTokenResult';
  dashboardId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  profileId?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type ReportingMutationCustomHeaderInput = {
  columnKey: Scalars['String']['input'];
  maxWidth: Scalars['Int']['input'];
  minWidth: Scalars['Int']['input'];
  typeReporting: Scalars['String']['input'];
};

export type ReportingMutationCustomHeaderResponse = {
  __typename?: 'ReportingMutationCustomHeaderResponse';
  message: Scalars['String']['output'];
};

export type ReportingSearch = {
  __typename?: 'ReportingSearch';
  bys: Array<Scalars['String']['output']>;
  default: Scalars['String']['output'];
};

export type ReservedStockRules = {
  __typename?: 'ReservedStockRules';
  selectedStatus: Scalars['String']['output'];
};

export type ReservedStockRulesInput = {
  selectedStatus: Scalars['String']['input'];
};

export type ResponseProductsAccount = {
  __typename?: 'ResponseProductsAccount';
  accountId?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Return = {
  __typename?: 'Return';
  accountID?: Maybe<Scalars['Int']['output']>;
  awb?: Maybe<Scalars['String']['output']>;
  channelID?: Maybe<Scalars['Int']['output']>;
  courier?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  invoice?: Maybe<Invoice>;
  itemLines?: Maybe<Array<OrderItemLine>>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderID?: Maybe<Scalars['Int']['output']>;
  orderitemLines?: Maybe<Array<ReturnItems>>;
  profileID?: Maybe<Scalars['Int']['output']>;
  reasonID?: Maybe<Scalars['Int']['output']>;
  receivedStatus?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  refundValue?: Maybe<Scalars['Int']['output']>;
  returnActivities: ReturnActivities;
  returnedAt?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  warehouse?: Maybe<Warehouse>;
  warehouseID?: Maybe<Scalars['Int']['output']>;
};

export type ReturnActivities = {
  __typename?: 'ReturnActivities';
  approvedBy?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  returnID?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

/** The connection type for Order. */
export type ReturnConnection = {
  __typename?: 'ReturnConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReturnEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Return>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type ReturnEdge = {
  __typename?: 'ReturnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Return>;
};

export type ReturnItem = {
  itemLineBundles?: InputMaybe<Array<InputMaybe<ItemLineBundles>>>;
  itemLinesId: Scalars['String']['input'];
  qtyToReturn: Scalars['Int']['input'];
};

export type ReturnItems = {
  __typename?: 'ReturnItems';
  consignment?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  itemImageUrl?: Maybe<Scalars['String']['output']>;
  itemLineID?: Maybe<Scalars['Int']['output']>;
  itemNote?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  localID?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderItemLineBundles?: Maybe<Array<Maybe<OrderItemLineBundle>>>;
  price?: Maybe<Scalars['Int']['output']>;
  qtyOrdered?: Maybe<Scalars['Int']['output']>;
  qtyReceived?: Maybe<Scalars['Int']['output']>;
  qtyRestock?: Maybe<Scalars['Int']['output']>;
  qtyReturned?: Maybe<Scalars['Int']['output']>;
  qtyToReturn?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityReturned?: Maybe<Scalars['Int']['output']>;
  returnID?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Array<Maybe<Status>>>;
  subTotal?: Maybe<Scalars['Int']['output']>;
  taxPrice?: Maybe<Scalars['Int']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
};

export type ReturnOrderFilterByInputs = {
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  stores?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ReturnResponse = {
  __typename?: 'ReturnResponse';
  message: Scalars['String']['output'];
  return?: Maybe<Return>;
  status: Scalars['String']['output'];
};

export type Role = {
  __typename?: 'Role';
  dashboardUserCount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  rolePermissions: Array<RolePermission>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  id: Scalars['ID']['output'];
  permission: Permission;
  warehouseIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type RolePermissions = {
  __typename?: 'RolePermissions';
  channelId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  permissionId?: Maybe<Scalars['Int']['output']>;
  roleId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
};

export type RoomAssignBulkPayload = {
  __typename?: 'RoomAssignBulkPayload';
  assignedRoomIds: Array<Scalars['String']['output']>;
  failedRoomIds: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RoomAssignPayload = {
  __typename?: 'RoomAssignPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum RoomCondition {
  All = 'all',
  Cart = 'cart',
  Expired = 'expired',
  Expiring = 'expiring',
  New = 'new'
}

export type RoomResolveItemResult = {
  __typename?: 'RoomResolveItemResult';
  message?: Maybe<Scalars['String']['output']>;
  roomId: Scalars['String']['output'];
  status: RoomResolveStatus;
};

export type RoomResolvePayload = {
  __typename?: 'RoomResolvePayload';
  failedRoomIds: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  resolvedRoomIds: Array<Scalars['String']['output']>;
  results: Array<RoomResolveItemResult>;
  success: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export enum RoomResolveStatus {
  AlreadyResolved = 'ALREADY_RESOLVED',
  Failed = 'FAILED',
  InvalidRoomId = 'INVALID_ROOM_ID',
  NotFound = 'NOT_FOUND',
  Resolved = 'RESOLVED'
}

export enum RoomType {
  Assigned = 'assigned',
  Chatbot = 'chatbot',
  LabelId = 'labelId',
  Mine = 'mine',
  Resolved = 'resolved',
  Unserved = 'unserved'
}

export type RoundRobinUser = {
  __typename?: 'RoundRobinUser';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isOnline: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RoundRobinUserInput = {
  id: Scalars['Int']['input'];
  isOnline: Scalars['Boolean']['input'];
  isUpdated: Scalars['Boolean']['input'];
};

export type SaleSummary = {
  __typename?: 'SaleSummary';
  avgCommissions?: Maybe<SaleSummaryAverageCommission>;
  avgItemDiscount: SaleSummaryAverageItemDiscount;
  avgOrderValue: SaleSummaryAverageOrderValue;
  avgOrdersPerDay: SaleSummaryAverageOrderPerDay;
  commissions: SaleSummaryCommission;
  costOfGoodSold: SaleSummaryCostOfGoodSold;
  data: Array<SaleSummaryData>;
  discountAmount: SaleSummaryDiscountAmount;
  grossProfit: SaleSummaryGrossProfit;
  grossSales: SaleSummaryGrossSale;
  itemsSold: SaleSummaryItemSold;
  netSales: SaleSummaryNetSale;
  orders: SaleSummaryOrder;
  shippingPrice: SaleSummaryShippingPrice;
  tax: SaleSummaryTax;
  timeRange: Scalars['String']['output'];
  voucherAmount: SaleSummaryVoucherAmount;
};

export type SaleSummaryAverageCommission = {
  __typename?: 'SaleSummaryAverageCommission';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryAverageCommissionV2 = {
  __typename?: 'SaleSummaryAverageCommissionV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryAverageItemDiscount = {
  __typename?: 'SaleSummaryAverageItemDiscount';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryAverageItemDiscountV2 = {
  __typename?: 'SaleSummaryAverageItemDiscountV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryAverageOrderPerDay = {
  __typename?: 'SaleSummaryAverageOrderPerDay';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type SaleSummaryAverageOrderPerDayV2 = {
  __typename?: 'SaleSummaryAverageOrderPerDayV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type SaleSummaryAverageOrderValue = {
  __typename?: 'SaleSummaryAverageOrderValue';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryAverageOrderValueV2 = {
  __typename?: 'SaleSummaryAverageOrderValueV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryCommission = {
  __typename?: 'SaleSummaryCommission';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryCommissionV2 = {
  __typename?: 'SaleSummaryCommissionV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryCostOfGoodSold = {
  __typename?: 'SaleSummaryCostOfGoodSold';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryCostOfGoodSoldV2 = {
  __typename?: 'SaleSummaryCostOfGoodSoldV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryData = {
  __typename?: 'SaleSummaryData';
  avgOrderValue: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  costOfGoodSold: Scalars['String']['output'];
  discount: Scalars['String']['output'];
  grossProfit: Scalars['String']['output'];
  grossSales: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  itemSold: Scalars['Int']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  netSales: Scalars['String']['output'];
  orders: Scalars['Int']['output'];
  settingUrl: Scalars['String']['output'];
  settingUrlHref: Scalars['String']['output'];
  shipping: Scalars['String']['output'];
  subTotal: Scalars['String']['output'];
  tax: Scalars['String']['output'];
  voucher: Scalars['String']['output'];
};

export type SaleSummaryDataV2 = {
  __typename?: 'SaleSummaryDataV2';
  avgInvoiceValue: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  costOfGoodSold: Scalars['String']['output'];
  discount: Scalars['String']['output'];
  grossProfit: Scalars['String']['output'];
  grossSales: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  invoices: Scalars['Int']['output'];
  itemSold: Scalars['Int']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  netSales: Scalars['String']['output'];
  settingUrl: Scalars['String']['output'];
  settingUrlHref: Scalars['String']['output'];
  shipping: Scalars['String']['output'];
  subTotal: Scalars['String']['output'];
  tax: Scalars['String']['output'];
  voucher: Scalars['String']['output'];
};

export type SaleSummaryDiscountAmount = {
  __typename?: 'SaleSummaryDiscountAmount';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryDiscountAmountV2 = {
  __typename?: 'SaleSummaryDiscountAmountV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryFilterByV2 = {
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SaleSummaryGrossProfit = {
  __typename?: 'SaleSummaryGrossProfit';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryGrossProfitV2 = {
  __typename?: 'SaleSummaryGrossProfitV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryGrossSale = {
  __typename?: 'SaleSummaryGrossSale';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryGrossSaleV2 = {
  __typename?: 'SaleSummaryGrossSaleV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryItemSold = {
  __typename?: 'SaleSummaryItemSold';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type SaleSummaryItemSoldV2 = {
  __typename?: 'SaleSummaryItemSoldV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type SaleSummaryNetSale = {
  __typename?: 'SaleSummaryNetSale';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryNetSaleV2 = {
  __typename?: 'SaleSummaryNetSaleV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryOrder = {
  __typename?: 'SaleSummaryOrder';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type SaleSummaryOrderV2 = {
  __typename?: 'SaleSummaryOrderV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type SaleSummaryShippingPrice = {
  __typename?: 'SaleSummaryShippingPrice';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryShippingPriceV2 = {
  __typename?: 'SaleSummaryShippingPriceV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryTax = {
  __typename?: 'SaleSummaryTax';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryTaxV2 = {
  __typename?: 'SaleSummaryTaxV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryV2 = {
  __typename?: 'SaleSummaryV2';
  avgCommissions?: Maybe<SaleSummaryAverageCommissionV2>;
  avgInvoiceValue: SaleSummaryAverageOrderValueV2;
  avgInvoicesPerDay: SaleSummaryAverageOrderPerDayV2;
  avgItemDiscount: SaleSummaryAverageItemDiscountV2;
  commissions: SaleSummaryCommissionV2;
  costOfGoodSold: SaleSummaryCostOfGoodSoldV2;
  data: Array<SaleSummaryDataV2>;
  discountAmount: SaleSummaryDiscountAmountV2;
  grossProfit: SaleSummaryGrossProfitV2;
  grossSales: SaleSummaryGrossSaleV2;
  invoices: SaleSummaryOrderV2;
  itemsSold: SaleSummaryItemSoldV2;
  netSales: SaleSummaryNetSaleV2;
  shippingPrice: SaleSummaryShippingPriceV2;
  tax: SaleSummaryTaxV2;
  timeRange: Scalars['String']['output'];
  voucherAmount: SaleSummaryVoucherAmountV2;
};

export type SaleSummaryVoucherAmount = {
  __typename?: 'SaleSummaryVoucherAmount';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SaleSummaryVoucherAmountV2 = {
  __typename?: 'SaleSummaryVoucherAmountV2';
  percentage: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SalesAgent = {
  __typename?: 'SalesAgent';
  approvedAt?: Maybe<Scalars['Time']['output']>;
  balanceAvailable: Scalars['Float']['output'];
  balancePending: Scalars['Float']['output'];
  bankAccountName: Scalars['String']['output'];
  bankAccountNumber: Scalars['String']['output'];
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']['output']>;
  company: Scalars['String']['output'];
  contactId: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  dateOfBirth?: Maybe<Scalars['Time']['output']>;
  gender?: Maybe<SalesAgentGender>;
  id: Scalars['Int']['output'];
  ktpImageUrl?: Maybe<Scalars['String']['output']>;
  ktpNumber?: Maybe<Scalars['String']['output']>;
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  npwpImageUrl?: Maybe<Scalars['String']['output']>;
  npwpNumber?: Maybe<Scalars['String']['output']>;
  orderOverview: SalesAgentOrderOverview;
  phoneNumber: Scalars['String']['output'];
  referralCode: Scalars['String']['output'];
  status: SalesAgentStatus;
  updatedAt: Scalars['Time']['output'];
};

export type SalesAgentActionResponse = {
  __typename?: 'SalesAgentActionResponse';
  data?: Maybe<SalesAgent>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum SalesAgentActionStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type SalesAgentConnection = {
  __typename?: 'SalesAgentConnection';
  edges: Array<SalesAgentEdge>;
  nodes: Array<SalesAgent>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type SalesAgentEdge = {
  __typename?: 'SalesAgentEdge';
  cursor: Scalars['String']['output'];
  node: SalesAgent;
};

export type SalesAgentFilter = {
  status?: InputMaybe<SalesAgentStatus>;
};

export enum SalesAgentGender {
  Female = 'female',
  Male = 'male'
}

export type SalesAgentOrderOverview = {
  __typename?: 'SalesAgentOrderOverview';
  averageOrderSalesAmount: Scalars['Float']['output'];
  totalItemSold: Scalars['Float']['output'];
  totalOrderCount: Scalars['Int']['output'];
  totalOrderSalesAmount: Scalars['Float']['output'];
};

export type SalesAgentPayout = {
  __typename?: 'SalesAgentPayout';
  bankAccount: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['Int']['output'];
  orderCount: Scalars['Int']['output'];
  paidAt?: Maybe<Scalars['Time']['output']>;
  paymentGatewayFeeAmount: Scalars['Float']['output'];
  paymentGatewayFeeVatAmount: Scalars['Float']['output'];
  payoutAt?: Maybe<Scalars['Time']['output']>;
  payoutStatus: SalesAgentPayoutStatus;
  phoneNumber: Scalars['String']['output'];
  profileId: Scalars['Int']['output'];
  salesAgentId: Scalars['Int']['output'];
  salesAgentName: Scalars['String']['output'];
  subtotalPayout: Scalars['Float']['output'];
  taxFeeAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  transactionIds: Array<Scalars['Int']['output']>;
  transactions: Array<SalesAgentTransaction>;
  updatedAt: Scalars['Time']['output'];
};

export type SalesAgentPayoutActionData = {
  __typename?: 'SalesAgentPayoutActionData';
  isAlreadyTargetStatus: Scalars['Boolean']['output'];
  isBalanceDeducted: Scalars['Boolean']['output'];
  isStatusUpdated: Scalars['Boolean']['output'];
  isTransactionPaidOut: Scalars['Boolean']['output'];
  orderCount: Scalars['Int']['output'];
  paidOutTransactionCount: Scalars['Int']['output'];
  paymentGatewayFeeAmount: Scalars['Float']['output'];
  paymentGatewayFeeVatAmount: Scalars['Float']['output'];
  payoutId: Scalars['Int']['output'];
  payoutStatus: SalesAgentPayoutStatus;
  previousStatus: SalesAgentPayoutStatus;
  profileId: Scalars['Int']['output'];
  salesAgentId: Scalars['Int']['output'];
  subtotalPayout: Scalars['Float']['output'];
  taxFeeAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type SalesAgentPayoutActionResponse = {
  __typename?: 'SalesAgentPayoutActionResponse';
  data?: Maybe<SalesAgentPayoutActionData>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum SalesAgentPayoutActionStatus {
  Completed = 'COMPLETED',
  PendingTransfer = 'PENDING_TRANSFER',
  Rejected = 'REJECTED'
}

export type SalesAgentPayoutConnection = {
  __typename?: 'SalesAgentPayoutConnection';
  edges: Array<SalesAgentPayoutEdge>;
  nodes: Array<SalesAgentPayout>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type SalesAgentPayoutEdge = {
  __typename?: 'SalesAgentPayoutEdge';
  cursor: Scalars['String']['output'];
  node: SalesAgentPayout;
};

export type SalesAgentPayoutFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  salesAgentId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SalesAgentPayoutStatus>;
};

export type SalesAgentPayoutSort = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export enum SalesAgentPayoutStatus {
  Completed = 'COMPLETED',
  PendingApproval = 'PENDING_APPROVAL',
  PendingTransfer = 'PENDING_TRANSFER',
  Rejected = 'REJECTED'
}

export type SalesAgentRegisterInput = {
  bankAccountName: Scalars['String']['input'];
  bankAccountNumber: Scalars['String']['input'];
  cityId?: InputMaybe<Scalars['Int']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<SalesAgentGender>;
  ktpImageUrl?: InputMaybe<Scalars['String']['input']>;
  ktpNumber?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  npwpImageUrl?: InputMaybe<Scalars['String']['input']>;
  npwpNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type SalesAgentSort = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export enum SalesAgentStatus {
  Approved = 'APPROVED',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED'
}

export type SalesAgentTransaction = {
  __typename?: 'SalesAgentTransaction';
  createdAt: Scalars['Time']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  histories: Array<SalesAgentTransactionHistory>;
  id: Scalars['Int']['output'];
  itemlines: Array<SalesAgentTransactionItemline>;
  orderId: Scalars['Int']['output'];
  orderStatus: SalesAgentTransactionOrderStatus;
  payoutFee: Scalars['Float']['output'];
  salesAgentId: Scalars['Int']['output'];
  salesAgentName: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  totalCommissionAmount: Scalars['Float']['output'];
  transactionStatus: SalesAgentTransactionStatus;
  updatedAt: Scalars['Time']['output'];
};

export type SalesAgentTransactionConnection = {
  __typename?: 'SalesAgentTransactionConnection';
  edges: Array<SalesAgentTransactionEdge>;
  nodes: Array<SalesAgentTransaction>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type SalesAgentTransactionEdge = {
  __typename?: 'SalesAgentTransactionEdge';
  cursor: Scalars['String']['output'];
  node: SalesAgentTransaction;
};

export type SalesAgentTransactionFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  salesAgentId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SalesAgentTransactionStatus>;
};

export type SalesAgentTransactionHistory = {
  __typename?: 'SalesAgentTransactionHistory';
  date: Scalars['Time']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SalesAgentTransactionItemline = {
  __typename?: 'SalesAgentTransactionItemline';
  categoryId: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  commissionAmount: Scalars['Float']['output'];
  commissionFix: Scalars['Float']['output'];
  commissionPercentage: Scalars['Float']['output'];
  itemVariantId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
};

export type SalesAgentTransactionMetrics = {
  __typename?: 'SalesAgentTransactionMetrics';
  totalCommissionAmount: Scalars['Float']['output'];
  totalSalesAmount: Scalars['Float']['output'];
  totalTransaction: Scalars['Int']['output'];
};

export enum SalesAgentTransactionOrderStatus {
  Cancelled = 'CANCELLED',
  CancelledByBuyer = 'CANCELLED_BY_BUYER',
  CancelledBySeller = 'CANCELLED_BY_SELLER',
  CancelledBySystem = 'CANCELLED_BY_SYSTEM',
  CancelRequested = 'CANCEL_REQUESTED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  DeliveredReturned = 'DELIVERED_RETURNED',
  Draft = 'DRAFT',
  FailedDelivery = 'FAILED_DELIVERY',
  Fulfilled = 'FULFILLED',
  HandedOver = 'HANDED_OVER',
  InvalidStatus = 'INVALID_STATUS',
  InPicking = 'IN_PICKING',
  InProgress = 'IN_PROGRESS',
  NotShipped = 'NOT_SHIPPED',
  Open = 'OPEN',
  PendingCourier = 'PENDING_COURIER',
  PendingPayment = 'PENDING_PAYMENT',
  Picked = 'PICKED',
  PickedUp = 'PICKED_UP',
  Printed = 'PRINTED',
  ReadyToShip = 'READY_TO_SHIP',
  Returned = 'RETURNED',
  ReturnConfirmed = 'RETURN_CONFIRMED',
  ReturnRejected = 'RETURN_REJECTED',
  ReturnRequested = 'RETURN_REQUESTED',
  Shipped = 'SHIPPED'
}

export type SalesAgentTransactionSort = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export enum SalesAgentTransactionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Paid = 'PAID',
  Payout = 'PAYOUT',
  PendingPayment = 'PENDING_PAYMENT',
  Settled = 'SETTLED'
}

export type SaveDraftInput = {
  draftId?: InputMaybe<Scalars['Int']['input']>;
  products: Array<InputDraftProduct>;
};

export type SaveDraftProductPayload = {
  __typename?: 'SaveDraftProductPayload';
  draftId: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  products: Array<DraftProductPayload>;
};

export enum SearchBy {
  ContactId = 'contactId',
  RoomId = 'roomId'
}

export type Sections = {
  __typename?: 'Sections';
  name: Scalars['String']['output'];
  pages: Array<Pages>;
};

export type SetDefaultWarehouseInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type SetDefaultWarehousePayload = {
  __typename?: 'SetDefaultWarehousePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
};

export type SetStatusWarehouseInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type SetStatusWarehousePayload = {
  __typename?: 'SetStatusWarehousePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
};

export type SettingPicklistInput = {
  picklist: Scalars['Boolean']['input'];
};

export type SettingPicklistPayload = {
  __typename?: 'SettingPicklistPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SettingUserWarehouseInput = {
  warehouseID: Scalars['Int']['input'];
};

export type SettingUserWarehousePayload = {
  __typename?: 'SettingUserWarehousePayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ShipmentActivity = {
  __typename?: 'ShipmentActivity';
  actionAt: Scalars['Time']['output'];
  actionName: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inProgress: Scalars['Boolean']['output'];
  ipAddress: Scalars['String']['output'];
  isSuccess: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  profileID: Scalars['Int']['output'];
  shipmentID: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userEmail: Scalars['String']['output'];
  userID: Scalars['Int']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type ShipmentPop = {
  __typename?: 'ShipmentPop';
  orders?: Maybe<Array<Maybe<Order>>>;
};

export type ShipperCourier = {
  __typename?: 'ShipperCourier';
  group: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ShipperUser = {
  __typename?: 'ShipperUser';
  couriers?: Maybe<Array<ShipperCourier>>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type ShippingAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
};

export enum ShippingCourierType {
  Default = 'default',
  FlatRate = 'flat_rate',
  FreeShipping = 'free_shipping'
}

export type ShippingLabelImages = {
  __typename?: 'ShippingLabelImages';
  orderName?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type ShippingPriceLocation = {
  address?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  subDistrictId?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export type ShippingPriceRequest = {
  cartId: Scalars['String']['input'];
};

export type ShippingPrices = {
  __typename?: 'ShippingPrices';
  cost?: Maybe<Scalars['Int']['output']>;
  cutOffTime?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  internalNote?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<Scalars['Int']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceType?: Maybe<Scalars['String']['output']>;
  subdistrictDestination?: Maybe<Scalars['Int']['output']>;
  subdistrictOrigin?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export enum Sort {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortReportingDashboardByInput = {
  percentage_total_product_discount?: InputMaybe<Sort>;
  total_product_discount?: InputMaybe<Sort>;
  total_quantity_sold?: InputMaybe<Sort>;
  total_regular_price?: InputMaybe<Sort>;
  total_selling_price?: InputMaybe<Sort>;
};

export type Status = {
  __typename?: 'Status';
  actionAvailabilities?: Maybe<Array<Maybe<ActionAvailability>>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type StockAdjustment = {
  __typename?: 'StockAdjustment';
  actionAvailabilities: Array<StockAdjustmentActionAvailability>;
  activityId: Scalars['Int']['output'];
  activitySummaryUrl?: Maybe<Scalars['String']['output']>;
  adjusmentId: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  itemLines: Array<StockAdjustmentItemLine>;
  receivedBy?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalQtyAdjusted: Scalars['Int']['output'];
  totalSku: Scalars['Int']['output'];
  totalSkuAdjusted: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouseName: Scalars['String']['output'];
};

export type StockAdjustmentActionAvailability = {
  __typename?: 'StockAdjustmentActionAvailability';
  group: StockAdjustmentActionAvailabilityGroup;
  name: Scalars['String']['output'];
};

export type StockAdjustmentActionAvailabilityGroup = {
  __typename?: 'StockAdjustmentActionAvailabilityGroup';
  action: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StockAdjustmentConnection = {
  __typename?: 'StockAdjustmentConnection';
  edges?: Maybe<Array<Maybe<StockAdjustmentEdge>>>;
  nodes?: Maybe<Array<Maybe<StockAdjustment>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type StockAdjustmentEdge = {
  __typename?: 'StockAdjustmentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<StockAdjustment>;
};

export type StockAdjustmentFilterByInputs = {
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StockAdjustmentItemLine = {
  __typename?: 'StockAdjustmentItemLine';
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  newQtyOnHand: Scalars['Int']['output'];
  options: Array<StockAdjustmentItemLineOption>;
  qtyAdjusted: Scalars['Int']['output'];
  qtyOnHand: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

export type StockAdjustmentItemLineOption = {
  __typename?: 'StockAdjustmentItemLineOption';
  option: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StockAdjustmentSort = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type StockHistories = {
  __typename?: 'StockHistories';
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  dashboardUserId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  newQuantity?: Maybe<Scalars['Int']['output']>;
  quantityIn?: Maybe<Scalars['String']['output']>;
  quantityOut?: Maybe<Scalars['String']['output']>;
  warehouseSpaceId: Scalars['Int']['output'];
};

export type StockHistory = {
  __typename?: 'StockHistory';
  batchId: Scalars['String']['output'];
  bin?: Maybe<Bin>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  locationId: Scalars['String']['output'];
  /** Where an Opening Balance came from. Null for other history types. */
  openingSource?: Maybe<StockHistoryOpeningSource>;
  productName: Scalars['String']['output'];
  productSku: Scalars['String']['output'];
  qtyIn: Scalars['Int']['output'];
  qtyOnHand: Scalars['Int']['output'];
  qtyOut: Scalars['Int']['output'];
  storeName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  typeRefId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Time']['output'];
  warehouseName: Scalars['String']['output'];
};

/** The connection type for StockHistory. */
export type StockHistoryConnection = {
  __typename?: 'StockHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StockHistoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<StockHistory>>>;
  /** A list of page cursors. */
  pageCursors?: Maybe<Array<PageCursor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StockHistoryEdge = {
  __typename?: 'StockHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<StockHistory>;
};

export type StockHistoryFilterByInputs = {
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseOldTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StockHistoryOpeningSource = {
  __typename?: 'StockHistoryOpeningSource';
  activityId?: Maybe<Scalars['Int']['output']>;
  /** Recorded activity description, e.g. Import Items Shopee (Account 13865), or Sumber tidak tercatat */
  label: Scalars['String']['output'];
  summaryUrl?: Maybe<Scalars['String']['output']>;
  /** import, activity, or unknown (origin not recorded) */
  type: Scalars['String']['output'];
};

export type StockInbound = {
  __typename?: 'StockInbound';
  actionAvailabilities: Array<StockInboundActionAvailability>;
  activityId: Scalars['Int']['output'];
  activitySummaryUrl?: Maybe<Scalars['String']['output']>;
  actualQuantity: Scalars['Int']['output'];
  actualQuantityPutaway: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  failedCount: Scalars['Int']['output'];
  goodReceives: Array<GoodReceive>;
  id: Scalars['Int']['output'];
  inboundAt: Scalars['String']['output'];
  inboundId: Scalars['String']['output'];
  inboundType: InboundType;
  itemLines: Array<StockInboundItemLine>;
  putawayStatus: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  quantityPutaway: Scalars['Int']['output'];
  receiveBy: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalInboundedQty: Scalars['Int']['output'];
  totalSku: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  warehouse: Scalars['String']['output'];
};

export type StockInboundActionAvailability = {
  __typename?: 'StockInboundActionAvailability';
  group: StockInboundActionAvailabilityGroup;
  name: Scalars['String']['output'];
};

export type StockInboundActionAvailabilityGroup = {
  __typename?: 'StockInboundActionAvailabilityGroup';
  action: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StockInboundConnection = {
  __typename?: 'StockInboundConnection';
  edges: Array<StockInboundEdge>;
  nodes: Array<StockInbound>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type StockInboundEdge = {
  __typename?: 'StockInboundEdge';
  cursor: Scalars['String']['output'];
  node: StockInbound;
};

export type StockInboundFilter = {
  inboundType?: InputMaybe<InboundType>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StockInboundItemLine = {
  __typename?: 'StockInboundItemLine';
  actualQuantityInbound: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  inboundDate: Scalars['String']['output'];
  inboundStatus: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Array<StockInboundItemLineOption>;
  putawayStatus: Scalars['String']['output'];
  quantityInbound: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

export type StockInboundItemLineOption = {
  __typename?: 'StockInboundItemLineOption';
  option: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StockInboundPutaway = {
  __typename?: 'StockInboundPutaway';
  actualQuantity: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  warehouse: Scalars['String']['output'];
};

export type StockInboundSort = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type StockOutbound = {
  __typename?: 'StockOutbound';
  actionAvailabilities: Array<StockOutboundActionAvailability>;
  activityId: Scalars['Int']['output'];
  activitySummaryUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  itemLines: Array<StockOutboundItemLine>;
  outboundAt: Scalars['String']['output'];
  outboundId: Scalars['String']['output'];
  receivedBy: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  totalActualQty: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalOutboundedQty: Scalars['Int']['output'];
  totalQty: Scalars['Int']['output'];
  totalSku: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  warehouse: Scalars['String']['output'];
};

export type StockOutboundActionAvailability = {
  __typename?: 'StockOutboundActionAvailability';
  group: StockOutboundActionAvailabilityGroup;
  name: Scalars['String']['output'];
};

export type StockOutboundActionAvailabilityGroup = {
  __typename?: 'StockOutboundActionAvailabilityGroup';
  action: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StockOutboundConnection = {
  __typename?: 'StockOutboundConnection';
  edges: Array<StockOutboundEdge>;
  nodes: Array<StockOutbound>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type StockOutboundEdge = {
  __typename?: 'StockOutboundEdge';
  cursor: Scalars['String']['output'];
  node: StockOutbound;
};

export type StockOutboundFilter = {
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StockOutboundItemLine = {
  __typename?: 'StockOutboundItemLine';
  actualQtyOutbound: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Array<StockOutboundItemLineOption>;
  outboundDate: Scalars['String']['output'];
  outboundStatus: Scalars['String']['output'];
  qtyToOutbound: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

export type StockOutboundItemLineOption = {
  __typename?: 'StockOutboundItemLineOption';
  option: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StockOutboundPutaway = {
  __typename?: 'StockOutboundPutaway';
  actualQuantity: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  warehouse: Scalars['String']['output'];
};

export type StockOutboundSort = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type StockSyncInput = {
  accountId: Scalars['Int']['input'];
  channelId: Scalars['Int']['input'];
  listingId: Array<Scalars['Int']['input']>;
};

export type StockSyncPayload = {
  __typename?: 'StockSyncPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type StockTransfer = {
  __typename?: 'StockTransfer';
  actionAvailabilities: Array<StockTransferActionAvailability>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  destinationWarehouse: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  inboundAt?: Maybe<Scalars['String']['output']>;
  inboundId?: Maybe<Scalars['Int']['output']>;
  itemLines: Array<StockTransferItemLine>;
  originWarehouse: Scalars['String']['output'];
  outboundAt?: Maybe<Scalars['String']['output']>;
  outboundId?: Maybe<Scalars['Int']['output']>;
  receivedBy: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalActualQty: Scalars['Int']['output'];
  totalQty: Scalars['Int']['output'];
  totalSku: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type StockTransferActionAvailability = {
  __typename?: 'StockTransferActionAvailability';
  group: StockTransferActionAvailabilityGroup;
  name: Scalars['String']['output'];
};

export type StockTransferActionAvailabilityGroup = {
  __typename?: 'StockTransferActionAvailabilityGroup';
  action: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StockTransferConnection = {
  __typename?: 'StockTransferConnection';
  edges: Array<StockTransferEdge>;
  nodes: Array<StockTransfer>;
  pageCursors: Array<PageCursor>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type StockTransferEdge = {
  __typename?: 'StockTransferEdge';
  cursor: Scalars['String']['output'];
  node: StockTransfer;
};

export type StockTransferFilter = {
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseOriginTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StockTransferItemLine = {
  __typename?: 'StockTransferItemLine';
  actualQtyTransfer: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Array<StockTransferItemLineOption>;
  qtyToTransfer: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

export type StockTransferItemLineOption = {
  __typename?: 'StockTransferItemLineOption';
  option: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StockTransferSort = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type StoreAccount = {
  __typename?: 'StoreAccount';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type StoreAddress = {
  __typename?: 'StoreAddress';
  address: Scalars['String']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  subDistrict?: Maybe<SubDistrict>;
  subdistrictId: Scalars['Int']['output'];
};

export type StoreAddressInput = {
  address: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  subdistrictId: Scalars['Int']['input'];
};

export type StoreConversation = {
  __typename?: 'StoreConversation';
  botAgent: Scalars['Int']['output'];
  channel: LiveViewChannel;
  humanAgents: Scalars['Int']['output'];
  mine: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
};

export type StoreHours = {
  __typename?: 'StoreHours';
  close?: Maybe<Scalars['String']['output']>;
  day: Scalars['String']['output'];
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  open?: Maybe<Scalars['String']['output']>;
};

export type StoreHoursInput = {
  close?: InputMaybe<Scalars['String']['input']>;
  day: Scalars['String']['input'];
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  open?: InputMaybe<Scalars['String']['input']>;
};

export type StoreV2 = {
  __typename?: 'StoreV2';
  accountId: Scalars['Int']['output'];
  alias: Scalars['String']['output'];
  blibliAccessToken: Scalars['String']['output'];
  blibliAccessTokenExpiresAt?: Maybe<Scalars['String']['output']>;
  blibliBusinessPartnerCode: Scalars['String']['output'];
  blibliClientSecret: Scalars['String']['output'];
  blibliMtaPassword: Scalars['String']['output'];
  blibliMtaUsername: Scalars['String']['output'];
  blibliRefreshToken: Scalars['String']['output'];
  channelIconUrl: Scalars['String']['output'];
  channelId: Scalars['Int']['output'];
  channelName: Scalars['String']['output'];
  channelSync: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  digital: Scalars['Boolean']['output'];
  fsApiSecret: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  importItemSetting: Scalars['Int']['output'];
  itemQcLastLog: Scalars['String']['output'];
  lastSyncedItemAt?: Maybe<Scalars['String']['output']>;
  lastSyncedItemQcAt?: Maybe<Scalars['String']['output']>;
  lastSyncedOrderAt?: Maybe<Scalars['String']['output']>;
  localId: Scalars['String']['output'];
  localName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  newAccountId: Scalars['String']['output'];
  newId: Scalars['String']['output'];
  pollingCheckVariants: Scalars['Boolean']['output'];
  pollingOrder: Scalars['Boolean']['output'];
  pollingOrderInterval: Scalars['Int']['output'];
  pollingQcInterval: Scalars['Int']['output'];
  pollingQcStatus: Scalars['Boolean']['output'];
  pollingReservedQuantity: Scalars['Boolean']['output'];
  redirectUrl: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  settings: Array<StoreV2MapEntry>;
  settingsJson: Array<StoreV2MapEntry>;
  sortOrder: Scalars['Int']['output'];
  taxSetting: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  tokenAccess: Scalars['String']['output'];
  tokenAccessExpiresAt?: Maybe<Scalars['String']['output']>;
  tokenRefresh: Scalars['String']['output'];
  tokopediaClientId: Scalars['String']['output'];
  tokopediaClientSecret: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  whitelistSkus: Scalars['String']['output'];
};

export type StoreV2MapEntry = {
  __typename?: 'StoreV2MapEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type StoresPayload = {
  __typename?: 'StoresPayload';
  id?: Maybe<Scalars['Int']['output']>;
  storeImage?: Maybe<Scalars['String']['output']>;
  storeImageName?: Maybe<Scalars['String']['output']>;
  storeName?: Maybe<Scalars['String']['output']>;
};

export type SubDistrict = {
  __typename?: 'SubDistrict';
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  lon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type SubDistrictInput = {
  districtId: Scalars['Int']['input'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Summary = {
  __typename?: 'Summary';
  channelName?: Maybe<Scalars['String']['output']>;
  customerNAme?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  orderID?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  storeName?: Maybe<Scalars['String']['output']>;
};

export type SyncOrderInput = {
  accountId: Scalars['Int']['input'];
  localIds: Array<Scalars['String']['input']>;
};

export type SyncOrderPayload = {
  __typename?: 'SyncOrderPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TaxSetting = {
  __typename?: 'TaxSetting';
  rate?: Maybe<Scalars['Int']['output']>;
  setting?: Maybe<Scalars['Boolean']['output']>;
};

export type Template = {
  __typename?: 'Template';
  accountName: Scalars['String']['output'];
  category: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  endedAt?: Maybe<Scalars['Time']['output']>;
  errorStatus: Scalars['String']['output'];
  firstSentAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  isVariable?: Maybe<Scalars['Boolean']['output']>;
  language: Scalars['String']['output'];
  lastSentAt?: Maybe<Scalars['Time']['output']>;
  messageFailed: Scalars['Int']['output'];
  messageRead: Scalars['Int']['output'];
  messageSent: Scalars['Int']['output'];
  messageSuccess: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  performance?: Maybe<MessagePerformance>;
  startedAt?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  statusQuality?: Maybe<Scalars['String']['output']>;
  syncAt?: Maybe<Scalars['Time']['output']>;
  templateId: Scalars['String']['output'];
  templatePreview?: Maybe<Array<Maybe<TemplatePreview>>>;
  totalClicks?: Maybe<Array<MessageTotalClick>>;
  type: TemplateType;
  uniqueClicks?: Maybe<Array<MessageUniqueClick>>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type TemplateActivityConnection = {
  __typename?: 'TemplateActivityConnection';
  edges?: Maybe<Array<Maybe<TemplateActivityEdge>>>;
  nodes?: Maybe<Array<Maybe<WhatsappTemplateActivity>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type TemplateActivityEdge = {
  __typename?: 'TemplateActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<WhatsappTemplateActivity>;
};

export type TemplateConnection = {
  __typename?: 'TemplateConnection';
  edges?: Maybe<Array<Maybe<TemplateEdge>>>;
  nodes?: Maybe<Array<Maybe<Template>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

export type TemplateEdge = {
  __typename?: 'TemplateEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Template>;
};

export type TemplateFilter = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type TemplatePreview = {
  __typename?: 'TemplatePreview';
  buttons?: Maybe<Array<Maybe<TemplatePreviewButton>>>;
  cards?: Maybe<Array<Maybe<TemplatePreviewCard>>>;
  example?: Maybe<TemplatePreviewExample>;
  format?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TemplatePreviewCard = {
  __typename?: 'TemplatePreviewCard';
  components?: Maybe<Array<Maybe<TemplatePreview>>>;
};

export type TemplateSortByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export enum TemplateType {
  Carousel = 'CAROUSEL',
  Regular = 'REGULAR'
}

export type TextNamedParamInput = {
  example?: InputMaybe<Scalars['String']['input']>;
  paramName?: InputMaybe<Scalars['String']['input']>;
};

export type Todo = {
  __typename?: 'Todo';
  done: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  user: User;
};

export type TransactionDescriptionPayload = {
  __typename?: 'TransactionDescriptionPayload';
  descriptions: Array<Scalars['String']['output']>;
};

export type UnarchivedProductsPayload = {
  __typename?: 'UnarchivedProductsPayload';
  message: Scalars['String']['output'];
};

/** Autogenerated input type of UpdateAccount */
export type UpdateAccountInput = {
  accurateMapping?: InputMaybe<AccurateMappingInput>;
  address?: InputMaybe<AddressInput>;
  channelIcon?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyLogo?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  courierSetting?: InputMaybe<CourierSettingInput>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  jurnalMapping?: InputMaybe<JurnalMappingInput>;
  name: Scalars['String']['input'];
  stockSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  storeUrl?: InputMaybe<Scalars['String']['input']>;
  warehouseMappings?: InputMaybe<Array<WarehouseMappingInput>>;
};

/** Autogenerated return type of UpdateAccount */
export type UpdateAccountPayload = {
  __typename?: 'UpdateAccountPayload';
  account: AccountRuby;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateDashboardUser */
export type UpdateDashboardUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateDashboardUser */
export type UpdateDashboardUserPayload = {
  __typename?: 'UpdateDashboardUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dashboardUser: DashboardUser;
};

export type UpdateInventorySettingLevelInput = {
  batchId: Scalars['Boolean']['input'];
  bin: Scalars['Boolean']['input'];
  expiredDate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  serialNumber: Scalars['Boolean']['input'];
};

export type UpdateInventorySettings = {
  __typename?: 'UpdateInventorySettings';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateInventorySettingsInput = {
  level?: InputMaybe<UpdateInventorySettingLevelInput>;
  lowStockAlert?: InputMaybe<LowStockAlertInput>;
  priorityStore?: InputMaybe<PriorityStoreInput>;
  reservedStockRules?: InputMaybe<ReservedStockRulesInput>;
};

/** Autogenerated input type of UpdateInvoice */
export type UpdateInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isAutoCreate: Scalars['Boolean']['input'];
  isAutoPaid?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDateOption?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  statusAutoCreate?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateInvoice */
export type UpdateInvoicePayload = {
  __typename?: 'UpdateInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  profile: Profile;
};

export type UpdateInvoiceStatus = {
  __typename?: 'UpdateInvoiceStatus';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateInvoiceStatusInput = {
  id: Scalars['Int']['input'];
  status: Scalars['String']['input'];
};

export type UpdateOrderNote = {
  __typename?: 'UpdateOrderNote';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrderNoteInput = {
  id: Scalars['Int']['input'];
  stringNote: Scalars['String']['input'];
};

export type UpdatePicklistInput = {
  id: Scalars['Int']['input'];
  itemLines?: InputMaybe<Array<UpdatePicklistItemLinesInput>>;
  pickerId?: InputMaybe<Scalars['Int']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePicklistItemLineBundlesInput = {
  binId?: InputMaybe<Scalars['String']['input']>;
  itemLineBundleId: Scalars['Int']['input'];
  itemNote?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  qtyPicked: Scalars['Int']['input'];
  serialNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdatePicklistItemLinesInput = {
  binId?: InputMaybe<Scalars['String']['input']>;
  itemLineBundles?: InputMaybe<Array<InputMaybe<UpdatePicklistItemLineBundlesInput>>>;
  itemLineId: Scalars['Int']['input'];
  itemNote?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  qtyPicked: Scalars['Int']['input'];
  serialNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdatePicklistPayload = {
  __typename?: 'UpdatePicklistPayload';
  message: Scalars['String']['output'];
  picklist?: Maybe<Picklist>;
};

export type UpdatePrintDocumentSettings = {
  __typename?: 'UpdatePrintDocumentSettings';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdatePrintDocumentSettingsInput = {
  brandLogo: Scalars['Boolean']['input'];
  brandLogoUrl: Scalars['String']['input'];
  buyerNote: Scalars['Boolean']['input'];
  channelLogo: Scalars['Boolean']['input'];
  forstokOrderID: Scalars['Boolean']['input'];
  logisticLogo: Scalars['Boolean']['input'];
  packagingInfo: Scalars['Boolean']['input'];
  productName: Scalars['Boolean']['input'];
  quantityOrdered: Scalars['Boolean']['input'];
  sellerName: Scalars['Boolean']['input'];
  sellerNote: Scalars['Boolean']['input'];
  sellerNotes: Scalars['String']['input'];
  sellerPhone: Scalars['Boolean']['input'];
  skuCode: Scalars['Boolean']['input'];
  variantName: Scalars['Boolean']['input'];
};

/** Autogenerated input type of UpdateRole */
export type UpdateRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  permissionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  permissions?: InputMaybe<Array<PermissionInputs>>;
};

/** Autogenerated return type of UpdateRole */
export type UpdateRolePayload = {
  __typename?: 'UpdateRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  role: Role;
};

/** Autogenerated input type of UpdateShipperUser */
export type UpdateShipperUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  shipperCourierIds: Array<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateShipperUser */
export type UpdateShipperUserPayload = {
  __typename?: 'UpdateShipperUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  shipper: ShipperUser;
};

/** Autogenerated input type of UpdateTax */
export type UpdateTaxInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  taxRate?: InputMaybe<Scalars['Int']['input']>;
  taxSetting: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateTax */
export type UpdateTaxPayload = {
  __typename?: 'UpdateTaxPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  profile: Profile;
};

export type UpdateWarehouseInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isPos?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subDistrictId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWarehousePayload = {
  __typename?: 'UpdateWarehousePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
};

export type UploadExcelDocumentResponse = {
  __typename?: 'UploadExcelDocumentResponse';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The connection type for VariantTypeNew. */
export type VariantConnectionTypeNew = {
  __typename?: 'VariantConnectionTypeNew';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VariantEdgeTypeNew>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VariantTypeNew>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  updateFe: Scalars['Boolean']['output'];
};

export type VariantContentListing = {
  __typename?: 'VariantContentListing';
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  listing?: Maybe<Array<Maybe<ListingVariantContentListing>>>;
  options?: Maybe<Array<Maybe<OptionVariantContentListing>>>;
  price?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  variantId?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type VariantEdgeTypeNew = {
  __typename?: 'VariantEdgeTypeNew';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VariantTypeNew>;
};

export type VariantFilter = {
  __typename?: 'VariantFilter';
  count: Scalars['Int']['output'];
  downloadUrl?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VariantFilterByInputs = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  pendingActions?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  stores?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VariantProductListing = {
  __typename?: 'VariantProductListing';
  barcode?: Maybe<Scalars['String']['output']>;
  confirmed: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isPromotion?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  masterLabelSku?: Maybe<Scalars['String']['output']>;
  masterVariantId?: Maybe<Scalars['Int']['output']>;
  masterVariantName?: Maybe<Scalars['String']['output']>;
  masterVariantSku?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<VariantProductListingOption>>>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<VariantSalePrice>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ProductListingStatus>;
  storeLabelSku?: Maybe<Scalars['String']['output']>;
  variantListingId?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type VariantProductListingOption = {
  __typename?: 'VariantProductListingOption';
  option: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type VariantSalePrice = {
  __typename?: 'VariantSalePrice';
  endAt?: Maybe<Scalars['Time']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['Time']['output']>;
};

export type VariantTypeNew = {
  __typename?: 'VariantTypeNew';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  bundle?: Maybe<BundleTypeNew>;
  config?: Maybe<Scalars['String']['output']>;
  costPrice?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  itemId: Scalars['ID']['output'];
  itemName?: Maybe<Scalars['String']['output']>;
  listings?: Maybe<Array<Listing>>;
  mainImageUrl?: Maybe<Scalars['String']['output']>;
  masterCatalog?: Maybe<MasterCatalog>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  profileId: Scalars['ID']['output'];
  reservedQuantity?: Maybe<Scalars['Int']['output']>;
  sku: Scalars['String']['output'];
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  variantType?: Maybe<Scalars['String']['output']>;
  warehouseSpaces?: Maybe<Array<WarehouseSpace>>;
};

export type Voucher = {
  __typename?: 'Voucher';
  applicableCategoryIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  applicableProducts?: Maybe<Array<Maybe<VoucherProduct>>>;
  applicableStoreIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedByUserId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  excludedProductIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isStackable?: Maybe<Scalars['Boolean']['output']>;
  logs?: Maybe<Array<Maybe<VoucherLog>>>;
  maxAmount?: Maybe<Scalars['Int']['output']>;
  minOrderValue?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  quotaPerUser?: Maybe<Scalars['Int']['output']>;
  quotaReserved?: Maybe<Scalars['Int']['output']>;
  quotaTotal?: Maybe<Scalars['Int']['output']>;
  quotaUsed?: Maybe<Scalars['Int']['output']>;
  stackGroup?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<VoucherStatus>;
  store?: Maybe<VoucherStore>;
  storeScope?: Maybe<Scalars['String']['output']>;
  type?: Maybe<VoucherType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByUserId?: Maybe<Scalars['Int']['output']>;
};

export enum VoucherActionStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE',
  Upcoming = 'UPCOMING'
}

export type VoucherAnalytics = {
  __typename?: 'VoucherAnalytics';
  averageRedemptionRate: Scalars['Float']['output'];
  redemptionRateOverTime: Array<VoucherRedemptionRateAnalyticsPoint>;
  revenueGenerated: Scalars['Int']['output'];
  totalSavingsGiven: Scalars['Int']['output'];
  totalUsage: Scalars['Int']['output'];
  usageOverTime: Array<VoucherUsageAnalyticsPoint>;
};

export type VoucherList = {
  __typename?: 'VoucherList';
  edges?: Maybe<Array<Maybe<VoucherListEdge>>>;
  nodes?: Maybe<Array<Maybe<Voucher>>>;
  pageCursors?: Maybe<Array<PageCursor>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type VoucherListEdge = {
  __typename?: 'VoucherListEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Voucher>;
};

export type VoucherLog = {
  __typename?: 'VoucherLog';
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type VoucherOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  endDate?: InputMaybe<Sort>;
  maxAmount?: InputMaybe<Sort>;
  minOrderValue?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  startDate?: InputMaybe<Sort>;
  status?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type VoucherProduct = {
  __typename?: 'VoucherProduct';
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
};

export type VoucherRedemptionRateAnalyticsPoint = {
  __typename?: 'VoucherRedemptionRateAnalyticsPoint';
  date: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
};

export enum VoucherStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
  Upcoming = 'UPCOMING'
}

export type VoucherStore = {
  __typename?: 'VoucherStore';
  channelColor?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['Int']['output']>;
  channelImage?: Maybe<Scalars['String']['output']>;
  channelInitials?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['Int']['output']>;
  storeName?: Maybe<Scalars['String']['output']>;
};

export enum VoucherType {
  Product = 'PRODUCT',
  PromoCode = 'PROMO_CODE',
  Shipping = 'SHIPPING',
  UniqueCode = 'UNIQUE_CODE'
}

export type VoucherUsageAnalyticsPoint = {
  __typename?: 'VoucherUsageAnalyticsPoint';
  date: Scalars['String']['output'];
  usage: Scalars['Int']['output'];
};

export type Warehouse = {
  __typename?: 'Warehouse';
  address?: Maybe<WarehouseAddress>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  default?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['Int']['output'];
  isDeletable?: Maybe<Scalars['Boolean']['output']>;
  isDisable?: Maybe<Scalars['Boolean']['output']>;
  isPos?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  newId?: Maybe<Scalars['String']['output']>;
  profileID?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type WarehouseAddress = {
  __typename?: 'WarehouseAddress';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  lon?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  subDistrict?: Maybe<SubDistrict>;
  subDistrictID?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Time']['output'];
  warehouseID: Scalars['Int']['output'];
};

export type WarehouseInventory = {
  __typename?: 'WarehouseInventory';
  availableToSell: Scalars['Int']['output'];
  handover: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inTransit: Scalars['Int']['output'];
  inbounded: Scalars['Int']['output'];
  isPromotion: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  onHandDamage: Scalars['Int']['output'];
  onHandNormal: Scalars['Int']['output'];
  onHandTotal: Scalars['Int']['output'];
  orders: Array<WarehouseInventoryReservedOrder>;
  packed: Scalars['Int']['output'];
  picked: Scalars['Int']['output'];
  promotions: Array<WarehouseInventoryPromotion>;
  reservedOrders: Scalars['Int']['output'];
  reservedPromotion: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  waitingInbound: Scalars['Int']['output'];
  waitingOutbound: Scalars['Int']['output'];
  warehouseId: Scalars['Int']['output'];
};

export type WarehouseInventoryPromotion = {
  __typename?: 'WarehouseInventoryPromotion';
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  store?: Maybe<PromotionStore>;
};

export type WarehouseInventoryReservedOrder = {
  __typename?: 'WarehouseInventoryReservedOrder';
  id: Scalars['ID']['output'];
  itemlineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type WarehouseList = {
  __typename?: 'WarehouseList';
  address?: Maybe<WarehouseAddress>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  default?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type WarehouseMappingInput = {
  channelWarehouseId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type WarehouseMappingRuby = {
  __typename?: 'WarehouseMappingRuby';
  channelWarehouseId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  profileChannelAssociationId?: Maybe<Scalars['Int']['output']>;
  warehouse?: Maybe<WarehouseRuby>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
};

export type WarehouseRuby = {
  __typename?: 'WarehouseRuby';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
};

export type WarehouseSpace = {
  __typename?: 'WarehouseSpace';
  binLocations?: Maybe<Array<Maybe<WarehouseSpaceBinLocation>>>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemVariant?: Maybe<ItemVariant>;
  itemVariantId?: Maybe<Scalars['Int']['output']>;
  lockVersion?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['Int']['output'];
};

export type WarehouseSpaceBinLocation = {
  __typename?: 'WarehouseSpaceBinLocation';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouseSpaceID: Scalars['Int']['output'];
};

export type WarehouseV2 = {
  __typename?: 'WarehouseV2';
  address?: Maybe<WarehouseAddress>;
  code?: Maybe<Scalars['String']['output']>;
  consignment?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Time']['output'];
  default?: Maybe<Scalars['Boolean']['output']>;
  fulfillmentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDisable?: Maybe<Scalars['Boolean']['output']>;
  isPos?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  oldId: Scalars['Int']['output'];
  profileId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type WhatsappCampaignActivity = {
  __typename?: 'WhatsappCampaignActivity';
  campaignName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sentDate?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export type WhatsappTemplateActivity = {
  __typename?: 'WhatsappTemplateActivity';
  campaignDelivered?: Maybe<Scalars['Int']['output']>;
  campaignID: Scalars['Int']['output'];
  campaignName?: Maybe<Scalars['String']['output']>;
  campaignNotDelivered?: Maybe<Scalars['Int']['output']>;
  campaignUndelivered?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  recipients?: Maybe<Scalars['Int']['output']>;
  sentDate?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Int']['output']>;
  successCount?: Maybe<Scalars['Int']['output']>;
};

export type ArchivedProductsInput = {
  productIds: Array<Scalars['Int']['input']>;
};

export type ChatAuthorizeInput = {
  data: Scalars['Any']['input'];
};

export type ChatLabelAssignInput = {
  labelId: Array<Scalars['Int']['input']>;
  roomId: Scalars['String']['input'];
};

export type ChatSendMessageInput = {
  audioUrl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cartId?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  replyMessageId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['String']['input'];
  senderName?: InputMaybe<Scalars['String']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
  videoUrl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ChatSyncInput = {
  roomId: Scalars['String']['input'];
};

export type ContentListingSortBy = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteArchivedProductInput = {
  productId: Scalars['Int']['input'];
};

export type DeleteListingsInput = {
  listingIds: Array<Scalars['String']['input']>;
};

export type DeleteProductsInput = {
  productIds: Array<Scalars['Int']['input']>;
};

export type InputContentListings = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  listingId?: InputMaybe<Scalars['Int']['input']>;
};

export type PayoutChannelInputs = {
  channelId: Scalars['Int']['input'];
  invoiceId: Scalars['Int']['input'];
};

export type RoomAssignBulkInput = {
  adminUserId: Scalars['Int']['input'];
  roomIds: Array<Scalars['String']['input']>;
};

export type RoomAssignInput = {
  adminUserId: Scalars['Int']['input'];
  roomId: Scalars['String']['input'];
};

export type RoomResolveInput = {
  idempotencyKey?: InputMaybe<Scalars['ID']['input']>;
  roomId: Array<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type TemplatePreviewButton = {
  __typename?: 'templatePreviewButton';
  flowAction?: Maybe<Scalars['String']['output']>;
  navigateScreen?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TemplatePreviewExample = {
  __typename?: 'templatePreviewExample';
  headerHandle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UnarchivedProductsInput = {
  productId: Scalars['Int']['input'];
};

export type UpdateStatusReturnInput = {
  createInbound?: InputMaybe<Scalars['Boolean']['input']>;
  returnID?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type AccountListFragment = { __typename?: 'AccountRuby', id: string, name: string, isSyncAvailable: boolean, isSyncing: boolean, isSyncFileNeeded: boolean, isSyncItem: boolean, isStore: boolean, lastSyncedAt: string, isMergeTikTok: boolean, imageUrl?: string | null, isAvailableApi?: boolean | null, hasCategory: boolean, channel: { __typename?: 'ChannelRuby', id: string, name: string, isPos: boolean, initials: string, color?: string | null, icon?: string | null } };

export type AccountsQueryVariables = Exact<{
  onlySalesOrder?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPayoutMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccountsQuery = { __typename?: 'Query', accounts?: Array<{ __typename?: 'AccountRuby', id: string, name: string, isSyncAvailable: boolean, isSyncing: boolean, isSyncFileNeeded: boolean, isSyncItem: boolean, isStore: boolean, lastSyncedAt: string, isMergeTikTok: boolean, imageUrl?: string | null, isAvailableApi?: boolean | null, hasCategory: boolean, channel: { __typename?: 'ChannelRuby', id: string, name: string, isPos: boolean, initials: string, color?: string | null, icon?: string | null } }> | null };

export type UserListQueryVariables = Exact<{ [key: string]: never; }>;


export type UserListQuery = { __typename?: 'Query', dashboardUsers: Array<{ __typename?: 'DashboardUser', id: string, name: string, email: string, isActive?: boolean | null, role?: { __typename?: 'Role', id: string, name: string } | null }> };

export type WarehouseListQueryVariables = Exact<{ [key: string]: never; }>;


export type WarehouseListQuery = { __typename?: 'Query', warehouses?: Array<{ __typename?: 'Warehouse', id: number, isDeletable?: boolean | null, code?: string | null, default?: boolean | null, status?: boolean | null, name: string, profileID?: number | null, updatedAt: any, isPos?: boolean | null, address?: { __typename?: 'WarehouseAddress', id: string, address?: string | null, postalCode?: string | null, subDistrictID?: number | null, subDistrict?: { __typename?: 'SubDistrict', id: string, name?: string | null, districtId?: number | null, district?: { __typename?: 'District', id: string, name: string, cityId?: number | null, city?: { __typename?: 'City', id: string, name?: string | null, provinceId?: number | null, province?: { __typename?: 'Province', id: string, name?: string | null, countryId?: number | null, country?: { __typename?: 'Country', id: string, name?: string | null } | null } | null } | null } | null } | null } | null } | null> | null };

export type ActionAvailabilityFragment = { __typename?: 'ActionAvailability', name?: string | null, isDisable?: boolean | null, group?: { __typename?: 'ActionAvailibilityGroup', name?: string | null } | null };

export type OrderinfoFragment = { __typename?: 'Order', id: string, customerName: string, totalPrice: number, grandTotal?: number | null, localName: string, localId: string, orderedAt?: any | null, printed: number, accountName: string, note?: string | null, dropship: boolean, advancePackage?: boolean | null, cancelReasons?: Array<{ __typename?: 'CancelReason', value?: string | null, name?: string | null } | null> | null, dropshipper?: { __typename?: 'OrderDropshipper', name?: string | null } | null };

export type ChannelinfoFragment = { __typename?: 'Order', channelId: number, channelGroupId?: number | null, channelName: string, channelInitials: string, channelColor: string, channelImage: string };

export type PicklistNodeFragment = { __typename?: 'Picklist', id: number, refId?: string | null, pickerId?: number | null, createdAt?: any | null, updatedAt?: any | null, status?: { __typename?: 'PicklistStatus', id: number, name?: string | null } | null, picker?: { __typename?: 'DashboardUser', id: string, email: string, name: string } | null, warehouse?: { __typename?: 'Warehouse', id: number, name: string } | null, actionAvailabilities?: Array<{ __typename?: 'ActionAvailability', name?: string | null, isDisable?: boolean | null, group?: { __typename?: 'ActionAvailibilityGroup', name?: string | null } | null } | null> | null, orderPicklist?: Array<{ __typename?: 'OrderPicklist', id: number, orderId?: number | null, order?: { __typename?: 'Order', id: string, customerName: string, totalPrice: number, grandTotal?: number | null, localName: string, localId: string, orderedAt?: any | null, printed: number, accountName: string, note?: string | null, dropship: boolean, advancePackage?: boolean | null, channelId: number, channelGroupId?: number | null, channelName: string, channelInitials: string, channelColor: string, channelImage: string, invoices?: Array<{ __typename?: 'Invoice', id: number } | null> | null, itemLines?: Array<{ __typename?: 'OrderItemLine', id?: string | null, status?: Array<{ __typename?: 'Status', name?: string | null } | null> | null, fulfillmentItemLine?: { __typename?: 'OrderItemLineFulfillment', id?: string | null, fulfillment?: { __typename?: 'OrderFulfillment', id: number, trackingNumber?: string | null, bookingCode?: string | null, trackingCompany?: string | null } | null } | null }> | null, cancelReasons?: Array<{ __typename?: 'CancelReason', value?: string | null, name?: string | null } | null> | null, dropshipper?: { __typename?: 'OrderDropshipper', name?: string | null } | null } | null } | null> | null, picklistItemLines?: Array<{ __typename?: 'PicklistItemLine', id: number, name?: string | null, sku?: string | null, orderId?: number | null, itemImageUrl?: string | null, qtyOrdered?: number | null, qtyPicked?: number | null, qtyToPick?: number | null, picklistItemLineBundles?: Array<{ __typename?: 'PicklistItemLineBundle', id: number, name?: string | null, sku?: string | null, orderId?: number | null, qtyOrdered?: number | null, qtyPicked?: number | null, qtyToPick?: number | null, itemImageUrl?: string | null } | null> | null } | null> | null };

export type PicklistListQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<PicklistFilterByInputs>;
  sortBy?: InputMaybe<LinkPicklistByInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type PicklistListQuery = { __typename?: 'Query', picklists?: { __typename?: 'PicklistConnection', totalCount: number, totalPageCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, pageCursors?: Array<{ __typename?: 'PageCursor', page: number, startCursor: string, endCursor: string }> | null, nodes?: Array<{ __typename?: 'Picklist', id: number, refId?: string | null, pickerId?: number | null, createdAt?: any | null, updatedAt?: any | null, status?: { __typename?: 'PicklistStatus', id: number, name?: string | null } | null, picker?: { __typename?: 'DashboardUser', id: string, email: string, name: string } | null, warehouse?: { __typename?: 'Warehouse', id: number, name: string } | null, actionAvailabilities?: Array<{ __typename?: 'ActionAvailability', name?: string | null, isDisable?: boolean | null, group?: { __typename?: 'ActionAvailibilityGroup', name?: string | null } | null } | null> | null, orderPicklist?: Array<{ __typename?: 'OrderPicklist', id: number, orderId?: number | null, order?: { __typename?: 'Order', id: string, customerName: string, totalPrice: number, grandTotal?: number | null, localName: string, localId: string, orderedAt?: any | null, printed: number, accountName: string, note?: string | null, dropship: boolean, advancePackage?: boolean | null, channelId: number, channelGroupId?: number | null, channelName: string, channelInitials: string, channelColor: string, channelImage: string, invoices?: Array<{ __typename?: 'Invoice', id: number } | null> | null, itemLines?: Array<{ __typename?: 'OrderItemLine', id?: string | null, status?: Array<{ __typename?: 'Status', name?: string | null } | null> | null, fulfillmentItemLine?: { __typename?: 'OrderItemLineFulfillment', id?: string | null, fulfillment?: { __typename?: 'OrderFulfillment', id: number, trackingNumber?: string | null, bookingCode?: string | null, trackingCompany?: string | null } | null } | null }> | null, cancelReasons?: Array<{ __typename?: 'CancelReason', value?: string | null, name?: string | null } | null> | null, dropshipper?: { __typename?: 'OrderDropshipper', name?: string | null } | null } | null } | null> | null, picklistItemLines?: Array<{ __typename?: 'PicklistItemLine', id: number, name?: string | null, sku?: string | null, orderId?: number | null, itemImageUrl?: string | null, qtyOrdered?: number | null, qtyPicked?: number | null, qtyToPick?: number | null, picklistItemLineBundles?: Array<{ __typename?: 'PicklistItemLineBundle', id: number, name?: string | null, sku?: string | null, orderId?: number | null, qtyOrdered?: number | null, qtyPicked?: number | null, qtyToPick?: number | null, itemImageUrl?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type PicklistPopupQueryVariables = Exact<{
  whId: Scalars['Int']['input'];
  orderId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type PicklistPopupQuery = { __typename?: 'Query', popUpPicklist?: { __typename?: 'PickPop', refId: string, orders?: Array<{ __typename?: 'Order', id: string, customerName: string, picked: number, itemLines?: Array<{ __typename?: 'OrderItemLine', id?: string | null, consignment?: boolean | null, name?: string | null, variantName?: string | null, sku?: string | null, quantity?: number | null, warehouseId?: number | null, warehouseName?: string | null, itemImageUrl?: string | null, barcode?: string | null, bins?: Array<{ __typename?: 'Bin', id?: string | null, binName?: string | null, quantity?: number | null } | null> | null, orderItemLineBundles?: Array<{ __typename?: 'OrderItemLineBundle', id?: string | null, name?: string | null, sku?: string | null, totalQuantity?: number | null, warehouseId?: number | null, warehouseName?: string | null, imageUrl?: string | null, barcode?: string | null, bins?: Array<{ __typename?: 'Bin', id?: string | null, binName?: string | null, quantity?: number | null } | null> | null } | null> | null }> | null } | null> | null } | null };

export type PicklistCreateMutationVariables = Exact<{
  input: CreatePicklistInput;
}>;


export type PicklistCreateMutation = { __typename?: 'Mutation', createPicklist?: { __typename?: 'CreatePicklistPayload', message: string, picklist?: { __typename?: 'Picklist', id: number } | null } | null };

export type PicklistDeleteMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PicklistDeleteMutation = { __typename?: 'Mutation', deletePicklist?: { __typename?: 'DeletePicklistPayload', success: boolean, successPicklists?: Array<number> | null, failedPicklists?: Array<number> | null } | null };

export type InboundNodeFragment = { __typename?: 'StockInbound', id: number, status: string, quantity: number, actualQuantity: number, putawayStatus: string, quantityPutaway: number, actualQuantityPutaway: number, warehouse: string, reference: string, createdBy: string, receiveBy: string, updatedAt: string, createdAt: string, actionAvailabilities: Array<{ __typename?: 'StockInboundActionAvailability', name: string, group: { __typename?: 'StockInboundActionAvailabilityGroup', action: string, name: string } }> };

export type InboundDetailFragment = { __typename?: 'StockInbound', inboundAt: string, totalSku: number, totalInboundedQty: number, id: number, status: string, quantity: number, actualQuantity: number, putawayStatus: string, quantityPutaway: number, actualQuantityPutaway: number, warehouse: string, reference: string, createdBy: string, receiveBy: string, updatedAt: string, createdAt: string, itemLines: Array<{ __typename?: 'StockInboundItemLine', id: number, image: string, name: string, inboundDate: string, sku: string, inboundStatus: string, putawayStatus: string, quantityInbound: number, actualQuantityInbound: number, options: Array<{ __typename?: 'StockInboundItemLineOption', type: string, option: string }> }>, goodReceives: Array<{ __typename?: 'GoodReceive', id: number, goodReceiveId: string, totalActualInboundQty: number, createdAt: string, putaway: { __typename?: 'StockInboundPutaway', status: string } }>, actionAvailabilities: Array<{ __typename?: 'StockInboundActionAvailability', name: string, group: { __typename?: 'StockInboundActionAvailabilityGroup', action: string, name: string } }> };

export type InboundListQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<StockInboundFilter>;
  sortBy?: InputMaybe<StockInboundSort>;
}>;


export type InboundListQuery = { __typename?: 'Query', stockInbounds?: { __typename?: 'StockInboundConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes: Array<{ __typename?: 'StockInbound', id: number, status: string, quantity: number, actualQuantity: number, putawayStatus: string, quantityPutaway: number, actualQuantityPutaway: number, warehouse: string, reference: string, createdBy: string, receiveBy: string, updatedAt: string, createdAt: string, actionAvailabilities: Array<{ __typename?: 'StockInboundActionAvailability', name: string, group: { __typename?: 'StockInboundActionAvailabilityGroup', action: string, name: string } }> }> } | null };

export type InboundPageQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<StockInboundFilter>;
  sortBy?: InputMaybe<StockInboundSort>;
}>;


export type InboundPageQuery = { __typename?: 'Query', stockInbounds?: { __typename?: 'StockInboundConnection', totalCount: number, totalPageCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, pageCursors: Array<{ __typename?: 'PageCursor', page: number, startCursor: string, endCursor: string }> } | null };

export type InboundDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type InboundDetailQuery = { __typename?: 'Query', stockInbound?: { __typename?: 'StockInbound', inboundAt: string, totalSku: number, totalInboundedQty: number, id: number, status: string, quantity: number, actualQuantity: number, putawayStatus: string, quantityPutaway: number, actualQuantityPutaway: number, warehouse: string, reference: string, createdBy: string, receiveBy: string, updatedAt: string, createdAt: string, itemLines: Array<{ __typename?: 'StockInboundItemLine', id: number, image: string, name: string, inboundDate: string, sku: string, inboundStatus: string, putawayStatus: string, quantityInbound: number, actualQuantityInbound: number, options: Array<{ __typename?: 'StockInboundItemLineOption', type: string, option: string }> }>, goodReceives: Array<{ __typename?: 'GoodReceive', id: number, goodReceiveId: string, totalActualInboundQty: number, createdAt: string, putaway: { __typename?: 'StockInboundPutaway', status: string } }>, actionAvailabilities: Array<{ __typename?: 'StockInboundActionAvailability', name: string, group: { __typename?: 'StockInboundActionAvailabilityGroup', action: string, name: string } }> } | null };

export type ActionConfirmReceivedMutationVariables = Exact<{
  input: ConfirmReceiveInput;
}>;


export type ActionConfirmReceivedMutation = { __typename?: 'Mutation', actionConfirmReceived?: { __typename?: 'ConfirmReceive', message: string } | null };

export type PicklistItemLinesBundleSnFragment = { __typename?: 'PicklistItemLineBundle', id: number, barcode?: string | null, name?: string | null, sku?: string | null, orderId?: number | null, qtyOrdered?: number | null, qtyPicked?: number | null, qtyToPick?: number | null, itemImageUrl?: string | null, totalQuantity?: number | null, serialNumber?: Array<string | null> | null, itemNote?: Array<string | null> | null, orderItemLineBundle?: { __typename?: 'OrderItemLineBundle', id?: string | null, bins?: Array<{ __typename?: 'Bin', id?: string | null, binName?: string | null, quantity?: number | null, quantityToPick?: number | null, quantityPicked?: number | null } | null> | null } | null };

export type PicklistItemLinesSnFragment = { __typename?: 'PicklistItemLine', id: number, name?: string | null, sku?: string | null, orderId?: number | null, itemImageUrl?: string | null, barcode?: string | null, qtyOrdered?: number | null, qtyPicked?: number | null, qtyToPick?: number | null, serialNumber?: Array<string | null> | null, itemNote?: Array<string | null> | null, orderItemLine?: { __typename?: 'OrderItemLine', id?: string | null, variantName?: string | null, order?: { __typename?: 'Order', printed: number, id: string, customerName: string, totalPrice: number, grandTotal?: number | null, localName: string, localId: string, orderedAt?: any | null, accountName: string, note?: string | null, dropship: boolean, advancePackage?: boolean | null, channelId: number, channelGroupId?: number | null, channelName: string, channelInitials: string, channelColor: string, channelImage: string, fulfillments?: Array<{ __typename?: 'OrderFulfillment', id: number, trackingNumber?: string | null, bookingCode?: string | null, trackingCompany?: string | null } | null> | null, cancelReasons?: Array<{ __typename?: 'CancelReason', value?: string | null, name?: string | null } | null> | null, dropshipper?: { __typename?: 'OrderDropshipper', name?: string | null } | null } | null, status?: Array<{ __typename?: 'Status', name?: string | null } | null> | null, bins?: Array<{ __typename?: 'Bin', id?: string | null, binName?: string | null, quantity?: number | null, quantityToPick?: number | null, quantityPicked?: number | null } | null> | null } | null, picklistItemLineBundles?: Array<{ __typename?: 'PicklistItemLineBundle', id: number, barcode?: string | null, name?: string | null, sku?: string | null, orderId?: number | null, qtyOrdered?: number | null, qtyPicked?: number | null, qtyToPick?: number | null, itemImageUrl?: string | null, totalQuantity?: number | null, serialNumber?: Array<string | null> | null, itemNote?: Array<string | null> | null, orderItemLineBundle?: { __typename?: 'OrderItemLineBundle', id?: string | null, bins?: Array<{ __typename?: 'Bin', id?: string | null, binName?: string | null, quantity?: number | null, quantityToPick?: number | null, quantityPicked?: number | null } | null> | null } | null } | null> | null };

export type PicklistDetailSnFragment = { __typename?: 'Picklist', id: number, refId?: string | null, createdAt?: any | null, updatedAt?: any | null, status?: { __typename?: 'PicklistStatus', id: number, name?: string | null } | null, warehouse?: { __typename?: 'Warehouse', id: number, name: string } | null, picker?: { __typename?: 'DashboardUser', id: string, name: string } | null, actionAvailabilities?: Array<{ __typename?: 'ActionAvailability', name?: string | null, isDisable?: boolean | null, group?: { __typename?: 'ActionAvailibilityGroup', name?: string | null } | null } | null> | null, orderPicklist?: Array<{ __typename?: 'OrderPicklist', id: number, orderId?: number | null, order?: { __typename?: 'Order', id: string, customerName: string, totalPrice: number, grandTotal?: number | null, localName: string, localId: string, orderedAt?: any | null, printed: number, accountName: string, note?: string | null, dropship: boolean, advancePackage?: boolean | null, channelId: number, channelGroupId?: number | null, channelName: string, channelInitials: string, channelColor: string, channelImage: string, invoices?: Array<{ __typename?: 'Invoice', id: number } | null> | null, itemLines?: Array<{ __typename?: 'OrderItemLine', id?: string | null, status?: Array<{ __typename?: 'Status', name?: string | null } | null> | null, fulfillmentItemLine?: { __typename?: 'OrderItemLineFulfillment', id?: string | null, fulfillment?: { __typename?: 'OrderFulfillment', id: number, trackingNumber?: string | null, bookingCode?: string | null, trackingCompany?: string | null } | null } | null }> | null, cancelReasons?: Array<{ __typename?: 'CancelReason', value?: string | null, name?: string | null } | null> | null, dropshipper?: { __typename?: 'OrderDropshipper', name?: string | null } | null } | null } | null> | null, picklistItemLines?: Array<{ __typename?: 'PicklistItemLine', id: number, name?: string | null, sku?: string | null, orderId?: number | null, itemImageUrl?: string | null, barcode?: string | null, qtyOrdered?: number | null, qtyPicked?: number | null, qtyToPick?: number | null, serialNumber?: Array<string | null> | null, itemNote?: Array<string | null> | null, orderItemLine?: { __typename?: 'OrderItemLine', id?: string | null, variantName?: string | null, order?: { __typename?: 'Order', printed: number, id: string, customerName: string, totalPrice: number, grandTotal?: number | null, localName: string, localId: string, orderedAt?: any | null, accountName: string, note?: string | null, dropship: boolean, advancePackage?: boolean | null, channelId: number, channelGroupId?: number | null, channelName: string, channelInitials: string, channelColor: string, channelImage: string, fulfillments?: Array<{ __typename?: 'OrderFulfillment', id: number, trackingNumber?: string | null, bookingCode?: string | null, trackingCompany?: string | null } | null> | null, cancelReasons?: Array<{ __typename?: 'CancelReason', value?: string | null, name?: string | null } | null> | null, dropshipper?: { __typename?: 'OrderDropshipper', name?: string | null } | null } | null, status?: Array<{ __typename?: 'Status', name?: string | null } | null> | null, bins?: Array<{ __typename?: 'Bin', id?: string | null, binName?: string | null, quantity?: number | null, quantityToPick?: number | null, quantityPicked?: number | null } | null> | null } | null, picklistItemLineBundles?: Array<{ __typename?: 'PicklistItemLineBundle', id: number, barcode?: string | null, name?: string | null, sku?: string | null, orderId?: number | null, qtyOrdered?: number | null, qtyPicked?: number | null, qtyToPick?: number | null, itemImageUrl?: string | null, totalQuantity?: number | null, serialNumber?: Array<string | null> | null, itemNote?: Array<string | null> | null, orderItemLineBundle?: { __typename?: 'OrderItemLineBundle', id?: string | null, bins?: Array<{ __typename?: 'Bin', id?: string | null, binName?: string | null, quantity?: number | null, quantityToPick?: number | null, quantityPicked?: number | null } | null> | null } | null } | null> | null } | null> | null };

export type PicklistDetailSnQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PicklistDetailSnQuery = { __typename?: 'Query', picklistSN?: { __typename?: 'Picklist', id: number, refId?: string | null, createdAt?: any | null, updatedAt?: any | null, status?: { __typename?: 'PicklistStatus', id: number, name?: string | null } | null, warehouse?: { __typename?: 'Warehouse', id: number, name: string } | null, picker?: { __typename?: 'DashboardUser', id: string, name: string } | null, actionAvailabilities?: Array<{ __typename?: 'ActionAvailability', name?: string | null, isDisable?: boolean | null, group?: { __typename?: 'ActionAvailibilityGroup', name?: string | null } | null } | null> | null, orderPicklist?: Array<{ __typename?: 'OrderPicklist', id: number, orderId?: number | null, order?: { __typename?: 'Order', id: string, customerName: string, totalPrice: number, grandTotal?: number | null, localName: string, localId: string, orderedAt?: any | null, printed: number, accountName: string, note?: string | null, dropship: boolean, advancePackage?: boolean | null, channelId: number, channelGroupId?: number | null, channelName: string, channelInitials: string, channelColor: string, channelImage: string, invoices?: Array<{ __typename?: 'Invoice', id: number } | null> | null, itemLines?: Array<{ __typename?: 'OrderItemLine', id?: string | null, status?: Array<{ __typename?: 'Status', name?: string | null } | null> | null, fulfillmentItemLine?: { __typename?: 'OrderItemLineFulfillment', id?: string | null, fulfillment?: { __typename?: 'OrderFulfillment', id: number, trackingNumber?: string | null, bookingCode?: string | null, trackingCompany?: string | null } | null } | null }> | null, cancelReasons?: Array<{ __typename?: 'CancelReason', value?: string | null, name?: string | null } | null> | null, dropshipper?: { __typename?: 'OrderDropshipper', name?: string | null } | null } | null } | null> | null, picklistItemLines?: Array<{ __typename?: 'PicklistItemLine', id: number, name?: string | null, sku?: string | null, orderId?: number | null, itemImageUrl?: string | null, barcode?: string | null, qtyOrdered?: number | null, qtyPicked?: number | null, qtyToPick?: number | null, serialNumber?: Array<string | null> | null, itemNote?: Array<string | null> | null, orderItemLine?: { __typename?: 'OrderItemLine', id?: string | null, variantName?: string | null, order?: { __typename?: 'Order', printed: number, id: string, customerName: string, totalPrice: number, grandTotal?: number | null, localName: string, localId: string, orderedAt?: any | null, accountName: string, note?: string | null, dropship: boolean, advancePackage?: boolean | null, channelId: number, channelGroupId?: number | null, channelName: string, channelInitials: string, channelColor: string, channelImage: string, fulfillments?: Array<{ __typename?: 'OrderFulfillment', id: number, trackingNumber?: string | null, bookingCode?: string | null, trackingCompany?: string | null } | null> | null, cancelReasons?: Array<{ __typename?: 'CancelReason', value?: string | null, name?: string | null } | null> | null, dropshipper?: { __typename?: 'OrderDropshipper', name?: string | null } | null } | null, status?: Array<{ __typename?: 'Status', name?: string | null } | null> | null, bins?: Array<{ __typename?: 'Bin', id?: string | null, binName?: string | null, quantity?: number | null, quantityToPick?: number | null, quantityPicked?: number | null } | null> | null } | null, picklistItemLineBundles?: Array<{ __typename?: 'PicklistItemLineBundle', id: number, barcode?: string | null, name?: string | null, sku?: string | null, orderId?: number | null, qtyOrdered?: number | null, qtyPicked?: number | null, qtyToPick?: number | null, itemImageUrl?: string | null, totalQuantity?: number | null, serialNumber?: Array<string | null> | null, itemNote?: Array<string | null> | null, orderItemLineBundle?: { __typename?: 'OrderItemLineBundle', id?: string | null, bins?: Array<{ __typename?: 'Bin', id?: string | null, binName?: string | null, quantity?: number | null, quantityToPick?: number | null, quantityPicked?: number | null } | null> | null } | null } | null> | null } | null> | null } | null };

export type PicklistUpdateSnMutationVariables = Exact<{
  input: UpdatePicklistInput;
}>;


export type PicklistUpdateSnMutation = { __typename?: 'Mutation', updatePicklistSN?: { __typename?: 'UpdatePicklistPayload', message: string, picklist?: { __typename?: 'Picklist', id: number } | null } | null };

export const AccountListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"accountList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountRuby"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSyncAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"isSyncing"}},{"kind":"Field","name":{"kind":"Name","value":"isSyncFileNeeded"}},{"kind":"Field","name":{"kind":"Name","value":"isSyncItem"}},{"kind":"Field","name":{"kind":"Name","value":"isStore"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMergeTikTok"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableApi"}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPos"}},{"kind":"Field","name":{"kind":"Name","value":"initials"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasCategory"}}]}}]} as unknown as DocumentNode<AccountListFragment, unknown>;
export const ActionAvailabilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"actionAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ActionAvailability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDisable"}}]}}]} as unknown as DocumentNode<ActionAvailabilityFragment, unknown>;
export const OrderinfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"orderinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"grandTotal"}},{"kind":"Field","name":{"kind":"Name","value":"localName"}},{"kind":"Field","name":{"kind":"Name","value":"localId"}},{"kind":"Field","name":{"kind":"Name","value":"orderedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"printed"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"dropship"}},{"kind":"Field","name":{"kind":"Name","value":"dropshipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advancePackage"}}]}}]} as unknown as DocumentNode<OrderinfoFragment, unknown>;
export const ChannelinfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"channelinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"channelName"}},{"kind":"Field","name":{"kind":"Name","value":"channelInitials"}},{"kind":"Field","name":{"kind":"Name","value":"channelColor"}},{"kind":"Field","name":{"kind":"Name","value":"channelImage"}}]}}]} as unknown as DocumentNode<ChannelinfoFragment, unknown>;
export const PicklistNodeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"picklistNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picklist"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"refId"}},{"kind":"Field","name":{"kind":"Name","value":"pickerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionAvailabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"actionAvailability"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderPicklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"orderinfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"channelinfo"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillmentItemLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fulfillment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bookingCode"}},{"kind":"Field","name":{"kind":"Name","value":"trackingCompany"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"picklistItemLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyToPick"}},{"kind":"Field","name":{"kind":"Name","value":"picklistItemLineBundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyToPick"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"actionAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ActionAvailability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDisable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"orderinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"grandTotal"}},{"kind":"Field","name":{"kind":"Name","value":"localName"}},{"kind":"Field","name":{"kind":"Name","value":"localId"}},{"kind":"Field","name":{"kind":"Name","value":"orderedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"printed"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"dropship"}},{"kind":"Field","name":{"kind":"Name","value":"dropshipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advancePackage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"channelinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"channelName"}},{"kind":"Field","name":{"kind":"Name","value":"channelInitials"}},{"kind":"Field","name":{"kind":"Name","value":"channelColor"}},{"kind":"Field","name":{"kind":"Name","value":"channelImage"}}]}}]} as unknown as DocumentNode<PicklistNodeFragment, unknown>;
export const InboundNodeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"inboundNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StockInbound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"actualQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"putawayStatus"}},{"kind":"Field","name":{"kind":"Name","value":"quantityPutaway"}},{"kind":"Field","name":{"kind":"Name","value":"actualQuantityPutaway"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"receiveBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionAvailabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<InboundNodeFragment, unknown>;
export const InboundDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"inboundDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StockInbound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"inboundNode"}},{"kind":"Field","name":{"kind":"Name","value":"inboundAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalSku"}},{"kind":"Field","name":{"kind":"Name","value":"totalInboundedQty"}},{"kind":"Field","name":{"kind":"Name","value":"itemLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"option"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inboundDate"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"inboundStatus"}},{"kind":"Field","name":{"kind":"Name","value":"putawayStatus"}},{"kind":"Field","name":{"kind":"Name","value":"quantityInbound"}},{"kind":"Field","name":{"kind":"Name","value":"actualQuantityInbound"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodReceives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goodReceiveId"}},{"kind":"Field","name":{"kind":"Name","value":"putaway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalActualInboundQty"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"inboundNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StockInbound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"actualQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"putawayStatus"}},{"kind":"Field","name":{"kind":"Name","value":"quantityPutaway"}},{"kind":"Field","name":{"kind":"Name","value":"actualQuantityPutaway"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"receiveBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionAvailabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<InboundDetailFragment, unknown>;
export const PicklistItemLinesBundleSnFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"picklistItemLinesBundleSN"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PicklistItemLineBundle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyToPick"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"totalQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"itemNote"}},{"kind":"Field","name":{"kind":"Name","value":"orderItemLineBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"binName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityToPick"}},{"kind":"Field","name":{"kind":"Name","value":"quantityPicked"}}]}}]}}]}}]} as unknown as DocumentNode<PicklistItemLinesBundleSnFragment, unknown>;
export const PicklistItemLinesSnFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"picklistItemLinesSN"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PicklistItemLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"orderItemLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"orderinfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"channelinfo"}},{"kind":"Field","name":{"kind":"Name","value":"printed"}},{"kind":"Field","name":{"kind":"Name","value":"fulfillments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bookingCode"}},{"kind":"Field","name":{"kind":"Name","value":"trackingCompany"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"binName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityToPick"}},{"kind":"Field","name":{"kind":"Name","value":"quantityPicked"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyToPick"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"itemNote"}},{"kind":"Field","name":{"kind":"Name","value":"picklistItemLineBundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"picklistItemLinesBundleSN"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"orderinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"grandTotal"}},{"kind":"Field","name":{"kind":"Name","value":"localName"}},{"kind":"Field","name":{"kind":"Name","value":"localId"}},{"kind":"Field","name":{"kind":"Name","value":"orderedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"printed"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"dropship"}},{"kind":"Field","name":{"kind":"Name","value":"dropshipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advancePackage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"channelinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"channelName"}},{"kind":"Field","name":{"kind":"Name","value":"channelInitials"}},{"kind":"Field","name":{"kind":"Name","value":"channelColor"}},{"kind":"Field","name":{"kind":"Name","value":"channelImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"picklistItemLinesBundleSN"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PicklistItemLineBundle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyToPick"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"totalQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"itemNote"}},{"kind":"Field","name":{"kind":"Name","value":"orderItemLineBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"binName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityToPick"}},{"kind":"Field","name":{"kind":"Name","value":"quantityPicked"}}]}}]}}]}}]} as unknown as DocumentNode<PicklistItemLinesSnFragment, unknown>;
export const PicklistDetailSnFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"picklistDetailSN"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picklist"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"refId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionAvailabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"actionAvailability"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderPicklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"orderinfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"channelinfo"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillmentItemLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fulfillment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bookingCode"}},{"kind":"Field","name":{"kind":"Name","value":"trackingCompany"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"picklistItemLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"picklistItemLinesSN"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"orderinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"grandTotal"}},{"kind":"Field","name":{"kind":"Name","value":"localName"}},{"kind":"Field","name":{"kind":"Name","value":"localId"}},{"kind":"Field","name":{"kind":"Name","value":"orderedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"printed"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"dropship"}},{"kind":"Field","name":{"kind":"Name","value":"dropshipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advancePackage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"channelinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"channelName"}},{"kind":"Field","name":{"kind":"Name","value":"channelInitials"}},{"kind":"Field","name":{"kind":"Name","value":"channelColor"}},{"kind":"Field","name":{"kind":"Name","value":"channelImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"picklistItemLinesBundleSN"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PicklistItemLineBundle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyToPick"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"totalQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"itemNote"}},{"kind":"Field","name":{"kind":"Name","value":"orderItemLineBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"binName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityToPick"}},{"kind":"Field","name":{"kind":"Name","value":"quantityPicked"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"actionAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ActionAvailability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDisable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"picklistItemLinesSN"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PicklistItemLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"orderItemLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"orderinfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"channelinfo"}},{"kind":"Field","name":{"kind":"Name","value":"printed"}},{"kind":"Field","name":{"kind":"Name","value":"fulfillments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bookingCode"}},{"kind":"Field","name":{"kind":"Name","value":"trackingCompany"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"binName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityToPick"}},{"kind":"Field","name":{"kind":"Name","value":"quantityPicked"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyToPick"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"itemNote"}},{"kind":"Field","name":{"kind":"Name","value":"picklistItemLineBundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"picklistItemLinesBundleSN"}}]}}]}}]} as unknown as DocumentNode<PicklistDetailSnFragment, unknown>;
export const AccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlySalesOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyPromotion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyPayoutMarketplace"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlySalesOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlySalesOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"onlyPromotion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyPromotion"}}},{"kind":"Argument","name":{"kind":"Name","value":"onlyPayoutMarketplace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyPayoutMarketplace"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"accountList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"accountList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountRuby"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSyncAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"isSyncing"}},{"kind":"Field","name":{"kind":"Name","value":"isSyncFileNeeded"}},{"kind":"Field","name":{"kind":"Name","value":"isSyncItem"}},{"kind":"Field","name":{"kind":"Name","value":"isStore"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isMergeTikTok"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailableApi"}},{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPos"}},{"kind":"Field","name":{"kind":"Name","value":"initials"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasCategory"}}]}}]} as unknown as DocumentNode<AccountsQuery, AccountsQueryVariables>;
export const UserListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<UserListQuery, UserListQueryVariables>;
export const WarehouseListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"warehouseList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"subDistrictID"}},{"kind":"Field","name":{"kind":"Name","value":"subDistrict"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"districtId"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provinceId"}},{"kind":"Field","name":{"kind":"Name","value":"province"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryId"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeletable"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileID"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isPos"}}]}}]}}]} as unknown as DocumentNode<WarehouseListQuery, WarehouseListQueryVariables>;
export const PicklistListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"picklistList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PicklistFilterByInputs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LinkPicklistByInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"picklists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterCursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeCursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPageCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageCursors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"picklistNode"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"actionAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ActionAvailability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDisable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"orderinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"grandTotal"}},{"kind":"Field","name":{"kind":"Name","value":"localName"}},{"kind":"Field","name":{"kind":"Name","value":"localId"}},{"kind":"Field","name":{"kind":"Name","value":"orderedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"printed"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"dropship"}},{"kind":"Field","name":{"kind":"Name","value":"dropshipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advancePackage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"channelinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"channelName"}},{"kind":"Field","name":{"kind":"Name","value":"channelInitials"}},{"kind":"Field","name":{"kind":"Name","value":"channelColor"}},{"kind":"Field","name":{"kind":"Name","value":"channelImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"picklistNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picklist"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"refId"}},{"kind":"Field","name":{"kind":"Name","value":"pickerId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionAvailabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"actionAvailability"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderPicklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"orderinfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"channelinfo"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillmentItemLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fulfillment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bookingCode"}},{"kind":"Field","name":{"kind":"Name","value":"trackingCompany"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"picklistItemLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyToPick"}},{"kind":"Field","name":{"kind":"Name","value":"picklistItemLineBundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyToPick"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}}]}}]}}]}}]} as unknown as DocumentNode<PicklistListQuery, PicklistListQueryVariables>;
export const PicklistPopupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"picklistPopup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"popUpPicklist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refId"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"itemLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"consignment"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"warehouseId"}},{"kind":"Field","name":{"kind":"Name","value":"warehouseName"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"bins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"binName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderItemLineBundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"totalQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"warehouseId"}},{"kind":"Field","name":{"kind":"Name","value":"warehouseName"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"bins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"binName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PicklistPopupQuery, PicklistPopupQueryVariables>;
export const PicklistCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"picklistCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePicklistInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPicklist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"picklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PicklistCreateMutation, PicklistCreateMutationVariables>;
export const PicklistDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"picklistDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePicklist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"successPicklists"}},{"kind":"Field","name":{"kind":"Name","value":"failedPicklists"}}]}}]}}]} as unknown as DocumentNode<PicklistDeleteMutation, PicklistDeleteMutationVariables>;
export const InboundListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"inboundList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StockInboundFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StockInboundSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stockInbounds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterCursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeCursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"inboundNode"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"inboundNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StockInbound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"actualQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"putawayStatus"}},{"kind":"Field","name":{"kind":"Name","value":"quantityPutaway"}},{"kind":"Field","name":{"kind":"Name","value":"actualQuantityPutaway"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"receiveBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionAvailabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<InboundListQuery, InboundListQueryVariables>;
export const InboundPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"inboundPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeCursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StockInboundFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StockInboundSort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stockInbounds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterCursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeCursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPageCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageCursors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<InboundPageQuery, InboundPageQueryVariables>;
export const InboundDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InboundDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stockInbound"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"inboundDetail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"inboundNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StockInbound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"actualQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"putawayStatus"}},{"kind":"Field","name":{"kind":"Name","value":"quantityPutaway"}},{"kind":"Field","name":{"kind":"Name","value":"actualQuantityPutaway"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"receiveBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionAvailabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"inboundDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StockInbound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"inboundNode"}},{"kind":"Field","name":{"kind":"Name","value":"inboundAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalSku"}},{"kind":"Field","name":{"kind":"Name","value":"totalInboundedQty"}},{"kind":"Field","name":{"kind":"Name","value":"itemLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"option"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inboundDate"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"inboundStatus"}},{"kind":"Field","name":{"kind":"Name","value":"putawayStatus"}},{"kind":"Field","name":{"kind":"Name","value":"quantityInbound"}},{"kind":"Field","name":{"kind":"Name","value":"actualQuantityInbound"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodReceives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goodReceiveId"}},{"kind":"Field","name":{"kind":"Name","value":"putaway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalActualInboundQty"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<InboundDetailQuery, InboundDetailQueryVariables>;
export const ActionConfirmReceivedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionConfirmReceived"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmReceiveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionConfirmReceived"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ActionConfirmReceivedMutation, ActionConfirmReceivedMutationVariables>;
export const PicklistDetailSnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"picklistDetailSN"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"picklistSN"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"picklistDetailSN"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"actionAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ActionAvailability"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDisable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"orderinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"grandTotal"}},{"kind":"Field","name":{"kind":"Name","value":"localName"}},{"kind":"Field","name":{"kind":"Name","value":"localId"}},{"kind":"Field","name":{"kind":"Name","value":"orderedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"printed"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"dropship"}},{"kind":"Field","name":{"kind":"Name","value":"dropshipper"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advancePackage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"channelinfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"channelGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"channelName"}},{"kind":"Field","name":{"kind":"Name","value":"channelInitials"}},{"kind":"Field","name":{"kind":"Name","value":"channelColor"}},{"kind":"Field","name":{"kind":"Name","value":"channelImage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"picklistItemLinesBundleSN"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PicklistItemLineBundle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyToPick"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"totalQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"itemNote"}},{"kind":"Field","name":{"kind":"Name","value":"orderItemLineBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"binName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityToPick"}},{"kind":"Field","name":{"kind":"Name","value":"quantityPicked"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"picklistItemLinesSN"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PicklistItemLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"itemImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"barcode"}},{"kind":"Field","name":{"kind":"Name","value":"orderItemLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"orderinfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"channelinfo"}},{"kind":"Field","name":{"kind":"Name","value":"printed"}},{"kind":"Field","name":{"kind":"Name","value":"fulfillments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bookingCode"}},{"kind":"Field","name":{"kind":"Name","value":"trackingCompany"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"binName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityToPick"}},{"kind":"Field","name":{"kind":"Name","value":"quantityPicked"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qtyOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"qtyPicked"}},{"kind":"Field","name":{"kind":"Name","value":"qtyToPick"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"itemNote"}},{"kind":"Field","name":{"kind":"Name","value":"picklistItemLineBundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"picklistItemLinesBundleSN"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"picklistDetailSN"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Picklist"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"refId"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionAvailabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"actionAvailability"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderPicklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"orderinfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"channelinfo"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillmentItemLine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fulfillment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bookingCode"}},{"kind":"Field","name":{"kind":"Name","value":"trackingCompany"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"picklistItemLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"picklistItemLinesSN"}}]}}]}}]} as unknown as DocumentNode<PicklistDetailSnQuery, PicklistDetailSnQueryVariables>;
export const PicklistUpdateSnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"picklistUpdateSN"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePicklistInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePicklistSN"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"picklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PicklistUpdateSnMutation, PicklistUpdateSnMutationVariables>;